module.exports = { cards: [
  {
    "Name": "A Land Divided",
    "Rarity": "Legendary",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "8",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Fill the left lane with Stormcloak Skirmishers or the right lane with Colovian Troopers.",
    "Keywords": "",
    "Played in": "84/12907 of  Eligible  decks (1 %)",
    "code": "aa"
  },
  {
    "Name": "A New Era",
    "Rarity": "Epic",
    "Type": "Item",
    "Attributes": [
      "willpower",
      "agility",
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "11",
    "Expansion Set": "Tamriel Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Shuffle all creatures into your deck.",
    "Keywords": "",
    "Played in": "11/356 of  Eligible  decks (3 %)",
    "code": "Be"
  },
  {
    "Name": "A Night to Remember",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "A friendly creature disappears to who knows where, then returns in the other lane Shackled.",
    "Keywords": "",
    "Played in": "1500/30861 of  Eligible  decks (5 %)",
    "code": "ab"
  },
  {
    "Name": "Abandoned Imperfect",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 4 - The Betrayal",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Ongoing: Treasure Hunt - Three [neutral] cards: Sacrifice Abandoned Imperfect to summon an 8/8 Awakened Imperfect with Breakthrough and Guard to the lane of your choice.",
    "Keywords": "Treasure Hunt",
    "Played in": "139/30861 of  Eligible  decks (0 %)",
    "code": "ac"
  },
  {
    "Name": "Abecean Navigator",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: If the top card of your deck is an action, draw it. Otherwise, put it on the bottom.",
    "Keywords": "",
    "Played in": "228/14266 of  Eligible  decks (2 %)",
    "code": "ad"
  },
  {
    "Name": "Abnur Tharn",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Imperial",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Abnur Tharn uses the summon ability of a creature.",
    "Keywords": "",
    "Played in": "760/14266 of  Eligible  decks (5 %)",
    "code": "uG"
  },
  {
    "Name": "Adoring Fan",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "3",
    "Attack": "0",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Prophecy, Guard. Last Gasp: Adoring Fan will return. Adoring Fan is immune to Silence.",
    "Keywords": "Guard,Last Gasp,Prophecy",
    "Played in": "414/30861 of  Eligible  decks (1 %)",
    "code": "ae"
  },
  {
    "Name": "Aela the Huntress",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "7",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Deal 1 damage. Beast Form: +2/+2 and destroy a Wounded creature.",
    "Keywords": "",
    "Played in": "610/12757 of  Eligible  decks (5 %)",
    "code": "af"
  },
  {
    "Name": "Aela's Huntmate",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Beast Form: +1/+1 and draw a card.",
    "Keywords": "",
    "Played in": "739/12757 of  Eligible  decks (6 %)",
    "code": "ag"
  },
  {
    "Name": "Afflicted Alit",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Reptile",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Deal 2 damage to each player.",
    "Keywords": "",
    "Played in": "1073/12757 of  Eligible  decks (8 %)",
    "code": "ah"
  },
  {
    "Name": "Ageless Automaton",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "When Ageless Automaton attacks a Guard, it gains +3/+0 and Breakthrough until end of turn.",
    "Keywords": "Breakthrough,Guard",
    "Played in": "135/30861 of  Eligible  decks (0 %)",
    "code": "ai"
  },
  {
    "Name": "Agent of Mehrunes Dagon",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Imperial",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "At the end of your turn, if you Invaded, Agent of Mehrunes Dagon gains +1/+1.",
    "Keywords": "Invade",
    "Played in": "44/12757 of  Eligible  decks (0 %)",
    "code": "zB"
  },
  {
    "Name": "Ahnassi",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "willpower",
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Ahnassi steals all keywords from enemy creatures.",
    "Keywords": "",
    "Played in": "1911/3723 of  Eligible  decks (51 %)",
    "code": "aj"
  },
  {
    "Name": "Alchemy",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Give your Activated supports 1 extra use. Empower: +1 use.",
    "Keywords": "Empower",
    "Played in": "46/12916 of  Eligible  decks (0 %)",
    "code": "sv"
  },
  {
    "Name": "Ald Velothi Assassin",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Breton",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Lethal, Rally.",
    "Keywords": "Lethal,Rally",
    "Played in": "1956/13644 of  Eligible  decks (14 %)",
    "code": "ak"
  },
  {
    "Name": "Ald'ruhn Arms Master",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Charge, Rally",
    "Keywords": "Charge,Rally",
    "Played in": "321/12757 of  Eligible  decks (3 %)",
    "code": "al"
  },
  {
    "Name": "Aldmeri Patriot",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "High Elf",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: +1/+1 if you have an action in your hand.",
    "Keywords": "",
    "Played in": "260/12907 of  Eligible  decks (2 %)",
    "code": "am"
  },
  {
    "Name": "Aldmeri Spellwright",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "willpower",
      "agility"
    ],
    "Race": "High Elf",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "6",
    "Expansion Set": "Tamriel Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When your opponent takes damage, you gain 1 magicka this turn.",
    "Keywords": "",
    "Played in": "7/307 of  Eligible  decks (2 %)",
    "code": "Bm"
  },
  {
    "Name": "Aldora the Daring",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 4 - The Inner Curiosity",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Treasure Hunt - Action, Creature, Item, Support: +6/+6. When a friendly treasure hunter finds something, summon Skywag or give Skywag +1/+1.",
    "Keywords": "Treasure Hunt",
    "Played in": "430/12757 of  Eligible  decks (3 %)",
    "code": "an"
  },
  {
    "Name": "Alduin",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dragon",
    "Magicka Cost": "20",
    "Attack": "12",
    "Health": "12",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Costs 2 less for each Dragon in your discard pile. Summon: Destroy all other creatures. At the start of your turn, summon a random Dragon from your discard pile.",
    "Keywords": "",
    "Played in": "1348/30872 of  Eligible  decks (4 %)",
    "code": "ao"
  },
  {
    "Name": "Alfiq Conjurer",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "6",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Guard. Summon: Consume a creature to summon a Flame Atronach. If you consumed an Atronach, instead summon a Storm Atronach.",
    "Keywords": "Guard,Consume",
    "Played in": "475/14266 of  Eligible  decks (3 %)",
    "code": "vD"
  },
  {
    "Name": "Alfiq Illusionist",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Wax: Summon a copy of Alfiq Illusionist in the other lane. Wane: +1/+2 and Guard.",
    "Keywords": "Wax/Wane,Guard",
    "Played in": "103/12907 of  Eligible  decks (1 %)",
    "code": "wR"
  },
  {
    "Name": "Alik'r Survivalist",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Redguard",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Put a Steel Dagger into your hand. When Alik'r Survivalist equips an item, he gains +1/+1.",
    "Keywords": "",
    "Played in": "337/12757 of  Eligible  decks (3 %)",
    "Evolves from:": "Alik'r Bandit",
    "code": "ar"
  },
  {
    "Name": "Allena Benoch",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "agility"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "6",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Lethal. Summon: Deal 1 damage.",
    "Keywords": "Lethal",
    "Played in": "1343/4477 of  Eligible  decks (30 %)",
    "code": "as"
  },
  {
    "Name": "Almalexia's Disciple",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Exalt 2: Heal all friendly creatures.",
    "Keywords": "Exalt",
    "Played in": "177/13644 of  Eligible  decks (1 %)",
    "code": "au"
  },
  {
    "Name": "Almalexia",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "God",
    "Magicka Cost": "7",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Exalt 3: +6/+6. Friendly Exalted creatures are immune to damage.",
    "Keywords": "Exalt",
    "Played in": "253/13644 of  Eligible  decks (2 %)",
    "code": "at"
  },
  {
    "Name": "Alpha Wolf",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Wolf",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Other friendly Wolves have +2/+0.",
    "Keywords": "",
    "Played in": "92/12907 of  Eligible  decks (1 %)",
    "code": "av"
  },
  {
    "Name": "Altar of Despair",
    "Rarity": "Legendary",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Madhouse Collection",
    "Soul Summon": "This card belongs to the Madhouse Collection and cannot be Soul Summoned.",
    "Soul Trap": "This card belongs to the Madhouse Collection and cannot be Soul Trapped.",
    "Text": "Uses: 12. Activate: Sacrifice a creature to summon a creature from your deck that costs 1, then increase the cost of creatures this summons by 1.",
    "Keywords": "",
    "Played in": "1088/30872 of  Eligible  decks (4 %)",
    "code": "aw"
  },
  {
    "Name": "Altar of Spellmaking",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "strength",
      "intelligence",
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Tamriel Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Ongoing. At the end of each turn, if you played a creature, action, item, and support, play the top card of your deck.",
    "Keywords": "",
    "Played in": "7/407 of  Eligible  decks (2 %)",
    "code": "AY"
  },
  {
    "Name": "Altmer Dragonknight",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "willpower"
    ],
    "Race": "High Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the end of your turn, if you played an action, Altmer Dragonknight gains +2/+2.",
    "Keywords": "",
    "Played in": "244/4500 of  Eligible  decks (5 %)",
    "code": "ax"
  },
  {
    "Name": "Altmer Flameslinger",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Ward. At the start of your turn, Altmer Flameslinger deals 1 damage to your opponent.",
    "Keywords": "Ward",
    "Played in": "312/14266 of  Eligible  decks (2 %)",
    "code": "sw"
  },
  {
    "Name": "Ambitious Hireling",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Give another friendly creature power and health equal to Ambitious Hireling's power.",
    "Keywords": "",
    "Played in": "304/12907 of  Eligible  decks (2 %)",
    "code": "ay"
  },
  {
    "Name": "An-Xileel Invader",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Argonian",
    "Magicka Cost": "4",
    "Attack": "5",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "0/13695 of  Eligible  decks (0 %)",
    "code": "az"
  },
  {
    "Name": "Ancano",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "8",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Breakthrough| Summon: Deal 5 damage. Your actions have Breakthrough.",
    "Keywords": "Breakthrough",
    "Played in": "7052/14271 of  Eligible  decks (49 %)",
    "code": "aA"
  },
  {
    "Name": "Ancestor's Battleaxe",
    "Rarity": "Epic",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "+4/+4. Summon: Give the top creature of your deck +4/+4.",
    "Keywords": "",
    "Played in": "291/12757 of  Eligible  decks (2 %)",
    "code": "aB"
  },
  {
    "Name": "Ancestral Dead",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Slay: Summon a Risen Dead.",
    "Keywords": "Slay",
    "Played in": "198/13644 of  Eligible  decks (1 %)",
    "code": "aC"
  },
  {
    "Name": "Ancient Lookout",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "When you summon a Dragon, summon a 1/1 Draugr Sentry with Guard.",
    "Keywords": "",
    "Played in": "495/13644 of  Eligible  decks (4 %)",
    "code": "aD"
  },
  {
    "Name": "Angry Grahl",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Troll",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Regenerate. Summon: +2/+2 if your opponent has more cards in hands.",
    "Keywords": "Regenerate",
    "Played in": "20/13644 of  Eligible  decks (0 %)",
    "code": "aE"
  },
  {
    "Name": "Apex Predator",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When Apex Predator moves, deal 2 damage to your opponent and you gain 2 health. At the end of your turn, if there are no enemy creatures in this lane, move Apex Predator.",
    "Keywords": "",
    "Played in": "86/13695 of  Eligible  decks (1 %)",
    "code": "wz"
  },
  {
    "Name": "Apex Wolf",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Wolf",
    "Magicka Cost": "6",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "FrostSpark Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Breakthrough, Drain. Last Gasp: Draw the top creature of your deck and give it Breakthrough and Drain.",
    "Keywords": "Breakthrough,Drain,Last Gasp",
    "Played in": "372/12907 of  Eligible  decks (3 %)",
    "code": "aF"
  },
  {
    "Name": "Apprentice Necromancer",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower",
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Summon a 1-cost creature from your discard pile.",
    "Keywords": "",
    "Played in": "179/4355 of  Eligible  decks (4 %)",
    "code": "xb"
  },
  {
    "Name": "Arcanaeum Librarian",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Orc",
    "Magicka Cost": "2",
    "Attack": "0",
    "Health": "2",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 2 - College of Winterhold",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Gains +1/+0 when you draw a card during your turn.",
    "Keywords": "",
    "Played in": "11/14266 of  Eligible  decks (0 %)",
    "code": "aI"
  },
  {
    "Name": "Arcane Enchanter",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When you draw an item, give it a random Keyword.",
    "Keywords": "",
    "Played in": "314/14266 of  Eligible  decks (2 %)",
    "code": "aH"
  },
  {
    "Name": "Archcanon Saryoni",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "willpower",
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Choose a blessing from one of the Tribunal gods. Exalt 3: Gain all three blessings instead.",
    "Keywords": "Exalt",
    "Played in": "939/1015 of  Eligible  decks (93 %)",
    "code": "aJ"
  },
  {
    "Name": "Archein Elite",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Lethal",
    "Keywords": "Lethal",
    "Played in": "155/13644 of  Eligible  decks (1 %)",
    "Evolves from:": "Archein Guerrilla",
    "code": "aK"
  },
  {
    "Name": "Archein Venomtongue",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "4",
    "Attack": "1",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Lethal. Slay: gain +1 max magicka.",
    "Keywords": "Lethal,Slay",
    "Played in": "843/13644 of  Eligible  decks (6 %)",
    "Evolves from:": "Archein Guerrilla",
    "code": "aM"
  },
  {
    "Name": "Archer's Gambit",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "strength",
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Move a friendly creature. Then, it deals 1 damage.",
    "Keywords": "",
    "Played in": "1862/4477 of  Eligible  decks (42 %)",
    "code": "aN"
  },
  {
    "Name": "Arenthia Guerrilla",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Lethal on your opponent's turn.",
    "Keywords": "Lethal",
    "Played in": "3/13695 of  Eligible  decks (0 %)",
    "code": "xk"
  },
  {
    "Name": "Arenthia Swindler",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Steal all items from an enemy creature.",
    "Keywords": "",
    "Played in": "2/13695 of  Eligible  decks (0 %)",
    "code": "aO"
  },
  {
    "Name": "Arise",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Summon a 1/1 Risen Dead with Guard in each lane.",
    "Keywords": "Prophecy,Guard",
    "Played in": "56/13651 of  Eligible  decks (0 %)",
    "code": "wP"
  },
  {
    "Name": "Arrest",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Steal an enemy creature. It loses Guard, and is permanently Shackled.",
    "Keywords": "",
    "Played in": "594/12916 of  Eligible  decks (5 %)",
    "code": "aP"
  },
  {
    "Name": "Arrow Storm",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Destroy all creatures with 2 power or less in one lane.",
    "Keywords": "",
    "Played in": "607/12907 of  Eligible  decks (5 %)",
    "code": "aR"
  },
  {
    "Name": "Arrow in the Knee",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Shackle a creature and deal 1 damage to it.",
    "Keywords": "",
    "Played in": "24/13695 of  Eligible  decks (0 %)",
    "code": "aQ"
  },
  {
    "Name": "Artaeum Savant",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "High Elf",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "After you play an action, a random friendly creature gets +1/+1.",
    "Keywords": "",
    "Played in": "186/12907 of  Eligible  decks (1 %)",
    "code": "aS"
  },
  {
    "Name": "Ascended Sleeper",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "intelligence",
      "agility"
    ],
    "Race": "Ash Creature",
    "Magicka Cost": "6",
    "Attack": "3",
    "Health": "6",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard. At the end of your turn, if you have a creature with 5 power or more, reduce the cost of all creatures in your hand by 1.",
    "Keywords": "Guard",
    "Played in": "235/937 of  Eligible  decks (25 %)",
    "code": "aT"
  },
  {
    "Name": "Ash Berserker",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Ash Creature",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "At the end of your turn, if you have a creature with 5 power or more, draw a card.",
    "Keywords": "",
    "Played in": "1578/12757 of  Eligible  decks (12 %)",
    "code": "aU"
  },
  {
    "Name": "Ash Oppressor",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Ash Creature",
    "Magicka Cost": "3",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: If you have a creature with 5 power or more, Shackle an enemy creature.",
    "Keywords": "",
    "Played in": "138/13695 of  Eligible  decks (1 %)",
    "code": "aV"
  },
  {
    "Name": "Ash Piercer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Ash Creature",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Deal 3 damage to a creature if you have a creature with 5 power or more.",
    "Keywords": "",
    "Played in": "64/14266 of  Eligible  decks (0 %)",
    "code": "aW"
  },
  {
    "Name": "Ash Servant",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Ash Creature",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Deal 2 damage to a creature.",
    "Keywords": "",
    "Played in": "196/14266 of  Eligible  decks (1 %)",
    "code": "aX"
  },
  {
    "Name": "Ashlander Punisher",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Breakthrough, Pilfer and Slay: +1/+0.",
    "Keywords": "Breakthrough,Pilfer,Slay",
    "Played in": "218/4477 of  Eligible  decks (5 %)",
    "code": "aZ"
  },
  {
    "Name": "Ashlander Zealot",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Battle an enemy creature.",
    "Keywords": "",
    "Played in": "229/12757 of  Eligible  decks (2 %)",
    "code": "bc"
  },
  {
    "Name": "Aspect of Hircine",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Werewolf",
    "Magicka Cost": "9",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Choose one: Strength: +6/+6 and Guard. Speed: Gains Charge.",
    "Keywords": "Guard,Charge",
    "Played in": "629/12757 of  Eligible  decks (5 %)",
    "code": "bd"
  },
  {
    "Name": "Assassin Beetle",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Beast",
    "Magicka Cost": "5",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy. Summon: Play a Prophecy from your hand.",
    "Keywords": "Prophecy",
    "Played in": "76/13695 of  Eligible  decks (1 %)",
    "code": "tv"
  },
  {
    "Name": "Assassin's Bow",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "+3/+0. Summon: Give the wielder Cover at the end of turn.",
    "Keywords": "",
    "Played in": "379/12757 of  Eligible  decks (3 %)",
    "code": "be"
  },
  {
    "Name": "Assassin's Ritual",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "intelligence",
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Give a creature Lethal and Ward.",
    "Keywords": "Lethal,Ward",
    "Played in": "539/4940 of  Eligible  decks (11 %)",
    "code": "bf"
  },
  {
    "Name": "Assembled Conduit",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Factotum",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 3 - The Halls of Regulation",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Assemble: +1/+0 and Breakthrough or +0/+1 and Regenerate.",
    "Keywords": "Assemble,Breakthrough,Regenerate",
    "Played in": "405/30861 of  Eligible  decks (1 %)",
    "code": "bg"
  },
  {
    "Name": "Assembled Sanitizer",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Factotum",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 3 - The Halls of Regulation",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Assemble: +2/+0 or Lethal.",
    "Keywords": "Assemble,Lethal",
    "Played in": "477/30861 of  Eligible  decks (2 %)",
    "code": "bh"
  },
  {
    "Name": "Assembled Sentry",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Factotum",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 3 - The Ventral Terminus",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Assemble: +0/+2 or Guard.",
    "Keywords": "Assemble,Guard",
    "Played in": "458/30861 of  Eligible  decks (1 %)",
    "code": "bi"
  },
  {
    "Name": "Assembled Titan",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Factotum",
    "Magicka Cost": "6",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 5 - Shaft of Sohleh",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Assemble: Choose two: +2/+0, +0/+2, deal 2 damage to your opponent, or you gain 2 health.",
    "Keywords": "Assemble",
    "Played in": "469/30861 of  Eligible  decks (2 %)",
    "code": "bj"
  },
  {
    "Name": "Astrid",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 3 - Cultists' Meeting Place",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Lethal. When a friendly Lethal creature Slays, put a Completed Contract into your hand.",
    "Keywords": "Lethal,Slay",
    "Played in": "2844/13703 of  Eligible  decks (21 %)",
    "code": "bk"
  },
  {
    "Name": "Attuned Dremora",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Daedra",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "5",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Gain all Keywords friendly creatures have.",
    "Keywords": "",
    "Played in": "50/14266 of  Eligible  decks (0 %)",
    "code": "yD"
  },
  {
    "Name": "Aundae Clan Sorcerer",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Vampire",
    "Magicka Cost": "3",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "At the end of your turn, if three or more creatures died this turn, put a random Blood Magic Spell into your hand.",
    "Keywords": "",
    "Played in": "724/13644 of  Eligible  decks (5 %)",
    "code": "bl"
  },
  {
    "Name": "Auridon Paladin",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "High Elf",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "When you play an action, give Auridon Paladin Drain this turn.",
    "Keywords": "Drain",
    "Played in": "358/12907 of  Eligible  decks (3 %)",
    "code": "bm"
  },
  {
    "Name": "Auroran Sentry",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Daedra",
    "Magicka Cost": "8",
    "Attack": "5",
    "Health": "7",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Guard. When Auroran Sentry is dealt damage, you gain that much health.",
    "Keywords": "Guard",
    "Played in": "255/12907 of  Eligible  decks (2 %)",
    "code": "bn"
  },
  {
    "Name": "Awakened Dreamer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "At the end of your turn, if you have a creature with 5 power or more, Awakened Dreamer gains +1/+1.",
    "Keywords": "",
    "Played in": "503/13695 of  Eligible  decks (4 %)",
    "code": "bo"
  },
  {
    "Name": "Awakened Imperfect",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Automaton",
    "Magicka Cost": "8",
    "Attack": "8",
    "Health": "8",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 5 - The Tools",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Breakthrough, Guard",
    "Keywords": "Breakthrough,Guard",
    "Played in": "99/30861 of  Eligible  decks (0 %)",
    "code": "bp"
  },
  {
    "Name": "Ayleid Guardian",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance", "agility"
    ],
    "Race": "Defense",
    "Magicka Cost": "11",
    "Attack": "8",
    "Health": "8",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard Immune to Lethal. Summon: Summon an Ayleid Guardian in the other lane.",
    "Keywords": "Guard",
    "code": "yW"
  },
  {
    "Name": "Ayrenn's Chosen",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "intelligence",
      "willpower",
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon a 1/1 Recruit in each lane and give them Guard. Empower: +1/+1.",
    "Keywords": "Empower,Guard",
    "Played in": "30/307 of  Eligible  decks (10 %)",
    "code": "tb"
  },
  {
    "Name": "Ayrenn, Dominion Queen",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "willpower",
      "agility"
    ],
    "Race": "High Elf",
    "Magicka Cost": "8",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Drain. Summon: Draw a random action from your discard pile. When you draw an action on your turn, deal 1 damage to your opponent.",
    "Keywords": "Drain",
    "Played in": "175/307 of  Eligible  decks (57 %)",
    "code": "sx"
  },
  {
    "Name": "Ayrenn",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "willpower"
    ],
    "Race": "High Elf",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Draw a random action from your discard pile. Your actions cost 1 less.",
    "Keywords": "",
    "Played in": "2848/4505 of  Eligible  decks (63 %)",
    "code": "bq"
  },
  {
    "Name": "Baandari Bruiser",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Pilfer: +3/+0.",
    "Keywords": "Pilfer",
    "Played in": "99/13695 of  Eligible  decks (1 %)",
    "code": "br"
  },
  {
    "Name": "Baandari Opportunist",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Charge. Pilfer: Shuffle a Baandari Opportunist with \"Summon: Draw a card\" into your deck.",
    "Keywords": "Charge,Pilfer",
    "Played in": "558/13695 of  Eligible  decks (4 %)",
    "code": "sA"
  },
  {
    "Name": "Back-Alley Footpad",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "0",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Give a creature Cover.",
    "Keywords": "",
    "Played in": "31/13695 of  Eligible  decks (0 %)",
    "code": "ta"
  },
  {
    "Name": "Back-Alley Rogue",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "5",
    "Health": "3",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 2 - Sightless Pit",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Steal Cover from another creature.",
    "Keywords": "",
    "Played in": "57/13695 of  Eligible  decks (0 %)",
    "code": "bs"
  },
  {
    "Name": "Bal Isra Warrider",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Redguard",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "6",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Rally",
    "Keywords": "Rally",
    "Played in": "133/13644 of  Eligible  decks (1 %)",
    "code": "bt"
  },
  {
    "Name": "Baliwog Tidecrawlers/Smoked Baliwog Leg",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Grummite",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "6",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "118/13644 of  Eligible  decks (1 %)",
    "code": "po"
  },
  {
    "Name": "Balmora Captain",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Rally 2. Your other Rallies give an extra +1/+1.",
    "Keywords": "Rally",
    "Played in": "178/12907 of  Eligible  decks (1 %)",
    "code": "bu"
  },
  {
    "Name": "Balmora Puppeteer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "willpower",
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Plot: +1/+1 for each other card you've played this turn.",
    "Keywords": "Plot",
    "Played in": "475/861 of  Eligible  decks (55 %)",
    "code": "bv"
  },
  {
    "Name": "Balmora Spymaster",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "2",
    "Attack": "0",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Last Gasp: Summon a random creature with cost less than or equal to your max magicka.",
    "Keywords": "Last Gasp",
    "Played in": "916/14266 of  Eligible  decks (6 %)",
    "code": "bw"
  },
  {
    "Name": "Bandit Ringleader",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "6",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Other friendly creatures in this lane gain \"Pilfer: Draw a card\" this turn.",
    "Keywords": "",
    "Played in": "360/12907 of  Eligible  decks (3 %)",
    "code": "bx"
  },
  {
    "Name": "Bangkorai Butcher",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: +2/+2 if you another friendly Orc.",
    "Keywords": "",
    "Played in": "607/12757 of  Eligible  decks (5 %)",
    "code": "by"
  },
  {
    "Name": "Barbas",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Daedra",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Choose one: -Stay: Gains +1/+1 and Guard. Fetch: Put a random Daedra into your hand. Roll Over: Gains Charge.",
    "Keywords": "",
    "Played in": "426/30872 of  Eligible  decks (1 %)",
    "code": "bz"
  },
  {
    "Name": "Barded Guar",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Reptile",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Give a creature Guard.",
    "Keywords": "Guard",
    "Played in": "328/30861 of  Eligible  decks (1 %)",
    "code": "bA"
  },
  {
    "Name": "Barilzar's Tinkering",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Betray. Transform a creature into a random creature that costs 1 more.",
    "Keywords": "Betray",
    "Played in": "497/14266 of  Eligible  decks (3 %)",
    "code": "bB"
  },
  {
    "Name": "Baron of Tear",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Give other friendly (Intelligence) creatures +1/+0 and Guard.",
    "Keywords": "Guard",
    "Played in": "192/14266 of  Eligible  decks (1 %)",
    "code": "bC"
  },
  {
    "Name": "Barrow Stalker",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Vampire",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 6 - Sanguine Barrows",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Drain, Guard",
    "Keywords": "Drain,Guard",
    "Played in": "4369/13644 of  Eligible  decks (32 %)",
    "code": "bD"
  },
  {
    "Name": "Barter",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Trade a card in your hand for a random card in your opponent's hand.",
    "Keywords": "",
    "Played in": "86/13703 of  Eligible  decks (1 %)",
    "code": "bE"
  },
  {
    "Name": "Battle of Chalman Keep",
    "Rarity": "Legendary - Unique",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Each player fills both lanes with 1/1 Recruits. Give all creatures Guard.",
    "Keywords": "Guard",
    "Played in": "51/30861 of  Eligible  decks (0 %)",
    "code": "sB"
  },
  {
    "Name": "Battlefield Scrounger",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Redguard",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Charge. Slay: Put a random item into your hand.",
    "Keywords": "Charge,Slay",
    "Played in": "501/12757 of  Eligible  decks (4 %)",
    "code": "bF"
  },
  {
    "Name": "Battlemage's Onslaught",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "strength",
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Put a random action, item, and creature into your hand.",
    "Keywords": "",
    "Played in": "301/3939 of  Eligible  decks (8 %)",
    "code": "bG"
  },
  {
    "Name": "Battlerage Orc",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Charge",
    "Keywords": "Charge",
    "Played in": "1707/12757 of  Eligible  decks (13 %)",
    "code": "bH"
  },
  {
    "Name": "Battlereeve of Dusk",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "6",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Friendly creatures get +1/+1 for each keyword they have.",
    "Keywords": "",
    "Played in": "97/14266 of  Eligible  decks (1 %)",
    "code": "bI"
  },
  {
    "Name": "Be at Peace",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Set a creature's power to 1.",
    "Keywords": "Prophecy",
    "Played in": "16/12907 of  Eligible  decks (0 %)",
    "code": "wt"
  },
  {
    "Name": "Bedeviling Scamp",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Daedra",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "All cards cost a minimum of 3.",
    "Keywords": "",
    "Played in": "57/12757 of  Eligible  decks (0 %)",
    "code": "bJ"
  },
  {
    "Name": "Bedlam",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Put two 1/1 Scamps into your hand.",
    "Keywords": "",
    "Played in": "22/12907 of  Eligible  decks (0 %)",
    "code": "xx"
  },
  {
    "Name": "Belligerent Giant",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Giant",
    "Magicka Cost": "7",
    "Attack": "7",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Breakthrough. Summon: Unsummon a creature in this lane, or destroy an enemy support.",
    "Keywords": "Breakthrough",
    "Played in": "2498/12757 of  Eligible  decks (20 %)",
    "code": "bK"
  },
  {
    "Name": "Berne Clan Nightstalker",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Vampire",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Guard. Summon: Secretly choose an enemy creature. Last Gasp: Destroy the chosen creature.",
    "Keywords": "Guard,Lasp Gasp",
    "Played in": "294/13695 of  Eligible  decks (2 %)",
    "code": "bL"
  },
  {
    "Name": "Berserker of the Pale",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "4",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "When you summon another creature with 5 power or more, give it +1/+1 and Breakthrough.",
    "Keywords": "Breakthrough",
    "Played in": "167/12757 of  Eligible  decks (1 %)",
    "code": "bM"
  },
  {
    "Name": "Betty Netch",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Netch",
    "Magicka Cost": "5",
    "Attack": "0",
    "Health": "5",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "While Betty Netch is in play, your max magicka is increased by 2.",
    "Keywords": "",
    "Played in": "54/13644 of  Eligible  decks (0 %)",
    "code": "bN"
  },
  {
    "Name": "Bewildering Speed",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Move a friendly creature in each lane and give them +1/+1.",
    "Keywords": "",
    "Played in": "127/13695 of  Eligible  decks (1 %)",
    "code": "sJ"
  },
  {
    "Name": "Bishop of the Hour",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: If you have another creature in each lane, give the top creature of your deck +5/+5.",
    "Keywords": "",
    "Played in": "51/13644 of  Eligible  decks (0 %)",
    "code": "sD"
  },
  {
    "Name": "Bitterfish Witch",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Goblin",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Summon: Give a creature -1/-1.",
    "Keywords": "Prophecy",
    "Played in": "74/13695 of  Eligible  decks (1 %)",
    "code": "xI"
  },
  {
    "Name": "Black Hand Messenger",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "0",
    "Health": "2",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Drain. Summon: Deal 2 damage to a creature. Last Gasp: Deal 2 damage to your opponent.",
    "Keywords": "Drain,Last Gasp",
    "Played in": "1439/4940 of  Eligible  decks (29 %)",
    "code": "bO"
  },
  {
    "Name": "Black Marsh Centurion",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "6",
    "Attack": "4",
    "Health": "8",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Veteran: Guard",
    "Keywords": "Veteran,Guard",
    "Played in": "40/13644 of  Eligible  decks (0 %)",
    "code": "sE"
  },
  {
    "Name": "Black Marsh Prodigy",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Veteran: +4/+4.",
    "Keywords": "Veteran",
    "Played in": "44/13651 of  Eligible  decks (0 %)",
    "code": "sF"
  },
  {
    "Name": "Black Marsh Warden",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "At the end of your turn, summon a 1/1 Argonian Recruit. If you have 7 or more max magicka, summon a 3/3 Argonian Veteran instead.",
    "Keywords": "",
    "Played in": "250/13644 of  Eligible  decks (2 %)",
    "code": "bP"
  },
  {
    "Name": "Black Soul Gem",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Ongoing. When a friendly creature dies, give a random creature in your hand +1/+1.",
    "Keywords": "",
    "Played in": "78/13644 of  Eligible  decks (1 %)",
    "code": "yk"
  },
  {
    "Name": "Black Worm Necromancer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "6",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: If you have more health than your opponent, summon a random creature card from your discard pile.",
    "Keywords": "",
    "Played in": "347/13644 of  Eligible  decks (3 %)",
    "code": "bQ"
  },
  {
    "Name": "Black Worm Neophyte",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Consume a creature. Summon a 1/1 Skeleton with its Keywords.",
    "Keywords": "",
    "Played in": "54/14266 of  Eligible  decks (0 %)",
    "code": "vP"
  },
  {
    "Name": "Blackmail",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Draw a copy of a random creature from your opponent's deck.",
    "Keywords": "",
    "Played in": "326/12907 of  Eligible  decks (3 %)",
    "code": "bR"
  },
  {
    "Name": "Blackreach Rebuilder",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "1",
    "Attack": "0",
    "Health": "1",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard. Summon: Gain 2 health.",
    "Keywords": "Prophecy,Guard",
    "Played in": "368/30861 of  Eligible  decks (1 %)",
    "code": "bS"
  },
  {
    "Name": "Blackrose Herbalist",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the start of your turn, heal another random friendly creature.",
    "Keywords": "",
    "Played in": "49/13644 of  Eligible  decks (0 %)",
    "code": "bT"
  },
  {
    "Name": "Blacksap Protector",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy, Guard",
    "Keywords": "Guard,Prophecy",
    "Played in": "251/13695 of  Eligible  decks (2 %)",
    "code": "bU"
  },
  {
    "Name": "Blackwood Alchemist",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "4",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Gains +2/+0 when your max magicka increases.",
    "Keywords": "",
    "Played in": "22/13644 of  Eligible  decks (0 %)",
    "code": "yu"
  },
  {
    "Name": "Blackwood Distiller",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility",
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Pilfer: Gain 3 magicka this turn. Slay: Gain +1 max magicka.",
    "Keywords": "Pilfer,Slay",
    "Played in": "438/4386 of  Eligible  decks (10 %)",
    "code": "bW"
  },
  {
    "Name": "Blades Defender",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Breton",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Give a creature in the other lane +0/+2.",
    "Keywords": "",
    "Played in": "5/13644 of  Eligible  decks (0 %)",
    "code": "yf"
  },
  {
    "Name": "Blades Flanker",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Give a creature in the other lane +2/+0.",
    "Keywords": "",
    "Played in": "11/13695 of  Eligible  decks (0 %)",
    "code": "yg"
  },
  {
    "Name": "Blades Guardian",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Redguard",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "5",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard. Summon: Give a creature in the other lane +1/+1 and Guard.",
    "Keywords": "Guard",
    "Played in": "11/12907 of  Eligible  decks (0 %)",
    "code": "yh"
  },
  {
    "Name": "Blades Lookout",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "When you summon a Dragon, draw a card.",
    "Keywords": "",
    "Played in": "484/12757 of  Eligible  decks (4 %)",
    "code": "bX"
  },
  {
    "Name": "Blades Stalwart",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Breton",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Slay: Blades Stalwart gains power equal to her health.",
    "Keywords": "Slay",
    "Played in": "12/13695 of  Eligible  decks (0 %)",
    "code": "ya"
  },
  {
    "Name": "Blast from Oblivion",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Invade, then deal damage equal to your Oblivion Gate's level to a creature.",
    "Keywords": "Prophecy,Invade",
    "Played in": "100/14266 of  Eligible  decks (1 %)",
    "code": "xp"
  },
  {
    "Name": "Blastbones",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "1",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Charge. Last Gasp: Deal 1 damage to all creatures in this lane.",
    "Keywords": "Charge",
    "Played in": "21/12759 of  Eligible  decks (0 %)",
    "code": "vR"
  },
  {
    "Name": "Bleakcoast Troll",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Troll",
    "Magicka Cost": "4",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Forgotten Hero Collection",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Slay: +1/+1",
    "Keywords": "Slay",
    "Played in": "1567/13644 of  Eligible  decks (11 %)",
    "code": "bY"
  },
  {
    "Name": "Blessing of the Grove",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Gain 2 health for each friendly creature.",
    "Keywords": "",
    "Played in": "35/12907 of  Eligible  decks (0 %)",
    "code": "bZ"
  },
  {
    "Name": "Blighted Alit",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Reptile",
    "Magicka Cost": "3",
    "Attack": "5",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the start of your turn, Blighted Alit deals 2 damage to you.",
    "Keywords": "",
    "Played in": "264/12757 of  Eligible  decks (2 %)",
    "code": "ca"
  },
  {
    "Name": "Blighted Werebat",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Beast",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Drain. At the end of your turn, if you have a creature with 5 or more power, deal 2 damage to your opponent.",
    "Keywords": "Drain",
    "Played in": "312/13695 of  Eligible  decks (2 %)",
    "code": "cb"
  },
  {
    "Name": "Blind Moth Priest",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "On your turn, Blind Moth Priest glows while your opponent has a Prophecy on top of their deck.",
    "Keywords": "Prophecy",
    "Played in": "6/12907 of  Eligible  decks (0 %)",
    "code": "xU"
  },
  {
    "Name": "Blood Dragon",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Dragon",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "7",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Blood Dragon ignores Guards and can attack creatures in any lane.",
    "Keywords": "Guard",
    "Played in": "1550/12757 of  Eligible  decks (12 %)",
    "code": "cc"
  },
  {
    "Name": "Blood Magic Lord",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Vampire",
    "Magicka Cost": "9",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon and Slay: Put a Blood Magic Spell into your hand.",
    "Keywords": "Slay",
    "Played in": "1526/13644 of  Eligible  decks (11 %)",
    "Evolves from:": "Volkihar Lord",
    "code": "cd"
  },
  {
    "Name": "Blood Pact Messenger",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 5 - Skooma Den",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Pilfer: Draw two cards. Sacrifice Blood Pact Messenger at the end of the turn.",
    "Keywords": "Pilfer",
    "Played in": "646/12907 of  Eligible  decks (5 %)",
    "code": "ce"
  },
  {
    "Name": "Blood Sacrament",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Betray. Deal 2 damage to your opponent and gain 2 health.",
    "Keywords": "Betray",
    "Played in": "305/13695 of  Eligible  decks (2 %)",
    "code": "cf"
  },
  {
    "Name": "Blood Sorceress",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Redguard",
    "Magicka Cost": "1",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 2 - Castle Wayrest, Grand Hall",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the start of the your turn, if you have 7 or more max magicka, deal 5 damage to your opponent.",
    "Keywords": "",
    "Played in": "525/14266 of  Eligible  decks (4 %)",
    "code": "cg"
  },
  {
    "Name": "Blood-Crazed Daedroth",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Daedra",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Draw a card if there is a Wounded creature in this lane.",
    "Keywords": "",
    "Played in": "108/12757 of  Eligible  decks (1 %)",
    "code": "xP"
  },
  {
    "Name": "Bloodline Outcast",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Vampire",
    "Magicka Cost": "7",
    "Attack": "7",
    "Health": "7",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "When a creature dies, Bloodline Outcast gains Drain this turn.",
    "Keywords": "",
    "Played in": "139/13644 of  Eligible  decks (1 %)",
    "code": "ch"
  },
  {
    "Name": "Bloody Hand Chef",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Goblin",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "When you reduce an enemy creature's power or health with an effect, Bloody Hand Chef gains that much power or health.",
    "Keywords": "",
    "Played in": "68/13695 of  Eligible  decks (0 %)",
    "code": "yl"
  },
  {
    "Name": "Blueclaw Matron",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dreugh",
    "Magicka Cost": "7",
    "Attack": "3",
    "Health": "8",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "32/30861 of  Eligible  decks (0 %)",
    "code": "ci"
  },
  {
    "Name": "Bog Lurcher",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Lurcher",
    "Magicka Cost": "4",
    "Attack": "9",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "",
    "Keywords": "",
    "Played in": "272/12757 of  Eligible  decks (2 %)",
    "code": "cj"
  },
  {
    "Name": "Bolvyn Venim",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "willpower",
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Rally. When you Rally with no creatures in your hand, first draw Bolvyn Venim from your deck.",
    "Keywords": "Rally",
    "Played in": "265/806 of  Eligible  decks (33 %)",
    "code": "ck"
  },
  {
    "Name": "Bone Armor",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: The wielder Consumes a creature and gains its health.",
    "Keywords": "Consume",
    "Played in": "57/13644 of  Eligible  decks (0 %)",
    "code": "vQ"
  },
  {
    "Name": "Bone Bow",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "+1/+0. Summon: Silence another creature.",
    "Keywords": "",
    "Played in": "1041/12757 of  Eligible  decks (8 %)",
    "code": "cl"
  },
  {
    "Name": "Bone Colossus",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "7",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Summon 1/1 Skeletons to fill this lane. Other friendly Undead have +1/+1.",
    "Keywords": "",
    "Played in": "478/13644 of  Eligible  decks (4 %)",
    "code": "cm"
  },
  {
    "Name": "Bonewalker",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "4",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard. Summon: +1/+1 for each enemy creature in this lane.",
    "Keywords": "Prophecy,Guard",
    "Played in": "250/13651 of  Eligible  decks (2 %)",
    "code": "cn"
  },
  {
    "Name": "Boneweaver",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. Summon: Consume a creature. Draw creature with the same name from your discard pile.",
    "Keywords": "Guard,Consume",
    "Played in": "103/13651 of  Eligible  decks (1 %)",
    "code": "vV"
  },
  {
    "Name": "Brass Arquebus",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "6",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 3 - The Last Stand",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Last Gasp: Draw three different random 1-cost creatures from your deck.",
    "Keywords": "Last Gasp",
    "Played in": "130/30861 of  Eligible  decks (0 %)",
    "code": "co"
  },
  {
    "Name": "Brassilisk",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Fabricant",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 5 - Submerged Aqueduct",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "When Brassilisk takes damage and survives, summon a copy of it in the other lane.",
    "Keywords": "",
    "Played in": "63/13644 of  Eligible  decks (0 %)",
    "code": "cp"
  },
  {
    "Name": "Brellach Commander",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Daedra",
    "Magicka Cost": "8",
    "Attack": "7",
    "Health": "8",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon and Pilfer: Summon a random creature with cost 3 or less.",
    "Keywords": "Pilfer",
    "Played in": "122/12907 of  Eligible  decks (1 %)",
    "code": "cq"
  },
  {
    "Name": "Breton Conjurer",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "4",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Ward. When Breton Conjurer's Ward is broken, summon a 5/5 Frost Atronach with Guard.",
    "Keywords": "Guard,Ward",
    "Played in": "1010/14266 of  Eligible  decks (7 %)",
    "code": "cr"
  },
  {
    "Name": "Brilliant Experiment",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Draw a copy of a friendly creature.",
    "Keywords": "",
    "Played in": "302/14266 of  Eligible  decks (2 %)",
    "code": "cs"
  },
  {
    "Name": "Bringer of Nightmares",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Daedra",
    "Magicka Cost": "7",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: See a vision of a random creature, then you must choose a creature to transform into it.",
    "Keywords": "",
    "Played in": "241/14266 of  Eligible  decks (2 %)",
    "code": "ct"
  },
  {
    "Name": "Brotherhood Sanctuary",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 4 - Falkreath Sanctuary",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Ongoing. When a friendly creature Slays, it receives its reward an extra time.",
    "Keywords": "Slay",
    "Played in": "886/13695 of  Eligible  decks (6 %)",
    "code": "cu"
  },
  {
    "Name": "Brotherhood Slayer",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 1 - Kastus Thorn's house",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Slay: Put a Completed Contract into your hand.",
    "Keywords": "Prophecy,Slay",
    "Played in": "2856/13695 of  Eligible  decks (21 %)",
    "code": "cv"
  },
  {
    "Name": "Brotherhood Suspect",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Argonian",
    "Magicka Cost": "1",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Last Gasp: Your opponent draws a Competed Contract.",
    "Keywords": "Last Gasp",
    "Played in": "27/13695 of  Eligible  decks (0 %)",
    "code": "xy"
  },
  {
    "Name": "Brotherhood Vampire",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Breton",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon; +1/+1 for each creature that died this turn.",
    "Keywords": "",
    "Played in": "3/13644 of  Eligible  decks (0 %)",
    "code": "yG"
  },
  {
    "Name": "Bruma Armorer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "When you summon another, give it +0/+2.",
    "Keywords": "",
    "Played in": "416/13644 of  Eligible  decks (3 %)",
    "code": "cw"
  },
  {
    "Name": "Bruma Oppressor",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: If you have another creature in each lane, set a creature's power to 1.",
    "Keywords": "",
    "Played in": "20/12907 of  Eligible  decks (0 %)",
    "code": "tt"
  },
  {
    "Name": "Bruma Profiteer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "When you summon another creature gain 1 health.",
    "Keywords": "",
    "Played in": "4325/12907 of  Eligible  decks (34 %)",
    "code": "cx"
  },
  {
    "Name": "Brutal Ashlander",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Last Gasp: Deal 3 damage to a random enemy.",
    "Keywords": "Last Gasp",
    "Played in": "1429/14266 of  Eligible  decks (10 %)",
    "code": "cy"
  },
  {
    "Name": "Brynjolf",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Nord",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "5",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Drain, When a friendly creature Pilfers or Drain, gain +1 magicka this turn.",
    "Keywords": "Drain,Pilfer",
    "Played in": "3075/13703 of  Eligible  decks (22 %)",
    "code": "cz"
  },
  {
    "Name": "Burn and Pillage",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Deal 1 damage to all enemy creatures in a lane for each destroyed enemy rune.",
    "Keywords": "",
    "Played in": "439/12757 of  Eligible  decks (3 %)",
    "code": "cA"
  },
  {
    "Name": "Burning Touch",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Deal 2 damage to a creature.",
    "Keywords": "Prophecy",
    "Played in": "124/14266 of  Eligible  decks (1 %)",
    "code": "cB"
  },
  {
    "Name": "Bushwhack",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "A friendly creature ignores Guards and can attack creatures in any lane this turn.",
    "Keywords": "Guard",
    "Played in": "172/12757 of  Eligible  decks (1 %)",
    "code": "cC"
  },
  {
    "Name": "Cadwell the Soul Shriven/Cadwell the Betrayer",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Imperial",
    "Magicka Cost": "1",
    "Attack": "0",
    "Health": "1",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Immune to Shackle. When a rune is destroyed, Cadwell the Soul Shriven gains +1/+0.\n-\nCadwell the Betrayer can attack you.",
    "Keywords": "",
    "Played in": "21/30861 of  Eligible  decks (0 %)",
    "code": "wY"
  },
  {
    "Name": "Caius Cosades",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Look at two of your opponent's cards. Guess the one in their hand. If you're right, give all creatures in your hand +1/+1.",
    "Keywords": "",
    "Played in": "99/13644 of  Eligible  decks (1 %)",
    "code": "cD"
  },
  {
    "Name": "Caius' Machinations",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Betray. Give the top three creatures of your deck +1/+1.",
    "Keywords": "Betray",
    "Played in": "239/13644 of  Eligible  decks (2 %)",
    "code": "cE"
  },
  {
    "Name": "Call Dragon",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "8",
    "Expansion Set": "Tamriel Collection",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Upgrade all your Shouts. Summon a random 6-8 cost Dragon.\nLevel 2: Summon a random 8-10 cost Dragon.\nLevel 3: Summon a random 12 cost Dragon.",
    "Keywords": "",
    "Played in": "29/30861 of  Eligible  decks (0 %)",
    "code": "Bj"
  },
  {
    "Name": "Call of Valor",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Level 1: Summon a 3/3 Sovngarde Hero.\nLevel 2: Summon two 3/3 Sovngarde Heroes.\nLevel 3: Fill a lane with 3/3 Sovngarde Heroes.",
    "Keywords": "",
    "Played in": "655/12907 of  Eligible  decks (5 %)",
    "code": "cF"
  },
  {
    "Name": "Calm",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Give a creature -4/-0 this turn.",
    "Keywords": "",
    "Played in": "329/12907 of  Eligible  decks (3 %)",
    "code": "cG"
  },
  {
    "Name": "Camlorn Hero",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "3",
    "Attack": "4",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Deal 2 damage to your opponent.",
    "Keywords": "",
    "Played in": "762/14266 of  Eligible  decks (5 %)",
    "Evolves from:": "Camlorn Adventurer",
    "code": "cI"
  },
  {
    "Name": "Camlorn Sentinel",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard",
    "Keywords": "Guard,Prophecy",
    "Played in": "966/14266 of  Eligible  decks (7 %)",
    "Evolves from:": "Camlorn Adventurer",
    "code": "cJ"
  },
  {
    "Name": "Camonna Tong Heavy",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Plot: Unsummon a creature in this lane with less power than Camonna Tong Heavy.",
    "Keywords": "Plot",
    "Played in": "88/12757 of  Eligible  decks (1 %)",
    "code": "cK"
  },
  {
    "Name": "Camoran Scout Leader",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "5",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Summon a 2/2 Wood Elf Scout with Charge in each lane with a wounded enemy creature.",
    "Keywords": "Charge",
    "Played in": "30/13695 of  Eligible  decks (0 %)",
    "code": "cL"
  },
  {
    "Name": "Candlehearth Brawler",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "5",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Charge, Guard",
    "Keywords": "Charge,Guard",
    "Played in": "1375/12757 of  Eligible  decks (11 %)",
    "code": "cM"
  },
  {
    "Name": "Caravan Enforcer",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "When Caravan Enforcer moves, he gains +1/+1.",
    "Keywords": "",
    "Played in": "351/13695 of  Eligible  decks (3 %)",
    "code": "cN"
  },
  {
    "Name": "Cartel Arcanist",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Wax: +2/+0. Wane: Shackle an enemy creature.",
    "Keywords": "Wax/Wane",
    "Played in": "63/14266 of  Eligible  decks (0 %)",
    "code": "wI"
  },
  {
    "Name": "Cartel Bruiser",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Pilfer: +2/+2.",
    "Keywords": "Pilfer",
    "Played in": "41/13695 of  Eligible  decks (0 %)",
    "code": "vC"
  },
  {
    "Name": "Cast Into Time",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Forgotten Hero Collection",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Banish a creature.",
    "Keywords": "",
    "Played in": "2103/12907 of  Eligible  decks (16 %)",
    "code": "cO"
  },
  {
    "Name": "Cast Out",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy. Unsummon a creature.",
    "Keywords": "Prophecy",
    "Played in": "1112/12757 of  Eligible  decks (9 %)",
    "code": "cP"
  },
  {
    "Name": "Cathay-raht Veteran",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "69/12907 of  Eligible  decks (1 %)",
    "code": "cQ"
  },
  {
    "Name": "Cauldron Keeper",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. Summon: Give your Activated supports an extra use. You may Activate your supports an extra time each turn.",
    "Keywords": "Guard",
    "Played in": "536/12907 of  Eligible  decks (4 %)",
    "code": "cR"
  },
  {
    "Name": "Cauterize",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Deal 2 damage to a Wounded creature.",
    "Keywords": "",
    "Played in": "34/12759 of  Eligible  decks (0 %)",
    "code": "sG"
  },
  {
    "Name": "Cave Bear",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Beast",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "6",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "86/13644 of  Eligible  decks (1 %)",
    "code": "cS"
  },
  {
    "Name": "Champion of the Arena",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "endurance"
    ],
    "Race": "Orc",
    "Magicka Cost": "7",
    "Attack": "4",
    "Health": "8",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Breakthrough. Summon: Battle an enemy creature.",
    "Keywords": "Breakthrough",
    "Played in": "20/3890 of  Eligible  decks (1 %)",
    "code": "yJ"
  },
  {
    "Name": "Channeled Storm",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Deal 3 damage to a creature. Empower: +1 damage.",
    "Keywords": "Empower",
    "Played in": "494/14266 of  Eligible  decks (3 %)",
    "code": "sH"
  },
  {
    "Name": "Chanter of Akatosh",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "5",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 1 - Temple of Akatosh",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "After you play an action, summon a random creature from your deck with the same cost.",
    "Keywords": "",
    "Played in": "442/12907 of  Eligible  decks (3 %)",
    "code": "cU"
  },
  {
    "Name": "Chaurus Breeding Pit",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "10",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon a Chaurus Reaper in each lane.",
    "Keywords": "",
    "Played in": "95/13695 of  Eligible  decks (1 %)",
    "code": "cW"
  },
  {
    "Name": "Chaurus Reaper",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Chaurus",
    "Magicka Cost": "7",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Give all enemy creatures in this lane -1/-1.",
    "Keywords": "",
    "Played in": "288/13695 of  Eligible  decks (2 %)",
    "code": "cX"
  },
  {
    "Name": "Chaurus",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Chaurus",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "31/13703 of  Eligible  decks (0 %)",
    "code": "cV"
  },
  {
    "Name": "Cheesemancer",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Imperial",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Promotional Cards",
    "Unlocked in": "Limited Sheogorath offer",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the start of the game, Cheesemancer gains the abilities of a random creature from Isle of Madness.",
    "Keywords": "",
    "Played in": "23/30872 of  Eligible  decks (0 %)",
    "code": "cY"
  },
  {
    "Name": "Cheydinhal Sapper",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Drain",
    "Keywords": "Drain",
    "Played in": "540/12907 of  Eligible  decks (4 %)",
    "code": "cZ"
  },
  {
    "Name": "Chieftain's Banner",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Friendly Orcs have +0/+2.",
    "Keywords": "",
    "Played in": "50/13644 of  Eligible  decks (0 %)",
    "code": "da"
  },
  {
    "Name": "Child of Hircine",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Werewolf",
    "Magicka Cost": "6",
    "Attack": "6",
    "Health": "7",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Slay: May attack again this turn.",
    "Keywords": "Slay",
    "Played in": "859/12757 of  Eligible  decks (7 %)",
    "Evolves from:": "Initiate of Hircine",
    "code": "db"
  },
  {
    "Name": "Chodala's Treachery",
    "Rarity": "Legendary",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "9",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Destroy a creature. Plot: Steal the creature instead.",
    "Keywords": "Plot",
    "Played in": "283/12907 of  Eligible  decks (2 %)",
    "code": "dc"
  },
  {
    "Name": "Cicero the Betrayer",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "6",
    "Attack": "1",
    "Health": "6",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 4 - Varlyn",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Lethal. Slay: Draw two cards. Cicero can attack friendly creatures.",
    "Keywords": "Lethal,Slay",
    "Played in": "1483/13644 of  Eligible  decks (11 %)",
    "code": "dd"
  },
  {
    "Name": "Circle Initiate",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Beast Form: +2/+1",
    "Keywords": "Prophecy",
    "Played in": "2421/12757 of  Eligible  decks (19 %)",
    "code": "de"
  },
  {
    "Name": "City Guard",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard.",
    "Keywords": "Prophecy,Guard",
    "Played in": "40/13644 of  Eligible  decks (0 %)",
    "code": "xu"
  },
  {
    "Name": "Clannfear Runt",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Daedra",
    "Magicka Cost": "0",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "11/12907 of  Eligible  decks (0 %)",
    "code": "xQ"
  },
  {
    "Name": "Cleric of Kyne",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Summon: Give a creature +0/+2.",
    "Keywords": "Prophecy",
    "Played in": "913/12907 of  Eligible  decks (7 %)",
    "code": "df"
  },
  {
    "Name": "Cliff Hunter",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Reptile",
    "Magicka Cost": "6",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Summon: Battle an enemy creature.",
    "Keywords": "Prophecy",
    "Played in": "81/12757 of  Eligible  decks (1 %)",
    "code": "dg"
  },
  {
    "Name": "Cliff Racer Onslaught",
    "Rarity": "Legendary",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "9",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon a 4/4 Cliff Racer with Charge in each lane. Your opponent summons a 0/1 Target with Guard in each lane.",
    "Keywords": "",
    "Played in": "61/13695 of  Eligible  decks (0 %)",
    "code": "di"
  },
  {
    "Name": "Cliff Racer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Reptile",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Charge",
    "Keywords": "Charge",
    "Played in": "797/13695 of  Eligible  decks (6 %)",
    "code": "dh"
  },
  {
    "Name": "Cliff Strider",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Reptile",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Charge. Can't attack your opponent. At the end of your turn, if there are no enemy creatures in this lane, move Cliff Strider.",
    "Keywords": "Charge",
    "Played in": "54/13695 of  Eligible  decks (0 %)",
    "code": "dj"
  },
  {
    "Name": "Cliffside Lookout",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "5",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "When you summon a Dragon, Cliffside Lookout gains +1/+1.",
    "Keywords": "",
    "Played in": "410/12907 of  Eligible  decks (3 %)",
    "code": "dk"
  },
  {
    "Name": "Clivia Tharn",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "willpower",
      "agility",
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "6",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Other friendly creatures in this lane have Guard. At the end of your turn, summon a 1/1 Recruit in each lane.",
    "Keywords": "Guard",
    "Played in": "249/356 of  Eligible  decks (70 %)",
    "code": "sI"
  },
  {
    "Name": "Cloak/Dagger",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "373/12757 of  Eligible  decks (3 %)",
    "code": "dl"
  },
  {
    "Name": "Clockwork Apostle",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "High Elf",
    "Magicka Cost": "7",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 3 - Brass Fortress Market Square",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Give another friendly creature +4/+4. It becomes [neutral].",
    "Keywords": "",
    "Played in": "341/12907 of  Eligible  decks (3 %)",
    "code": "dm"
  },
  {
    "Name": "Clockwork City Pilgrim",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard. Exalt 3: +2/+2.",
    "Keywords": "Guard,Exalt",
    "Played in": "180/14266 of  Eligible  decks (1 %)",
    "code": "dn"
  },
  {
    "Name": "Clockwork Dragon",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dragon",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 6 - Dragonclaw Rock",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: If Clockwork Dragon is in the left lane, +2/+0 and Dran. Otherwise, +0/+2 and Guard.",
    "Keywords": "Drain,Guard",
    "Played in": "1012/30861 of  Eligible  decks (3 %)",
    "code": "do"
  },
  {
    "Name": "Clockwork Scorpion",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Fabricant",
    "Magicka Cost": "6",
    "Attack": "3",
    "Health": "7",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 6 - Return to The Inner Curiosity",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Drain, Lethal",
    "Keywords": "Drain,Lethal",
    "Played in": "619/13695 of  Eligible  decks (5 %)",
    "code": "dp"
  },
  {
    "Name": "Close Call",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Madhouse Collection",
    "Soul Summon": "This card belongs to the Madhouse Collection and cannot be Soul Summoned.",
    "Soul Trap": "This card belongs to the Madhouse Collection and cannot be Soul Trapped.",
    "Text": "Unsummon a friendly creature.",
    "Keywords": "",
    "Played in": "858/30861 of  Eligible  decks (3 %)",
    "code": "dq"
  },
  {
    "Name": "Cloudrest Illusionist",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "High Elf",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Prophecy. Summon: Give a creature -4/-0 this turn.",
    "Keywords": "Prophecy",
    "Played in": "3777/12907 of  Eligible  decks (29 %)",
    "code": "dr"
  },
  {
    "Name": "Cog Collector",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 2 - Sightless Pit",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Pilfer: Add a gear to Cog Collector. Last Gasp: Summon a random [neutral] creature with cost equal to the number of gears on Cog Collector.",
    "Keywords": "Pilfer,Last Gasp",
    "Played in": "118/13695 of  Eligible  decks (1 %)",
    "code": "ds"
  },
  {
    "Name": "College of Winterhold",
    "Rarity": "Legendary - Unique",
    "Type": "Support",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Uses: 3. Activate: Reveal three random 1-cost actions and draw one. Then, increase the cost of cards this reveals by 1.",
    "Keywords": "",
    "Played in": "681/14266 of  Eligible  decks (5 %)",
    "code": "dt"
  },
  {
    "Name": "Companion Harbinger",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Beast Form: Give friendly Werwolves +1/+1.",
    "Keywords": "",
    "Played in": "287/13644 of  Eligible  decks (2 %)",
    "code": "du"
  },
  {
    "Name": "Conjuration Scholar",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Redguard",
    "Magicka Cost": "6",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Summon a 5/5 Frost Atronach with Guard.",
    "Keywords": "",
    "Played in": "964/14266 of  Eligible  decks (7 %)",
    "code": "dv"
  },
  {
    "Name": "Conjuration Tutor",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "6",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Shuffle three Lava Atronachs into your deck. When you summon an Atronach, summon a copy of it in the other lane.",
    "Keywords": "",
    "Played in": "586/14266 of  Eligible  decks (4 %)",
    "code": "dw"
  },
  {
    "Name": "Conjurer's Spirit",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Ongoing. At the end of your turn, if you gained health, summon a 2/2 Familiar.",
    "Keywords": "",
    "Played in": "216/12907 of  Eligible  decks (2 %)",
    "code": "dx"
  },
  {
    "Name": "Corinthe Brawler",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Wax: +1/+1 and your opponent can't target Corinthe Brawler with actions. Wane: Gain 1 magicka this turn for each enemy creature in this lane.",
    "Keywords": "Wax/Wane",
    "Played in": "58/13695 of  Eligible  decks (0 %)",
    "code": "wX"
  },
  {
    "Name": "Cornerclub Gambler",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "3",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: You must discard a card. At the start of your turn, draw two cards and Cornerclub Gambler loses this ability.",
    "Keywords": "",
    "Played in": "1956/13695 of  Eligible  decks (14 %)",
    "code": "dy"
  },
  {
    "Name": "Corprus Disease",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Silence a creature, then give it +2/+0.",
    "Keywords": "",
    "Played in": "172/12757 of  Eligible  decks (1 %)",
    "code": "dz"
  },
  {
    "Name": "Corrupted Shade",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Spirit",
    "Magicka Cost": "4",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Ward. At the end of your turn, if Corrupted Shade doesn't have a Ward, sacrifice it.",
    "Keywords": "Ward",
    "Played in": "625/13644 of  Eligible  decks (5 %)",
    "code": "dA"
  },
  {
    "Name": "Corsair Ship",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 2 - City Gates",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Summon a 1/1 Corsair. When you summon a creature, equip it with a Steel Dagger.",
    "Keywords": "",
    "Played in": "753/14266 of  Eligible  decks (5 %)",
    "code": "dB"
  },
  {
    "Name": "Court Wizard",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Draw a card if you have two other  creatures.",
    "Keywords": "",
    "Played in": "58/14266 of  Eligible  decks (0 %)",
    "code": "dC"
  },
  {
    "Name": "Covenant Mail",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Mobilize, Guard.\n+1/+3",
    "Keywords": "Prophecy,Mobilize,Guard",
    "Played in": "130/13644 of  Eligible  decks (1 %)",
    "code": "sL"
  },
  {
    "Name": "Covenant Marauder",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "1",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "+2/+0 while you have no cards in hand.",
    "Keywords": "",
    "Played in": "195/12757 of  Eligible  decks (2 %)",
    "code": "dD"
  },
  {
    "Name": "Covenant Masterpiece",
    "Rarity": "Epic",
    "Type": "Item",
    "Attributes": [
      "strength",
      "intelligence",
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Mobilize, Breajthrough, Regenerate, Guard, Ward. +3/+3.",
    "Keywords": "Mobilize,Breajthrough,Regenerate,Guard,Ward",
    "Played in": "76/303 of  Eligible  decks (25 %)",
    "code": "sM"
  },
  {
    "Name": "Covenant Oathman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Redguard",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: If you have a ... \n[strength] cad in play, draw a random item from your deck.\n[endurance] card in play, give an item in your hand +2/+2.",
    "Keywords": "",
    "Played in": "96/14266 of  Eligible  decks (1 %)",
    "code": "sN"
  },
  {
    "Name": "Covenant Plate",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Mobilize, Guard, +3/+1.",
    "Keywords": "Prophecy,Mobilize,Guard",
    "Played in": "251/12757 of  Eligible  decks (2 %)",
    "code": "tE"
  },
  {
    "Name": "Cradlecrush Giant",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Giant",
    "Magicka Cost": "6",
    "Attack": "6",
    "Health": "4",
    "Expansion Set": "Forgotten Hero Collection",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Deal 2 damage to all other creatures in this lane.",
    "Keywords": "",
    "Played in": "1249/12757 of  Eligible  decks (10 %)",
    "code": "dE"
  },
  {
    "Name": "Craglorn Scavenger",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Redguard",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "When you play or activate a support, give Craglorn Scavenger +1/+1.",
    "Keywords": "",
    "Played in": "35/14266 of  Eligible  decks (0 %)",
    "code": "dF"
  },
  {
    "Name": "Crassius' Favor",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon two 1/1 Imperial Grunts to a lane. Plot: Gain 1 health for each friendly creature in that lane.",
    "Keywords": "Plot",
    "Played in": "450/12907 of  Eligible  decks (3 %)",
    "code": "dG"
  },
  {
    "Name": "Craven Conscript",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "3",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Craven Conscript is permanently Shackled unless equipped with an item.",
    "Keywords": "",
    "Played in": "135/12757 of  Eligible  decks (1 %)",
    "code": "sO"
  },
  {
    "Name": "Crazed Hunger",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Daedra",
    "Magicka Cost": "2",
    "Attack": "0",
    "Health": "2",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Charge. Crazed Hunger has +2/+0 on your turn.",
    "Keywords": "Charge",
    "Played in": "70/13695 of  Eligible  decks (1 %)",
    "code": "dH"
  },
  {
    "Name": "Crocodile Brute",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Reptile",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. When Crocodile Brute is Consumed, draw a card.",
    "Keywords": "Prophecy,Consume",
    "Played in": "146/30861 of  Eligible  decks (0 %)",
    "code": "vW"
  },
  {
    "Name": "Crown Quartermaster",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Redguard",
    "Magicka Cost": "1",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Put a Steel Dagger into your hand.",
    "Keywords": "",
    "Played in": "2147/14266 of  Eligible  decks (15 %)",
    "code": "dI"
  },
  {
    "Name": "Crucible Blacksmith",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "2",
    "Attack": "0",
    "Health": "1",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Draw an item of your choice from your deck.",
    "Keywords": "",
    "Played in": "266/14266 of  Eligible  decks (2 %)",
    "code": "dJ"
  },
  {
    "Name": "Cruel Axe",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Mobilize. Summon: +1/+1 for each enemy creature in this lane.",
    "Keywords": "Mobilize",
    "Played in": "57/13644 of  Eligible  decks (0 %)",
    "code": "tH"
  },
  {
    "Name": "Cruel Firebloom",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Sacrifice a creature to deal 5 damage to a random enemy creature.",
    "Keywords": "",
    "Played in": "1881/14266 of  Eligible  decks (13 %)",
    "code": "dK"
  },
  {
    "Name": "Crusader's Assault",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "strength",
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Give a creature +2/+0, Breakthrough and “Slay and Pilfer: Draw a card” this turn.",
    "Keywords": "",
    "Played in": "2742/3994 of  Eligible  decks (69 %)",
    "code": "dL"
  },
  {
    "Name": "Crushing Blow",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Deal 3 damage.",
    "Keywords": "",
    "Played in": "4018/30861 of  Eligible  decks (13 %)",
    "code": "dM"
  },
  {
    "Name": "Crystal Tower Crafter",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "After you play an action, Crystal Tower Crafter gets +1/+1.",
    "Keywords": "",
    "Played in": "694/14266 of  Eligible  decks (5 %)",
    "code": "dO"
  },
  {
    "Name": "Cunning Ally",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Put a Firebolt into your hand if the top card of your deck is (Intelligence).",
    "Keywords": "",
    "Played in": "2210/14266 of  Eligible  decks (15 %)",
    "code": "dP"
  },
  {
    "Name": "Curse",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Give a creature -1/-1.",
    "Keywords": "",
    "Played in": "1114/13695 of  Eligible  decks (8 %)",
    "code": "dQ"
  },
  {
    "Name": "Cursed Spectre",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Spirit",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Summon: Silence another creature.",
    "Keywords": "Prophecy",
    "Played in": "520/13644 of  Eligible  decks (4 %)",
    "code": "dR"
  },
  {
    "Name": "Cygnus Standard Bearer",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Summon a 2/2 Imperial Solider for each friendly support. When you summon a support, summon a 2/2 Imperial Soldier.",
    "Keywords": "",
    "Played in": "83/12907 of  Eligible  decks (1 %)",
    "code": "wZ"
  },
  {
    "Name": "Cyriel",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Pilfer: Reduce the cost of the top card of your deck by 3.",
    "Keywords": "Pilfer",
    "Played in": "512/13703 of  Eligible  decks (4 %)",
    "code": "dS"
  },
  {
    "Name": "Daedric Crescent",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+2/+2. Slay: +1/+1.",
    "Keywords": "Slay",
    "Played in": "273/13644 of  Eligible  decks (2 %)",
    "code": "dT"
  },
  {
    "Name": "Daedric Dagger",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Lethal. +1/+1",
    "Keywords": "Lethal",
    "Played in": "687/13644 of  Eligible  decks (5 %)",
    "code": "dU"
  },
  {
    "Name": "Daedric Incursion",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Draw a random Daedra from your deck. Invade.",
    "Keywords": "Invade",
    "Played in": "80/12757 of  Eligible  decks (1 %)",
    "code": "xr"
  },
  {
    "Name": "Daedric Titan",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Daedra",
    "Magicka Cost": "5",
    "Attack": "6",
    "Health": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "While you have another creature in each lane, Daedric Titan has Drain and your opponent can't target it with actions.",
    "Keywords": "Drain",
    "Played in": "56/13695 of  Eligible  decks (0 %)",
    "code": "sR"
  },
  {
    "Name": "Daggerfall Mage",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Ward. When Daggerfall Mage's Ward is broken, put a Tome of Alteration into your hand.",
    "Keywords": "Ward",
    "Played in": "5787/14266 of  Eligible  decks (41 %)",
    "code": "dV"
  },
  {
    "Name": "Daggerfall Phantom",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "intelligence",
      "endurance"
    ],
    "Race": "Spirit",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Last Gasp: Return all items equipped to Daggerfall Phantom to your hand.",
    "Keywords": "",
    "Played in": "138/303 of  Eligible  decks (46 %)",
    "code": "ul"
  },
  {
    "Name": "Daggers in the Dark",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 1 - Murder Scene",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Equip a +1/+0 Steel Dagger to a random friendly creature in each lane.",
    "Keywords": "",
    "Played in": "168/14266 of  Eligible  decks (1 %)",
    "code": "dW"
  },
  {
    "Name": "Dagi-raht Mystic",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Pilfer: Draw a random support from your deck.",
    "Keywords": "Pilfer",
    "Played in": "709/12907 of  Eligible  decks (5 %)",
    "code": "dX"
  },
  {
    "Name": "Dagoth Dagger",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Breakthrough. +2/+1.",
    "Keywords": "Breakthrough",
    "Played in": "615/12757 of  Eligible  decks (5 %)",
    "code": "dY"
  },
  {
    "Name": "Dagoth Oathman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Ash Creature",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: if you have a ... (agility) card in play, +1/+1. (intelligence) card in play, +1/+1.",
    "Keywords": "",
    "Played in": "262/12757 of  Eligible  decks (2 %)",
    "code": "dZ"
  },
  {
    "Name": "Dagoth Ur",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "intelligence",
      "agility"
    ],
    "Race": "God",
    "Magicka Cost": "12",
    "Attack": "8",
    "Health": "8",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Breakthrough, Charge, Drain, Guard, Lethal, Ward",
    "Keywords": "Breakthrough,Charge,Drain,Guard,Lethal,Ward",
    "Played in": "540/937 of  Eligible  decks (58 %)",
    "code": "ea"
  },
  {
    "Name": "Daring Cutpurse",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Pilfer: +1/+1",
    "Keywords": "Pilfer,Prophecy",
    "Played in": "1769/13695 of  Eligible  decks (13 %)",
    "code": "eb"
  },
  {
    "Name": "Daring Heist",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 1 - Thornwell Farm",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Draw two cards. Daring Heist can't be played unless a creature in each lane damage your opponent this turn.",
    "Keywords": "",
    "Played in": "56/13695 of  Eligible  decks (0 %)",
    "code": "ec"
  },
  {
    "Name": "Dark Anchor",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Defense",
    "Magicka Cost": "5",
    "Attack": "0",
    "Health": "8",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Your Daedra cost 1 less. When you draw a creature, transform it into a random Daedra.",
    "Keywords": "",
    "Played in": "21/13644 of  Eligible  decks (0 %)",
    "code": "sS"
  },
  {
    "Name": "Dark Guardian",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "5",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 2 - Wayrest Plains",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard, When your opponent draws a Prophecy from a rune being destroyed, draw a card.",
    "Keywords": "Guard",
    "Played in": "3305/13644 of  Eligible  decks (24 %)",
    "code": "ed"
  },
  {
    "Name": "Dark Harvester",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dreugh",
    "Magicka Cost": "7",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard. Summon: Gain 4 health.",
    "Keywords": "Guard,Prophecy",
    "Played in": "712/30861 of  Eligible  decks (2 %)",
    "code": "ee"
  },
  {
    "Name": "Dark Mane",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": ["willpower", "agility"],
    "Race": "",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When you summon a creature in this lane, if it's full, Dark Mane moves. When Dark Mane moves, it gains +2/+0 and Drain this turn.",
    "Keywords": "Drain,Move",
    "code": "yY"
  },
  {
    "Name": "Dark Rebirth",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Sacrifice a creature to summon a copy of it.",
    "Keywords": "",
    "Played in": "1964/14266 of  Eligible  decks (14 %)",
    "code": "ef"
  },
  {
    "Name": "Dark Rift",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Uses: 5. Activate: Deal 1 damage to your opponent. If Dark Rift has dealt 5 damage, sacrifice it to summon a Storm Atronach.",
    "Keywords": "",
    "Played in": "313/14266 of  Eligible  decks (2 %)",
    "code": "eg"
  },
  {
    "Name": "Dark Seducer",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Daedra",
    "Magicka Cost": "8",
    "Attack": "7",
    "Health": "7",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Drain, Guard. Dark Seducer Drains on both turns.",
    "Keywords": "Drain,Guard",
    "Played in": "660/13644 of  Eligible  decks (5 %)",
    "code": "eh"
  },
  {
    "Name": "Dawn's Wrath",
    "Rarity": "Legendary",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "8",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Destroy all creatures in a lane.",
    "Keywords": "",
    "Played in": "2541/12907 of  Eligible  decks (20 %)",
    "code": "ei"
  },
  {
    "Name": "Dawnbreaker",
    "Rarity": "Legendary - Unique",
    "Type": "Item",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "+4/+4. Slay: Banish the slain creature if it's Undead.",
    "Keywords": "",
    "Played in": "2930/12916 of  Eligible  decks (23 %)",
    "code": "ej"
  },
  {
    "Name": "Dawnfang",
    "Rarity": "Legendary - Unique",
    "Type": "Item",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "+0/+3. At the end of your turn, if Dawnfang is in your hand, change it into Duskfang. Slay: You gain 5 health.",
    "Keywords": "Slay",
    "Played in": "384/30872 of  Eligible  decks (1 %)",
    "code": "ek"
  },
  {
    "Name": "Dawnstar Healer",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "After an enemy rune is destroyed, gain 3 health.",
    "Keywords": "",
    "Played in": "906/12907 of  Eligible  decks (7 %)",
    "code": "el"
  },
  {
    "Name": "Dead Drop",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Give a friendly creature \"Slay: Put a Completed Contract into your hand\" this turn. It may move to attack creatures in the other lane this turn.",
    "Keywords": "",
    "Played in": "20/13695 of  Eligible  decks (0 %)",
    "code": "yw"
  },
  {
    "Name": "Deadly Draugr",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Lethal",
    "Keywords": "Lethal",
    "Played in": "839/13644 of  Eligible  decks (6 %)",
    "Evolves from:": "Rotting Draugr",
    "code": "em"
  },
  {
    "Name": "Death Hound",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Beast",
    "Magicka Cost": "5",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "FrostSpark Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. Death Hound's power is equal to its health.",
    "Keywords": "Guard",
    "Played in": "67/13644 of  Eligible  decks (0 %)",
    "code": "en"
  },
  {
    "Name": "Death Scythe",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "intelligence",
      "agility",
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Tamriel Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Drain. Deal damage to a creature equal to the number of creatures that died this turn.",
    "Keywords": "Drain",
    "Played in": "3/1118 of  Eligible  decks (0 %)",
    "code": "Bk"
  },
  {
    "Name": "Deathless Draugr",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Last Gasp; Summon a 1/1 Skeleton.",
    "Keywords": "Last Gasp",
    "Played in": "421/13644 of  Eligible  decks (3 %)",
    "Evolves from:": "Rotting Draugr",
    "code": "eo"
  },
  {
    "Name": "Debilitate",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Give all crateures -2/-2. Empower: Costs 1 less.",
    "Keywords": "Empower",
    "Played in": "410/13695 of  Eligible  decks (3 %)",
    "code": "uz"
  },
  {
    "Name": "Deepwood Trapper",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. Shackle creatures damaged by Deepwood Trapper.",
    "Keywords": "Guard",
    "Played in": "743/13695 of  Eligible  decks (5 %)",
    "code": "ep"
  },
  {
    "Name": "Defense of Bruma",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Costs 2 less for each friendly creature with 5 or more health. Give friendly creatures +1/+1 and Guard.",
    "Keywords": "Guard",
    "Played in": "50/12907 of  Eligible  decks (0 %)",
    "code": "yj"
  },
  {
    "Name": "Deranged Corprus",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Ash Creature",
    "Magicka Cost": "2",
    "Attack": "0",
    "Health": "1",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Deranged Corprus has +5/+0 on your turn.",
    "Keywords": "",
    "Played in": "132/13695 of  Eligible  decks (1 %)",
    "code": "eq"
  },
  {
    "Name": "Descendant of Alkosh",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Pilfer: Descendant of Alkosh gains +1/+1 and a random keyword.",
    "Keywords": "Pilfer",
    "Played in": "784/12907 of  Eligible  decks (6 %)",
    "code": "er"
  },
  {
    "Name": "Deshaan Avenger",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Last Gasp: Summon a 3/3 Deshaan Sneak.",
    "Keywords": "Last Gasp",
    "Played in": "586/13695 of  Eligible  decks (4 %)",
    "Evolves from:": "Deshaan Sneak",
    "code": "es"
  },
  {
    "Name": "Desperate Conjuring",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Sacrifice a creature to summon a random creature that costs 2 more.",
    "Keywords": "",
    "Played in": "694/14266 of  Eligible  decks (5 %)",
    "code": "eu"
  },
  {
    "Name": "Destruction Tutor",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "FrostSpark Collection",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Your actions that deal damage costs 2 less.",
    "Keywords": "",
    "Played in": "77/14266 of  Eligible  decks (1 %)",
    "code": "ev"
  },
  {
    "Name": "Determined Supplier",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Breton",
    "Magicka Cost": "4",
    "Attack": "1",
    "Health": "4",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard. Last Gasp: Gain max magicka equal to Determined Supplier's power.",
    "Keywords": "Guard",
    "Played in": "82/13644 of  Eligible  decks (1 %)",
    "code": "yt"
  },
  {
    "Name": "Devious Bandit",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "6",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Deal 3 damage to your opponent and you gain 3 health. Devious Bandit has the Pilfer abilities of all your creatures.",
    "Keywords": "Pilfer",
    "Played in": "71/13695 of  Eligible  decks (1 %)",
    "code": "wj"
  },
  {
    "Name": "Devour",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Destroy a creature with 4 power or less and give its Keywords to a random Dragon in your hand.",
    "Keywords": "",
    "Played in": "846/12916 of  Eligible  decks (7 %)",
    "code": "ex"
  },
  {
    "Name": "Devouring Flame",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Deal 2 damage to a creature. If this would kill it, instead Banish it.",
    "Keywords": "",
    "Played in": "32/12757 of  Eligible  decks (0 %)",
    "code": "wS"
  },
  {
    "Name": "Discerning Thief",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Pilfer: Draw a card, then discard a card.",
    "Keywords": "Pilfer",
    "Played in": "286/14266 of  Eligible  decks (2 %)",
    "code": "vK"
  },
  {
    "Name": "Disciple of Namira",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the end of each turn, draw a card for each friendly creature that died in Disciple of Namira's lane.",
    "Keywords": "",
    "Played in": "565/13644 of  Eligible  decks (4 %)",
    "code": "ey"
  },
  {
    "Name": "Dismantle",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Destroy an enemy support or (neutral) creature.",
    "Keywords": "",
    "Played in": "248/30872 of  Eligible  decks (1 %)",
    "code": "ez"
  },
  {
    "Name": "Divayth Fyr",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "11",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Deal 6 damage to a random enemy. At the start of your turn, Divayth Fyr summons a Daughter of Fyr.",
    "Keywords": "",
    "Played in": "535/14266 of  Eligible  decks (4 %)",
    "code": "eA"
  },
  {
    "Name": "Divayth's Experiments",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "intelligence",
      "agility",
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "9",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Betray. Summon a copy of a friendly creature.",
    "Keywords": "Betray",
    "Played in": "458/1118 of  Eligible  decks (41 %)",
    "code": "eB"
  },
  {
    "Name": "Dive Rock Fall",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Banish a creature with 0 power.",
    "Keywords": "",
    "Played in": "5/12907 of  Eligible  decks (0 %)",
    "code": "xH"
  },
  {
    "Name": "Divine Fervor",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Friendly creatures have +1/+1.",
    "Keywords": "",
    "Played in": "4195/12907 of  Eligible  decks (33 %)",
    "Evolves from:": "Divine Conviction",
    "code": "eD"
  },
  {
    "Name": "Dominion Battlereeve",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "willpower",
      "agility"
    ],
    "Race": "High Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Drain. Summon, Last Gasp and Slay: Deal 1 damage to your opponent.",
    "Keywords": "Drain,Last Gasp,Slay",
    "Played in": "270/307 of  Eligible  decks (88 %)",
    "code": "sy"
  },
  {
    "Name": "Dominion Oathman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "High Elf",
    "Magicka Cost": "1",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: If you have a... \n[willpower] card in play, Drain.\n[intelligence] card in play, deal 2 damage to your opponent",
    "Keywords": "Drain",
    "Played in": "224/13695 of  Eligible  decks (2 %)",
    "code": "sU"
  },
  {
    "Name": "Doomcrag Vampire",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Vampire",
    "Magicka Cost": "6",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Friendly creatures in this lane have Lethal.",
    "Keywords": "Lethal",
    "Played in": "609/13644 of  Eligible  decks (4 %)",
    "code": "eE"
  },
  {
    "Name": "Doomed Adventurer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Last Gasp: Give a random creature in your hand +2/+2.",
    "Keywords": "Last Gasp",
    "Played in": "112/13644 of  Eligible  decks (1 %)",
    "code": "ys"
  },
  {
    "Name": "Doomfang Ally",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Reachman",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: If the top card of your deck is... [strength]: +2/+0, [intelligence]: Ward, [willpower]: Drain, [agility]: Lethal, [endurance]: +0/+2.",
    "Keywords": "",
    "Played in": "308/30861 of  Eligible  decks (1 %)",
    "code": "eF"
  },
  {
    "Name": "Doppelganger",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Daedra",
    "Magicka Cost": "5",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Forgotten Hero Collection",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Transform Doppelganger into a copy of another friendly creature.",
    "Keywords": "",
    "Played in": "953/14271 of  Eligible  decks (7 %)",
    "code": "eG"
  },
  {
    "Name": "Dormant Centurion",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 2 - College of Winterhold",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Dormant Centurion can't attack unless you've played an action this turn.",
    "Keywords": "",
    "Played in": "40/30861 of  Eligible  decks (0 %)",
    "code": "eH"
  },
  {
    "Name": "Dovah of the Voice",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dragon",
    "Magicka Cost": "7",
    "Attack": "6",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Last Gasp: Put a random Shout into your hand.",
    "Keywords": "Last Gasp",
    "Played in": "362/13695 of  Eligible  decks (3 %)",
    "code": "eI"
  },
  {
    "Name": "Dragonfire Wizard",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": ["willpower", "intelligence"],
    "Race": "Imperial",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the end of your turn, add a flame to Dragonfire Wizard. Last Gasp: Put a Flame Lash into your hand that deals damage and gains health equal to the number of flames on Dagonfire Wizard.",
    "Keywords": "Last Gasp",
    "code": "yR"
  },
  {
    "Name": "Dragon Aspect",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 2 - Mount Anthor",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Level 1: You gain 3 health and Battle an enemy creature as if you had 3 power. \nLevel 2: You gain 5 health and Battle an enemy creature as if you had 5 power.\nLevel 3: You gain 7 health and Battle an enemy creature as if you had 7 power.",
    "Keywords": "",
    "Played in": "458/30861 of  Eligible  decks (1 %)",
    "code": "eJ"
  },
  {
    "Name": "Dragon Cult Ghost",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Spirit",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Spend all your available magicka to play Dragon Cult Ghost. Its power and health are equal to the magicka spent.",
    "Keywords": "",
    "Played in": "415/13644 of  Eligible  decks (3 %)",
    "code": "eK"
  },
  {
    "Name": "Dragon Mound",
    "Rarity": "Legendary - Unique",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Ongoing. Summon: Transform all cards in your deck into random Dragons. Your Dragons cost 1 less.",
    "Keywords": "",
    "Played in": "253/30861 of  Eligible  decks (1 %)",
    "code": "eL"
  },
  {
    "Name": "Dragon Priest Mask",
    "Rarity": "Epic",
    "Type": "Item",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "+2/+2 Summon: Trigger the wielder's summon ability.",
    "Keywords": "",
    "Played in": "511/14266 of  Eligible  decks (4 %)",
    "code": "eM"
  },
  {
    "Name": "Dragon's Fury",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Deal 3 damage to a creature, and 3 extra damage for each friendly Dragon.",
    "Keywords": "",
    "Played in": "138/14266 of  Eligible  decks (1 %)",
    "code": "eN"
  },
  {
    "Name": "Dragonguard Outcast",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Imperial",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Dragonguard Outcast gains Cover until she attacks.",
    "Keywords": "Lethal",
    "Played in": "50/13695 of  Eligible  decks (0 %)",
    "code": "sV"
  },
  {
    "Name": "Dragonplate Armor",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+2/+2. Summon: +2/+2 if you have a Dragon in your discard pile.",
    "Keywords": "",
    "Played in": "223/13644 of  Eligible  decks (2 %)",
    "code": "eO"
  },
  {
    "Name": "Dragonstar Rider",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Redguard",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When Dragonstar Rider equips an item, draw a card.",
    "Keywords": "",
    "Played in": "329/14266 of  Eligible  decks (2 %)",
    "code": "eP"
  },
  {
    "Name": "Dragontail Savior",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Orc",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: +1/+0 for each enemy creature in this lane.",
    "Keywords": "",
    "Played in": "1087/13644 of  Eligible  decks (8 %)",
    "code": "eQ"
  },
  {
    "Name": "Drain Blood",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Betray. Give a creature -2/-2.",
    "Keywords": "Betray",
    "Played in": "201/13695 of  Eligible  decks (1 %)",
    "code": "eR"
  },
  {
    "Name": "Drain Vitality",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Level 1: Give an enemy creature -1/-1.\nLevel 2: Give an enemy creature -2/-2. \nLevel 3: Give all enemy creatures in a lane -2/-2.",
    "Keywords": "",
    "Played in": "2124/13695 of  Eligible  decks (16 %)",
    "code": "eS"
  },
  {
    "Name": "Dread Clannfear",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Daedra",
    "Magicka Cost": "6",
    "Attack": "6",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: All enemy creatures lose Guard.",
    "Keywords": "Guard",
    "Played in": "72/12757 of  Eligible  decks (1 %)",
    "code": "eT"
  },
  {
    "Name": "Dremora Adept",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Daedra",
    "Magicka Cost": "3",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "When Dremora Adept gains a Keyword, Invade.",
    "Keywords": "",
    "Played in": "62/14266 of  Eligible  decks (0 %)",
    "code": "xF"
  },
  {
    "Name": "Dremora Archer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Daedra",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy. Summon: Deal damage to a creature equal to Dremora Archer's power.",
    "Keywords": "Prophecy",
    "Played in": "27/12757 of  Eligible  decks (0 %)",
    "code": "xw"
  },
  {
    "Name": "Dremora Channeler",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Daedra",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Summon: You gain health equal to Dremora Channeler's power plus health.",
    "Keywords": "Prophecy",
    "Played in": "96/12907 of  Eligible  decks (1 %)",
    "code": "xE"
  },
  {
    "Name": "Dremora Markynaz",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Daedra",
    "Magicka Cost": "10",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Guard. Summon: Double a creature's power and health.",
    "Keywords": "Guard",
    "Played in": "251/12757 of  Eligible  decks (2 %)",
    "code": "eU"
  },
  {
    "Name": "Dren Bodyguard",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard",
    "Keywords": "Guard",
    "Played in": "108/12907 of  Eligible  decks (1 %)",
    "code": "eV"
  },
  {
    "Name": "Dres Renegade",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard. Other friendly creatures can't be Shackled.",
    "Keywords": "Guard",
    "Played in": "671/14266 of  Eligible  decks (5 %)",
    "Evolves from:": "Dres Guard",
    "code": "eX"
  },
  {
    "Name": "Dres Spy",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "0",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Look at the top card of your deck. You may discard it.",
    "Keywords": "",
    "Played in": "246/13695 of  Eligible  decks (2 %)",
    "code": "eY"
  },
  {
    "Name": "Dres Tormentor",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "When an enemy becomes Shackled, deal 3 damage to it.",
    "Keywords": "",
    "Played in": "471/14266 of  Eligible  decks (3 %)",
    "Evolves from:": "Dres Guard",
    "code": "eZ"
  },
  {
    "Name": "Dreugh Shell Armor",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "+3/+3",
    "Keywords": "",
    "Played in": "226/30861 of  Eligible  decks (1 %)",
    "Evolves from:": "Snapping Dreugh",
    "code": "fa"
  },
  {
    "Name": "Drive Mad",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "A creature Battles itself.",
    "Keywords": "",
    "Played in": "234/12757 of  Eligible  decks (2 %)",
    "code": "fb"
  },
  {
    "Name": "Dro-m'Athra Reaper",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Consume a creature. When a creature leaves your discard pile, Dro-m'Athra Reaper gains +0/+1 and you gain 1 health.",
    "Keywords": "Consume",
    "Played in": "106/13644 of  Eligible  decks (1 %)",
    "code": "wy"
  },
  {
    "Name": "Duel Atop the World",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Give a friendly creature +3/+3. It Battles your opponent's most powerful creature.",
    "Keywords": "",
    "Played in": "129/12757 of  Eligible  decks (1 %)",
    "code": "fd"
  },
  {
    "Name": "Duke Vedam Dren",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "willpower",
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "5",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "The first time you play a card each turn, draw a random card from your deck with cost equal to your remaining magicka.",
    "Keywords": "",
    "Played in": "402/861 of  Eligible  decks (47 %)",
    "code": "ff"
  },
  {
    "Name": "Duneripper",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": ["strength", "agility"],
    "Race": "Beast",
    "Attack": "4",
    "Health": "3",
    "Magicka Cost": "5",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When Duneripper enters a lane, it deals 2 damage to an enemy creature in the lane. Pilfer: Move.",
    "Keywords": "Pilfer,Move",
    "code": "yK"
  },
  {
    "Name": "Dune Smuggler",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Move another friendly creature in this lane. When a friendly creature moves, give it +1/+1.",
    "Keywords": "",
    "Played in": "1102/13695 of  Eligible  decks (8 %)",
    "Evolves from:": "Dune Rogue",
    "code": "fh"
  },
  {
    "Name": "Dune Stalker",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy. Summon: Move another friendly creature in this lane.",
    "Keywords": "Prophecy",
    "Played in": "628/13695 of  Eligible  decks (5 %)",
    "Evolves from:": "Dune Rogue",
    "code": "fi"
  },
  {
    "Name": "Dunmer Nightblade",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Last Gasp: Put an Iron Sword into your hand.",
    "Keywords": "Last Gasp",
    "Played in": "485/14266 of  Eligible  decks (3 %)",
    "code": "fk"
  },
  {
    "Name": "Dunmer Tyro",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Charge. Veteran: +2/+0.",
    "Keywords": "Charge,Veteran",
    "Played in": "95/13695 of  Eligible  decks (1 %)",
    "code": "sW"
  },
  {
    "Name": "Dushnikh Yal Archer",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. Summon: Deal 1 damage or destroy an enemy support.",
    "Keywords": "Guard",
    "Played in": "2680/12757 of  Eligible  decks (21 %)",
    "code": "fl"
  },
  {
    "Name": "Dust Eater Skirmisher",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Goblin",
    "Magicka Cost": "1",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "When Dust Eater Skirmisher takes damage from a creature, give that creature -1/-1.",
    "Keywords": "",
    "Played in": "85/13695 of  Eligible  decks (1 %)",
    "code": "xz"
  },
  {
    "Name": "Dwarven Armaments",
    "Rarity": "Epic",
    "Type": "Item",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "+5/+5",
    "Keywords": "",
    "Played in": "196/30861 of  Eligible  decks (1 %)",
    "code": "fm"
  },
  {
    "Name": "Dwarven Ballista",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Breakthrough",
    "Keywords": "Breakthrough",
    "Played in": "151/30861 of  Eligible  decks (0 %)",
    "code": "fn"
  },
  {
    "Name": "Dwarven Centurion",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "7",
    "Attack": "6",
    "Health": "8",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Brekathrough. When Dwarven Centurion is dealt damage, draw a 0/3 Dwarven Spider with Guard.",
    "Keywords": "Guard",
    "Played in": "393/30861 of  Eligible  decks (1 %)",
    "code": "fo"
  },
  {
    "Name": "Dwarven Colossus",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "11",
    "Attack": "11",
    "Health": "11",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 4 - The Inner Curiosity",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Summon a Power Sphere in each lane.",
    "Keywords": "",
    "Played in": "333/30861 of  Eligible  decks (1 %)",
    "code": "fp"
  },
  {
    "Name": "Dwarven Dynamo",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Give another (Neutral) creature +3/+3 and Guard.",
    "Keywords": "",
    "Played in": "621/30861 of  Eligible  decks (2 %)",
    "code": "fq"
  },
  {
    "Name": "Dwarven Sphere",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Shackle an enemy creature.",
    "Keywords": "",
    "Played in": "708/30861 of  Eligible  decks (2 %)",
    "code": "fr"
  },
  {
    "Name": "Dwarven Spider",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "0",
    "Attack": "0",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard",
    "Keywords": "Guard",
    "Played in": "392/30861 of  Eligible  decks (1 %)",
    "code": "fs"
  },
  {
    "Name": "Dwemer Puzzle Box",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Uses: 3. Activate: Discard the top card of your deck. Last Gasp: Draw a card.",
    "Keywords": "Last Gasp",
    "Played in": "100/30861 of  Eligible  decks (0 %)",
    "code": "ft"
  },
  {
    "Name": "Eager Torturer",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Imperial",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "When you sacrifice a creature, Eager Torturer gains +2/+2.",
    "Keywords": "",
    "Played in": "40/13695 of  Eligible  decks (0 %)",
    "code": "fu"
  },
  {
    "Name": "Earthbone Spinner",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Silence another creature, then deal 1 damage to it.",
    "Keywords": "",
    "Played in": "4566/12757 of  Eligible  decks (36 %)",
    "code": "fv"
  },
  {
    "Name": "East Empire Crafter",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "When you summon another creature with 5 health or more, give it +1/+1 and Guard.",
    "Keywords": "Guard",
    "Played in": "464/13644 of  Eligible  decks (3 %)",
    "code": "fw"
  },
  {
    "Name": "Eastmarch Crusader",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "4",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Draw a card if an enemy rune has been destroyed this game.",
    "Keywords": "",
    "Played in": "3612/12907 of  Eligible  decks (28 %)",
    "code": "fx"
  },
  {
    "Name": "Ebonheart Oracle",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Drain. Double the amount of health you gain.",
    "Keywords": "Drain",
    "Played in": "526/12907 of  Eligible  decks (4 %)",
    "code": "fy"
  },
  {
    "Name": "Ebonthread Cloak",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Mobilize. +1/+2. Summon: Your opponent can't target the wielder with actions until your next turn.",
    "Keywords": "Mobilize",
    "Played in": "166/12757 of  Eligible  decks (1 %)",
    "code": "sK"
  },
  {
    "Name": "Echo of Akatosh",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dragon",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "When you draw a creature, give it a random Keyword.",
    "Keywords": "",
    "Played in": "260/14266 of  Eligible  decks (2 %)",
    "code": "fz"
  },
  {
    "Name": "Eclipse Baroness",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "8",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 5 - Eclipse Hideout",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon and Last Gasp: Draw a card and reduce its cost by 2.",
    "Keywords": "Last Gasp",
    "Played in": "2997/13695 of  Eligible  decks (22 %)",
    "code": "fA"
  },
  {
    "Name": "Edict of Azura",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "willpower",
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Destroy an enemy creature or support card.",
    "Keywords": "",
    "Played in": "3283/4355 of  Eligible  decks (75 %)",
    "code": "fB"
  },
  {
    "Name": "Elder Centaur",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Centaur",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "After Elder Centaur attacks, give it Cover.",
    "Keywords": "",
    "Played in": "38/13695 of  Eligible  decks (0 %)",
    "code": "fC"
  },
  {
    "Name": "Eldergleam Matron",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Spriggan",
    "Magicka Cost": "3",
    "Attack": "4",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Put a random Animal into your hand.",
    "Keywords": "",
    "Played in": "809/13695 of  Eligible  decks (6 %)",
    "code": "fD"
  },
  {
    "Name": "Elixir of Conflict",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Uses: 3. Activate: Give a creature +1/+1.",
    "Keywords": "",
    "Played in": "123/30861 of  Eligible  decks (0 %)",
    "code": "fE"
  },
  {
    "Name": "Elixir of Deflection",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Uses: 3. Activate: Give a creature Ward.",
    "Keywords": "Ward",
    "Played in": "357/14266 of  Eligible  decks (3 %)",
    "code": "fF"
  },
  {
    "Name": "Elixir of Light Feet",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Uses: 3. Activate: Give a creature Cover.",
    "Keywords": "",
    "Played in": "99/13695 of  Eligible  decks (1 %)",
    "code": "fG"
  },
  {
    "Name": "Elixir of Potency",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Uses: 3. Activate: Give a creature a random Keyword.",
    "Keywords": "",
    "Played in": "13/14266 of  Eligible  decks (0 %)",
    "code": "xV"
  },
  {
    "Name": "Elixir of Vigor",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Uses: 3. Activate: Give a creature +0/+1.",
    "Keywords": "",
    "Played in": "23/13644 of  Eligible  decks (0 %)",
    "code": "fI"
  },
  {
    "Name": "Elixir of Vitality",
    "Rarity": "Common",
    "Type": "Support",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Uses: 3. Activate: Gain 2 health.",
    "Keywords": "",
    "Played in": "629/12907 of  Eligible  decks (5 %)",
    "code": "fJ"
  },
  {
    "Name": "Elixir of the Defender",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Uses: 3. Activate: Give a friendly creature Guard.",
    "Keywords": "Guard",
    "Played in": "145/12907 of  Eligible  decks (1 %)",
    "code": "fH"
  },
  {
    "Name": "Elsweyr Lookout",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Pilfer: Double Elsweyr Lookout's power and health.",
    "Keywords": "Pilfer",
    "Played in": "169/12907 of  Eligible  decks (1 %)",
    "code": "fK"
  },
  {
    "Name": "Elusive Schemer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Draw a card. Last Gasp: Shuffle a 0-cost Elusive Schemer into your deck.",
    "Keywords": "Last Gasp",
    "Played in": "3441/14266 of  Eligible  decks (24 %)",
    "code": "fL"
  },
  {
    "Name": "Embassy Disguise",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "+0/+1. Summon: Draw a card. The wielder has Cover until it attacks.",
    "Keywords": "",
    "Played in": "376/13695 of  Eligible  decks (3 %)",
    "code": "fM"
  },
  {
    "Name": "Embassy Guard",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "2",
    "Attack": "0",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard, Ward",
    "Keywords": "Prophecy,Guard,Ward",
    "Played in": "320/14266 of  Eligible  decks (2 %)",
    "code": "fN"
  },
  {
    "Name": "Emeric's Warlord",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Your items have Mobilize. When a friendly Recruit equips an item, Emeric's Warlord gains +1/+0.",
    "Keywords": "Mobilize",
    "Played in": "29/14266 of  Eligible  decks (0 %)",
    "code": "tz"
  },
  {
    "Name": "Emeric, Covenant King",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "intelligence",
      "endurance"
    ],
    "Race": "Breton",
    "Magicka Cost": "9",
    "Attack": "7",
    "Health": "7",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "At the end of your turn, Emeric gains a Ward. Summon: Battle an enemy creature.",
    "Keywords": "Ward",
    "Played in": "159/303 of  Eligible  decks (52 %)",
    "code": "sZ"
  },
  {
    "Name": "Emperor Titus Mede II",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "1",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "At the end of your turn, give the top creature of your deck +1/+1 and Guard.",
    "Keywords": "",
    "Played in": "300/13644 of  Eligible  decks (2 %)",
    "code": "fO"
  },
  {
    "Name": "Emperor's Attendant",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Redguard",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Give a creature in your hand power and health equal to Emperor's Attendant's power.",
    "Keywords": "",
    "Played in": "88/13644 of  Eligible  decks (1 %)",
    "code": "yF"
  },
  {
    "Name": "Emperor's Blade",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower",
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "5",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. Slay: Gain 3 health.",
    "Keywords": "Guard,Slay",
    "Played in": "1284/4355 of  Eligible  decks (29 %)",
    "code": "fP"
  },
  {
    "Name": "Empire Dreadmage",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Imperial",
    "Magicka Cost": "7",
    "Attack": "7",
    "Health": "5",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: If you have another creature in each lane, give a creature -2/-2.",
    "Keywords": "",
    "Played in": "35/13695 of  Eligible  decks (0 %)",
    "code": "tr"
  },
  {
    "Name": "Empire Oathman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: If you have a ...\n[agility] card in play, give other friendly creatures +1/+0.\n[willpower] card in play, give other friendly creatures +0/+1.",
    "Keywords": "",
    "Played in": "103/13644 of  Eligible  decks (1 %)",
    "code": "sQ"
  },
  {
    "Name": "Empire Recruiter",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower",
      "agility",
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Pilfer: Summon a 1/1 Recruit in the other lane.",
    "Keywords": "Pilfer",
    "Played in": "167/356 of  Eligible  decks (47 %)",
    "code": "ts"
  },
  {
    "Name": "Enamor's Keeper",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Exalt 4: Equip a +5/+0 Heirloom Greatsword to Enamor's Keeper.",
    "Keywords": "Exalt",
    "Played in": "207/14266 of  Eligible  decks (1 %)",
    "code": "fQ"
  },
  {
    "Name": "Enchanted Plate",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+0/+3. Summon: Draw a card.",
    "Keywords": "",
    "Played in": "1251/13644 of  Eligible  decks (9 %)",
    "code": "fR"
  },
  {
    "Name": "Enchanted Ring",
    "Rarity": "Epic",
    "Type": "Item",
    "Attributes": [
      "strength",
      "intelligence",
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Tamriel Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Mobilize. +1/+1. Summon: Equip the wielder with all copies of Enchanted Ring from your discard pile. Then if the wielder has three or more items, draw a card.",
    "Keywords": "",
    "Played in": "5/303 of  Eligible  decks (2 %)",
    "code": "Bc"
  },
  {
    "Name": "Encumbered Explorer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "1",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Shackle Encumbered Explorer after he attacks.",
    "Keywords": "",
    "Played in": "112/13644 of  Eligible  decks (1 %)",
    "code": "fS"
  },
  {
    "Name": "Enlistment Officer",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Imperial",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Give friendly Recruits +1/+1.",
    "Keywords": "",
    "Played in": "45/30861 of  Eligible  decks (0 %)",
    "code": "tc"
  },
  {
    "Name": "Enraged Dragonknight",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Consume a creature to deal 2 damage to each player.",
    "Keywords": "Consume",
    "Played in": "145/12757 of  Eligible  decks (1 %)",
    "code": "wT"
  },
  {
    "Name": "Enraged Mudcrab",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Mudcrab",
    "Magicka Cost": "1",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "186/30861 of  Eligible  decks (1 %)",
    "code": "fT"
  },
  {
    "Name": "Euraxia Tharn",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "willpower",
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "9",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Steal an enemy creature or support. Last Gasp: Your opponent steals it back.",
    "Keywords": "Last Gasp",
    "Played in": "123/4355 of  Eligible  decks (3 %)",
    "code": "wb"
  },
  {
    "Name": "Euraxian Berserker",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Imperial",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Consume a creature to gain +2/+0.",
    "Keywords": "Consume",
    "Played in": "62/12757 of  Eligible  decks (0 %)",
    "code": "we"
  },
  {
    "Name": "Evermore Steward",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard, Ward",
    "Keywords": "Guard,Ward",
    "Played in": "691/14266 of  Eligible  decks (5 %)",
    "code": "fU"
  },
  {
    "Name": "Excavate",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 6 - Return to The Inner Curiosity",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Draw an item or support from your discard pile.",
    "Keywords": "",
    "Played in": "317/14271 of  Eligible  decks (2 %)",
    "code": "fV"
  },
  {
    "Name": "Execute",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Destroy a creature with 2 power or less.",
    "Keywords": "",
    "Played in": "4663/12907 of  Eligible  decks (36 %)",
    "code": "fW"
  },
  {
    "Name": "Explore",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Attack": "0",
    "Health": "0",
    "Expansion Set": "Tamriel Collection",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Choose creature, item, action or support. Put a random card of that type into your hand.",
    "Keywords": "",
    "Played in": "14/12759 of  Eligible  decks (0 %)",
    "code": "Bf"
  },
  {
    "Name": "Expunge",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Heal a creature and give it immune to Shackle this turn. Draw a card.",
    "Keywords": "",
    "Played in": "76/13651 of  Eligible  decks (1 %)",
    "code": "wD"
  },
  {
    "Name": "Fabricate",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 5 - The Tools",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Build a custom creature and put it into your hand.",
    "Keywords": "",
    "Played in": "385/30872 of  Eligible  decks (1 %)",
    "code": "fY"
  },
  {
    "Name": "Faded Wraith",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Spirit",
    "Magicka Cost": "5",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Draw cards equal to Faded Wraith's power.",
    "Keywords": "",
    "Played in": "129/13644 of  Eligible  decks (1 %)",
    "code": "yz"
  },
  {
    "Name": "Falinesti Reaver",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "agility"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "8",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Destroy all wounded enemy creatures in this lane.",
    "Keywords": "",
    "Played in": "239/4477 of  Eligible  decks (5 %)",
    "code": "fZ"
  },
  {
    "Name": "Falkreath Defiler",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 3 - Hall of the Dead",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Slay: Draw a creature from your discard pile.",
    "Keywords": "Slay",
    "Played in": "1302/13644 of  Eligible  decks (10 %)",
    "code": "ga"
  },
  {
    "Name": "Fallen Dragon",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Dragon",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "10",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Fallen Dragon deals 5 damage to itself.",
    "Keywords": "",
    "Played in": "45/13644 of  Eligible  decks (0 %)",
    "code": "wK"
  },
  {
    "Name": "Falling Wizard",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "2",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Falling Wizard deals 5 damage to himself. Last Gasp: Draw an Experimental Scroll.",
    "Keywords": "Last Gasp",
    "Played in": "85/14266 of  Eligible  decks (1 %)",
    "code": "gb"
  },
  {
    "Name": "False Incarnate",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Your opponent can't gain health.",
    "Keywords": "",
    "Played in": "171/12757 of  Eligible  decks (1 %)",
    "code": "gc"
  },
  {
    "Name": "Farsight Nereid",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Nereid",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Reveal the top card of the opponent's deck.",
    "Keywords": "",
    "Played in": "36/14266 of  Eligible  decks (0 %)",
    "code": "gd"
  },
  {
    "Name": "Fate Weaver",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Nereid",
    "Magicka Cost": "6",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy. Summon: Draw a card. If it has Prophecy you may play it for free.",
    "Keywords": "Prophecy",
    "Played in": "1256/14266 of  Eligible  decks (9 %)",
    "Evolves from:": "Fate's Witness",
    "code": "ge"
  },
  {
    "Name": "Fear Totem",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Unsummon a creature and reduce its cost by 3.",
    "Keywords": "Prophecy",
    "Played in": "133/12757 of  Eligible  decks (1 %)",
    "code": "ws"
  },
  {
    "Name": "Fearless Northlander",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Breakthrough. When Fearless Northlander takes damage, he gains +2/+0.",
    "Keywords": "Breakthrough",
    "Played in": "291/12757 of  Eligible  decks (2 %)",
    "code": "gg"
  },
  {
    "Name": "Feasting Hunger",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Daedra",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard. Summon: You gain 1 health for each enemy creature.",
    "Keywords": "Guard",
    "Played in": "398/12907 of  Eligible  decks (3 %)",
    "code": "gh"
  },
  {
    "Name": "Feasting Vulture",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Beast",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: +2/+2 if a creature died this turn.",
    "Keywords": "",
    "Played in": "184/13695 of  Eligible  decks (1 %)",
    "code": "gi"
  },
  {
    "Name": "Feed",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Tamriel Collection",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Destroy a creature and give its Kewords to a friendly creature.",
    "Keywords": "",
    "Played in": "13/12916 of  Eligible  decks (0 %)",
    "code": "Bi"
  },
  {
    "Name": "Fell the Mighty",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 3 - Hilltop Shrine",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Destroy a creature with 4 power or more.",
    "Keywords": "",
    "Played in": "1713/12757 of  Eligible  decks (13 %)",
    "code": "gj"
  },
  {
    "Name": "Felldew/Elytra Noble",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "118/13695 of  Eligible  decks (1 %)",
    "code": "gk"
  },
  {
    "Name": "Ferocious Dreugh",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dreugh",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "72/30861 of  Eligible  decks (0 %)",
    "code": "gl"
  },
  {
    "Name": "Fetcherfly Golem",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Daedra",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When Fetcherfly Golem takes damage and survives, summon a 2/2 Fetcherfly Swarm.",
    "Keywords": "",
    "Played in": "149/12757 of  Eligible  decks (1 %)",
    "code": "gm"
  },
  {
    "Name": "Fharun Defender",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Orc",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard",
    "Keywords": "Guard,Prophecy",
    "Played in": "921/13644 of  Eligible  decks (7 %)",
    "code": "gn"
  },
  {
    "Name": "Fiery Imp",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Imp",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "When Fiery Imp attacks, deal 2 damage to your opponent.",
    "Keywords": "",
    "Played in": "1144/12757 of  Eligible  decks (9 %)",
    "code": "go"
  },
  {
    "Name": "Fifth Legion Trainer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "When you summon another creature, give it +1/+0.",
    "Keywords": "",
    "Played in": "3735/12907 of  Eligible  decks (29 %)",
    "code": "gp"
  },
  {
    "Name": "Fighters Guild Berserker",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "3",
    "Attack": "4",
    "Health": "2",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Expertise: Deal 2 damage to your opponent.",
    "Keywords": "",
    "Played in": "96/12757 of  Eligible  decks (1 %)",
    "code": "tn"
  },
  {
    "Name": "Fighters Guild Elite",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "5",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Expertise: Double Fighters Guild Elite's power and health.",
    "Keywords": "Expertise",
    "Played in": "45/12757 of  Eligible  decks (0 %)",
    "code": "tf"
  },
  {
    "Name": "Fighters Guild Hall",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Ongoing. When a friendly creature takes damage on your turn, give it +2/+0.",
    "Keywords": "",
    "Played in": "199/12757 of  Eligible  decks (2 %)",
    "code": "gq"
  },
  {
    "Name": "Fighters Guild Recruit",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Argonian",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard, Lethal",
    "Keywords": "Guard,Lethal,Prophecy",
    "Played in": "3312/13695 of  Eligible  decks (24 %)",
    "Evolves from:": "Guild Recruit",
    "code": "gs"
  },
  {
    "Name": "Fighters Guild Steward",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: A friendly creature with 5 or more power Battles an enemy creature.",
    "Keywords": "",
    "Played in": "131/12757 of  Eligible  decks (1 %)",
    "code": "gt"
  },
  {
    "Name": "Fingers of the Mountain",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Cost 1 less for each action you've played this turn. Deal 1 damage to a creature. Deal 2 damage to a creature. Deal 3 damage to a creature.",
    "Keywords": "",
    "Played in": "41/14266 of  Eligible  decks (0 %)",
    "code": "xS"
  },
  {
    "Name": "Finish Off",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Destroy a wounded enemy creature.",
    "Keywords": "",
    "Played in": "2218/13695 of  Eligible  decks (16 %)",
    "code": "gu"
  },
  {
    "Name": "Fire Breath",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Level 1: Deal 2 damage to a creature.\nLevel 2: Deal 4 damage to a creature.\nLevel 3: Deal 10 damage to a creature.",
    "Keywords": "",
    "Played in": "348/14266 of  Eligible  decks (2 %)",
    "code": "gv"
  },
  {
    "Name": "Fire Storm",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy. Deal 2 damage to all creatures in one lane.",
    "Keywords": "Prophecy",
    "Played in": "992/14266 of  Eligible  decks (7 %)",
    "code": "gw"
  },
  {
    "Name": "Fireball",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Deal 1 damage to all enemies.",
    "Keywords": "",
    "Played in": "222/12759 of  Eligible  decks (2 %)",
    "code": "gx"
  },
  {
    "Name": "Firebolt",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Deal 2 damage to a creature.",
    "Keywords": "",
    "Played in": "6672/14271 of  Eligible  decks (47 %)",
    "code": "gy"
  },
  {
    "Name": "Firepot Spider",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Fabricant",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 4 - Hall of Conveyance",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Last Gasp: Deal 1 damage to all creatures in this lane.",
    "Keywords": "Last Gasp",
    "Played in": "100/12757 of  Eligible  decks (1 %)",
    "code": "gz"
  },
  {
    "Name": "Flamespear Dragon",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Dragon",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "5",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "When your opponent summons a creature, Flamespear Dragon aims at it. At the start of your turn, Flamespear Dragon deals 1 damage to the creature it's aiming at.",
    "Keywords": "",
    "Played in": "130/12757 of  Eligible  decks (1 %)",
    "code": "vS"
  },
  {
    "Name": "Flaming Breath",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Deal 1 damage to everything.",
    "Keywords": "Prophecy",
    "Played in": "19/12757 of  Eligible  decks (0 %)",
    "code": "yr"
  },
  {
    "Name": "Fleeting Apparition",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Betray. Summon a random creature from your deck that costs 3 or less to a random lane. Unsummon it at the end of your turn.",
    "Keywords": "Betray",
    "Played in": "259/13695 of  Eligible  decks (2 %)",
    "code": "gA"
  },
  {
    "Name": "Flesh Atronach",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Daedra",
    "Magicka Cost": "6",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: +1/+1 for each creature in your discard pile.",
    "Keywords": "",
    "Played in": "379/13644 of  Eligible  decks (3 %)",
    "code": "gB"
  },
  {
    "Name": "Flesh Sculpture",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 2 - Princess Baryna",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Uses: 2. Activate: Transform each card in your hand into a random card.",
    "Keywords": "",
    "Played in": "130/30861 of  Eligible  decks (0 %)",
    "code": "gC"
  },
  {
    "Name": "Forces of Destruction",
    "Rarity": "Legendary",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "10",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Invade, then summon random Daedra with total cost 10.",
    "Keywords": "",
    "Played in": "60/14266 of  Eligible  decks (0 %)",
    "code": "yI"
  },
  {
    "Name": "Forerunner of the Pact",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "agility",
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Veteran: Draw a Forerunner of the Pact from your deck.",
    "Keywords": "Veteran",
    "Played in": "108/338 of  Eligible  decks (32 %)",
    "code": "sX"
  },
  {
    "Name": "Fork of Horripilation",
    "Rarity": "Legendary - Unique",
    "Type": "Item",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "-2/+0. Slay: Sacrifice Fork of Horripilation and draw three cards.",
    "Keywords": "Slay",
    "Played in": "488/30861 of  Eligible  decks (2 %)",
    "code": "gD"
  },
  {
    "Name": "Forked Bolt",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Deal 1 damage to a creature and your opponent.",
    "Keywords": "",
    "Played in": "187/14266 of  Eligible  decks (1 %)",
    "code": "tg"
  },
  {
    "Name": "Forsaken Champion",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Reachman",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Madhouse Collection",
    "Soul Summon": "This card belongs to the Madhouse Collection and cannot be Soul Summoned.",
    "Soul Trap": "This card belongs to the Madhouse Collection and cannot be Soul Trapped.",
    "Text": "Summon: Choose a friendly creature. Friendly creatures of the chosen type have +1/+1.",
    "Keywords": "",
    "Played in": "152/30861 of  Eligible  decks (0 %)",
    "code": "gE"
  },
  {
    "Name": "Forsworn Guide",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Reachman",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Unsummon another friendly creature to give Forsworn Guide +2/+2.",
    "Keywords": "",
    "Played in": "256/30861 of  Eligible  decks (1 %)",
    "code": "gF"
  },
  {
    "Name": "Forsworn Looter",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Reachman",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Pilfer: Draw a random item from your deck with cost equal to Forsworn Looter's power.",
    "Keywords": "Pilfer",
    "Played in": "140/30861 of  Eligible  decks (0 %)",
    "code": "gG"
  },
  {
    "Name": "Fortress Guard",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: You may discard a card to summon a 2/2 Colovian Trooper with Gaurd in the other lane.",
    "Keywords": "Guard",
    "Played in": "72/12907 of  Eligible  decks (1 %)",
    "code": "gH"
  },
  {
    "Name": "Fortress Watchman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard",
    "Keywords": "Guard",
    "Played in": "284/12757 of  Eligible  decks (2 %)",
    "code": "gI"
  },
  {
    "Name": "Forward Camp",
    "Rarity": "Legendary",
    "Type": "Support",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Ongoing. Your supports cost 1 less. When you have 4 supports, sacrifice Forward Camp and summon an Eastmarch Crusader in each lane.",
    "Keywords": "",
    "Played in": "189/12907 of  Eligible  decks (1 %)",
    "code": "th"
  },
  {
    "Name": "Frazzled Alfiq",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Wax: Deal 1 damage. Wane: +1/+1. After you play another card Waxed, deal 1 damage. After you another card Waned, +1/+1.",
    "Keywords": "Wax/Wane",
    "Played in": "69/14266 of  Eligible  decks (0 %)",
    "code": "wF"
  },
  {
    "Name": "Frenzied Alit",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Reptile",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When Frenzied Alit takes damage, it gains +1/+0.",
    "Keywords": "",
    "Played in": "53/12757 of  Eligible  decks (0 %)",
    "code": "iT"
  },
  {
    "Name": "Frenzied Witchman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Reachman",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Give a creature +2/+1.",
    "Keywords": "",
    "Played in": "299/30861 of  Eligible  decks (1 %)",
    "code": "gJ"
  },
  {
    "Name": "Fresh Start",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Draw three cards.",
    "Keywords": "",
    "Played in": "86/13695 of  Eligible  decks (1 %)",
    "code": "yx"
  },
  {
    "Name": "Frost Giant",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Giant",
    "Magicka Cost": "8",
    "Attack": "10",
    "Health": "10",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Regenerate. When a creature heals, you gain that much health.",
    "Keywords": "Regenerate",
    "Played in": "146/13644 of  Eligible  decks (1 %)",
    "code": "gK"
  },
  {
    "Name": "Frost Troll",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Troll",
    "Magicka Cost": "4",
    "Attack": "1",
    "Health": "6",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Regenerate. When Frost Troll takes damage, it gains that much power.",
    "Keywords": "Regenerate",
    "Played in": "174/13644 of  Eligible  decks (1 %)",
    "code": "gL"
  },
  {
    "Name": "Frostbite Spider",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Spider",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy, Lethal",
    "Keywords": "Lethal,Prophecy",
    "Played in": "299/13644 of  Eligible  decks (2 %)",
    "code": "gM"
  },
  {
    "Name": "Frostscale Dragon",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "intelligence"
    ],
    "Race": "Dragon",
    "Magicka Cost": "9",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Deal 4 damage to an enemy creature and 1 damage to all other enemy creatures.",
    "Keywords": "",
    "Played in": "165/3939 of  Eligible  decks (4 %)",
    "code": "gN"
  },
  {
    "Name": "Galyn the Shelterer",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 3 - The Last Stand",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Choose a creature or item in your hand. Shuffle three copies of it with +3/+3 into your deck.",
    "Keywords": "",
    "Played in": "4033/13644 of  Eligible  decks (30 %)",
    "code": "gO"
  },
  {
    "Name": "Gardener of Swords",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Redguard",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Madhouse Collection",
    "Soul Summon": "This card belongs to the Madhouse Collection and cannot be Soul Summoned.",
    "Soul Trap": "This card belongs to the Madhouse Collection and cannot be Soul Trapped.",
    "Text": "When you equip an item to another creature, equip a copy of it to Gardener of Swords.",
    "Keywords": "",
    "Played in": "771/14266 of  Eligible  decks (5 %)",
    "code": "gP"
  },
  {
    "Name": "Gardener's Harvest",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "+1/+1. At the end of your turn, if Gardener's Harvest is in your hand, it changes into a random item and keeps this ability.",
    "Keywords": "",
    "Played in": "80/14266 of  Eligible  decks (1 %)",
    "code": "gQ"
  },
  {
    "Name": "Garnag, Dark Adherent",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "5",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 5 - Silverhome on the Water, Back Room",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Breakthrough. Players can't have more than 7 magicka.",
    "Keywords": "Breakthrough",
    "Played in": "2396/12757 of  Eligible  decks (19 %)",
    "code": "gR"
  },
  {
    "Name": "Gates of Madness",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Ongoing. Summon: Transform your deck into random cards. When you draw a creature or item, give it +1/+1. When you draw an action or support, reduce its cost by 1.",
    "Keywords": "",
    "Played in": "63/30861 of  Eligible  decks (0 %)",
    "code": "gS"
  },
  {
    "Name": "Gavel of the Ordinator",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "+2/+0. Summon: The wielder is immune to damage this turn.",
    "Keywords": "",
    "Played in": "754/12907 of  Eligible  decks (6 %)",
    "code": "gT"
  },
  {
    "Name": "Gearwork Spider",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 4 - The Apprentice",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Summon all Gearwork Spiders in your discard pile.",
    "Keywords": "Prophecy,Guard",
    "Played in": "575/30861 of  Eligible  decks (2 %)",
    "code": "gU"
  },
  {
    "Name": "General Tullius",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "willpower",
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "6",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Summon a 2/2 Colovian Trooper with Guard in each lane. When a friendly creature is destroyed, General Tullius gains +1/+1.",
    "Keywords": "Guard",
    "Played in": "730/4355 of  Eligible  decks (17 %)",
    "code": "gV"
  },
  {
    "Name": "Genius Pathmage",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "7",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Summon a random creature from your deck with cost equal to your current magicka.",
    "Keywords": "",
    "Played in": "463/14266 of  Eligible  decks (3 %)",
    "code": "gW"
  },
  {
    "Name": "Gentleman Jim Stacey",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Redguard",
    "Magicka Cost": "7",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Your opponent chooses a card in their hand and gives it to you.",
    "Keywords": "",
    "Played in": "291/13695 of  Eligible  decks (2 %)",
    "code": "gX"
  },
  {
    "Name": "Ghost Fanatic",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Spirit",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Ghost Fanatic costs 1 less for each creature that died this turn.",
    "Keywords": "",
    "Played in": "44/30861 of  Eligible  decks (0 %)",
    "code": "gY"
  },
  {
    "Name": "Ghost Sea Lookout",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "3",
    "Attack": "4",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "When you summon a Dragon, Ghost Sea Lookout gains a Ward.",
    "Keywords": "",
    "Played in": "147/14266 of  Eligible  decks (1 %)",
    "code": "gZ"
  },
  {
    "Name": "Ghostgate Defender",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard. Exalt 3: Deal 2 damage to a creature.",
    "Keywords": "Guard,Exalt",
    "Played in": "377/14266 of  Eligible  decks (3 %)",
    "code": "ha"
  },
  {
    "Name": "Giant Bat",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Beast",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Charge, Drain",
    "Keywords": "Charge,Drain",
    "Played in": "2166/13695 of  Eligible  decks (16 %)",
    "code": "hb"
  },
  {
    "Name": "Giant Chicken",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Beast",
    "Magicka Cost": "7",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Last Gasp: Fill this lane with 1/1 Confused Villagers.",
    "Keywords": "Last Gasp",
    "Played in": "28/30861 of  Eligible  decks (0 %)",
    "code": "hc"
  },
  {
    "Name": "Giant Slaughterfish",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Fish",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Give friendly Animals +2/+0 at the start of your turn.",
    "Keywords": "",
    "Played in": "25/30861 of  Eligible  decks (0 %)",
    "code": "xY"
  },
  {
    "Name": "Giant Snake",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Reptile",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Shackle all enemy creatures in this lane.",
    "Keywords": "",
    "Played in": "572/13695 of  Eligible  decks (4 %)",
    "code": "hd"
  },
  {
    "Name": "Giant's Camp",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": ["strength"],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the start of your turn, set each friendly creature's power equal to the power of your most powerful creature.",
    "Keywords": "",
    "code": "yU"
  },
  {
    "Name": "Glacial Dragon",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dragon",
    "Magicka Cost": "6",
    "Attack": "4",
    "Health": "5",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Shackle enemy creatures damaged by friendly Dragons. Summon: Deal 2 damage to a creature.",
    "Keywords": "",
    "Played in": "75/14266 of  Eligible  decks (1 %)",
    "code": "wx"
  },
  {
    "Name": "Gladiator Arena",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the start of each player's turn, deal 2 damage to that player.",
    "Keywords": "",
    "Played in": "152/12757 of  Eligible  decks (1 %)",
    "code": "he"
  },
  {
    "Name": "Glass Greaves",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+1/+1. Plot: Reduce the cost of a random card in your hand by 1.",
    "Keywords": "Plot",
    "Played in": "142/13695 of  Eligible  decks (1 %)",
    "code": "hf"
  },
  {
    "Name": "Glass Helm of Remedy",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+0/+4. Summon: You gain 4 health.",
    "Keywords": "",
    "Played in": "344/30861 of  Eligible  decks (1 %)",
    "code": "hg"
  },
  {
    "Name": "Glenumbra Sorceress",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Ward",
    "Keywords": "Ward",
    "Played in": "109/14266 of  Eligible  decks (1 %)",
    "code": "hh"
  },
  {
    "Name": "Gloom Wraith",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Spirit",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Breakthrough. Summon: +1/+1 for each other friendly (Endurance) creature.",
    "Keywords": "Breakthrough",
    "Played in": "154/13644 of  Eligible  decks (1 %)",
    "code": "hi"
  },
  {
    "Name": "Gloomlurker",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Falmer",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "1",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Summon: Give a creature Cover.",
    "Keywords": "Prophecy",
    "Played in": "431/13703 of  Eligible  decks (3 %)",
    "code": "hj"
  },
  {
    "Name": "Gnarl Rootbender",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Spriggan",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "When an action targets Gnarl Rootbender, draw a card.",
    "Keywords": "",
    "Played in": "200/14266 of  Eligible  decks (1 %)",
    "code": "hk"
  },
  {
    "Name": "Goblin Skulk",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Goblin",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Pilfer: Draw a random card from your deck that costs 0.",
    "Keywords": "Pilfer",
    "Played in": "2916/13695 of  Eligible  decks (21 %)",
    "code": "hl"
  },
  {
    "Name": "Goldbrand",
    "Rarity": "Legendary - Unique",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Activate: Deal 2 damage to a creature, then increase the damage Goldbrand deals by 2.",
    "Keywords": "",
    "Played in": "995/30872 of  Eligible  decks (3 %)",
    "code": "hm"
  },
  {
    "Name": "Golden Initiate",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Daedra",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Drain",
    "Keywords": "Prophecy,Drain",
    "Played in": "1203/12907 of  Eligible  decks (9 %)",
    "code": "hn"
  },
  {
    "Name": "Golden Saint",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Daedra",
    "Magicka Cost": "6",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard. Summon: If you have more health than your opponent, summon a copy of Golden Saint in the other lane.",
    "Keywords": "Guard",
    "Played in": "1682/12907 of  Eligible  decks (13 %)",
    "code": "ho"
  },
  {
    "Name": "Gortwog gro-Nagorm",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "endurance"
    ],
    "Race": "Orc",
    "Magicka Cost": "6",
    "Attack": "4",
    "Health": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "At the start of your turn, summon a random creature from your deck to a random lane.",
    "Keywords": "",
    "Played in": "1047/3890 of  Eligible  decks (27 %)",
    "code": "hq"
  },
  {
    "Name": "Goutfang Adept",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Wax: Draw a card. Wane: +1/+1 and Guard.",
    "Keywords": "Wax/Wane,Guard",
    "Played in": "77/14266 of  Eligible  decks (1 %)",
    "code": "wq"
  },
  {
    "Name": "Grahtwood Ambusher",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Prophecy. Summon: Deal 1 damage to all enemy creatures in this lane.",
    "Keywords": "Prophecy",
    "Played in": "778/12757 of  Eligible  decks (6 %)",
    "code": "hr"
  },
  {
    "Name": "Grand Ball",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 1 - Arenthil Wethrin's house",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Move all friendly creatures.",
    "Keywords": "",
    "Played in": "273/13695 of  Eligible  decks (2 %)",
    "code": "hs"
  },
  {
    "Name": "Grand Inquisitor",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Exalt 4: +3/+3. Summon: Destroy a creature with less power than Grand Inquisitor",
    "Keywords": "Exalt",
    "Played in": "246/12907 of  Eligible  decks (2 %)",
    "code": "ht"
  },
  {
    "Name": "Grappling Hook",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 2 - Bleakcoast Ridge",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+3/+2. Summon: Move an enemy creature into this lane. It loses Cover.",
    "Keywords": "",
    "Played in": "197/12757 of  Eligible  decks (2 %)",
    "code": "hu"
  },
  {
    "Name": "Grave Grasp",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Shackle an enemy creature. Summon a 1/1 Skeleton for each enemy creature in its lane.",
    "Keywords": "Prophecy",
    "Played in": "47/14266 of  Eligible  decks (0 %)",
    "code": "wr"
  },
  {
    "Name": "Gravesinger",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "10",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 3 - Cultists' Meeting Place",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the start of your turn, summon the highest cost creature from your discard pile and give Charge. At the end of the turn, put it on the bottom of your deck.",
    "Keywords": "Charge",
    "Played in": "541/13651 of  Eligible  decks (4 %)",
    "code": "hv"
  },
  {
    "Name": "Gray Viper Brigand",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Draw a card for each Gray Viper Brigand in your discard pile.",
    "Keywords": "",
    "Played in": "278/12907 of  Eligible  decks (2 %)",
    "code": "uA"
  },
  {
    "Name": "Graystone Ravager",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "2",
    "Attack": "4",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy",
    "Keywords": "Prophecy",
    "Played in": "1588/12757 of  Eligible  decks (12 %)",
    "code": "hw"
  },
  {
    "Name": "Great Moot Squire",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Veteran: +1/+1.",
    "Keywords": "Veteran",
    "Played in": "50/13644 of  Eligible  decks (0 %)",
    "code": "un"
  },
  {
    "Name": "Great Sigil Stone",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Attack": "0",
    "Health": "0",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Activate: Invade. Last Gasp: Draw a random Daedra from your deck and give it +2/+2.",
    "Keywords": "Invade,Last Gasp",
    "Played in": "68/30861 of  Eligible  decks (0 %)",
    "code": "xG"
  },
  {
    "Name": "Greatwood Elder",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Spriggan",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "5",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard. If Greatwood Elder is in your hand at the start of your first turn, gain 1 magicka this turn.",
    "Keywords": "Guard",
    "Played in": "25/13695 of  Eligible  decks (0 %)",
    "code": "hx"
  },
  {
    "Name": "Green Pact Ambusher",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "2",
    "Attack": "4",
    "Health": "1",
    "Expansion Set": "FrostSpark Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Prophecy, Guard. At the end of your opponent's turn, if they have a full lane and Green Pact Ambusher is in your hand, summon her to that lane.",
    "Keywords": "Prophecy,Guard",
    "Played in": "470/12757 of  Eligible  decks (4 %)",
    "code": "hy"
  },
  {
    "Name": "Green Pact Stalker",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard. Summon: +2/+2 if there is a wounded enemy creature in this lane.",
    "Keywords": "Guard",
    "Played in": "318/13695 of  Eligible  decks (2 %)",
    "code": "hz"
  },
  {
    "Name": "Green-Touched Spriggan",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Spriggan",
    "Magicka Cost": "5",
    "Attack": "1",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When you gain health, Green-Touched Spriggan gains that much power.",
    "Keywords": "",
    "Played in": "153/13695 of  Eligible  decks (1 %)",
    "code": "hA"
  },
  {
    "Name": "Greenheart Knight",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Charge",
    "Keywords": "Charge",
    "Played in": "94/13695 of  Eligible  decks (1 %)",
    "code": "hB"
  },
  {
    "Name": "Greybeard Mentor",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Draw a random Shout from your deck.",
    "Keywords": "",
    "Played in": "1288/30861 of  Eligible  decks (4 %)",
    "code": "hC"
  },
  {
    "Name": "Grim Champion",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When a creature in this lane is destroyed, Grim Champion gains +1/+1.",
    "Keywords": "",
    "Played in": "185/13644 of  Eligible  decks (1 %)",
    "code": "hD"
  },
  {
    "Name": "Grim Shield-Brother",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Beast Form: +1/+1 and Drain.",
    "Keywords": "Drain",
    "Played in": "466/13644 of  Eligible  decks (3 %)",
    "code": "hE"
  },
  {
    "Name": "Grisly Gourmet",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Transform an enemy creature with 2 power or less into a Sweet Roll.",
    "Keywords": "",
    "Played in": "1347/12907 of  Eligible  decks (10 %)",
    "code": "hF"
  },
  {
    "Name": "Gristlehide Dreugh",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dreugh",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 1 - Dreughside",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "When Gristlehide Dreugh takes damage and survives, draw a card.",
    "Keywords": "",
    "Played in": "239/30861 of  Eligible  decks (1 %)",
    "code": "hH"
  },
  {
    "Name": "Grummite Magus",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Grummite",
    "Magicka Cost": "7",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. Summon: Your opponent discards the highest cost action in their hand.",
    "Keywords": "Guard",
    "Played in": "195/12757 of  Eligible  decks (2 %)",
    "code": "hI"
  },
  {
    "Name": "Guar Stablemaster",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: +1/+1 and Guard if you have an Animal.",
    "Keywords": "Guard",
    "Played in": "78/13695 of  Eligible  decks (1 %)",
    "code": "hJ"
  },
  {
    "Name": "Guildsworn Apprentice",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "intelligence",
      "willpower"
    ],
    "Race": "Argonian",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy, Guard. Summon: Draw a card.",
    "Keywords": "Prophecy,Guard",
    "Played in": "392/407 of  Eligible  decks (96 %)",
    "code": "ti"
  },
  {
    "Name": "Guildsworn Bloodluster",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "7",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Expertise: +2/+2 and Battle an enemy creature in this lane.",
    "Keywords": "",
    "Played in": "50/12757 of  Eligible  decks (0 %)",
    "code": "te"
  },
  {
    "Name": "Guildsworn Cavalier",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Breton",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Expertise: Give friendly creatures +1/+1.",
    "Keywords": "Expertise",
    "Played in": "116/12907 of  Eligible  decks (1 %)",
    "code": "tj"
  },
  {
    "Name": "Guildsworn Honeytongue",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "7",
    "Attack": "0",
    "Health": "5",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Expertise: You may trade Guildsworn Honeytongue for an enemy creature.",
    "Keywords": "Expertise",
    "Played in": "14/12907 of  Eligible  decks (0 %)",
    "code": "up"
  },
  {
    "Name": "Guildsworn Incendiary",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "6",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Expertise: Deal 1 damage to all creatures in this lane.",
    "Keywords": "Expertise",
    "Played in": "48/12757 of  Eligible  decks (0 %)",
    "code": "tR"
  },
  {
    "Name": "Guildsworn Oathman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "6",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: If you have a...\n[strength] card in play, put an Improvised Weapon into your hand.\n[intelligence] card in play, put a Forked Bolt into your hand.",
    "Keywords": "",
    "Played in": "128/12907 of  Eligible  decks (1 %)",
    "code": "tl"
  },
  {
    "Name": "Guildsworn Revitalizer",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "5",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Expertise: You gain 2 health.",
    "Keywords": "Expertise",
    "Played in": "305/12907 of  Eligible  decks (2 %)",
    "code": "tm"
  },
  {
    "Name": "Guildsworn Wayfarer",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Redguard",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Expertise: +1/+1.",
    "Keywords": "Expertise",
    "Played in": "117/14266 of  Eligible  decks (1 %)",
    "code": "tk"
  },
  {
    "Name": "Haafingar Marauder",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "When a friendly creature destroys an enemy rune, equip it with a random item.",
    "Keywords": "",
    "Played in": "1049/12907 of  Eligible  decks (8 %)",
    "code": "hL"
  },
  {
    "Name": "Hackwing Feather",
    "Rarity": "Epic",
    "Type": "Item",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Regenerate, +1/+3",
    "Keywords": "Regenerate",
    "Played in": "307/13644 of  Eligible  decks (2 %)",
    "code": "hM"
  },
  {
    "Name": "Hallowed Deathpriest",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 1 - Forelhost Front Gate",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Transform the highest cost creature in your opponent's hand into a Shriveled Mummy.",
    "Keywords": "",
    "Played in": "1447/13644 of  Eligible  decks (11 %)",
    "code": "hN"
  },
  {
    "Name": "Halls of the Dwemer",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Put a 0/3 Dwarven Spider with Guard into your hand. Friendly Dwemer have +3/+0.",
    "Keywords": "Guard",
    "Played in": "597/30861 of  Eligible  decks (2 %)",
    "code": "hO"
  },
  {
    "Name": "Hand of Dagoth",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "intelligence",
      "agility"
    ],
    "Race": "Ash Creature",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Breakthrough, Drain, Ward",
    "Keywords": "Breakthrough,Drain,Ward",
    "Played in": "874/937 of  Eligible  decks (93 %)",
    "code": "hP"
  },
  {
    "Name": "Hannibal Traven",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "7",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "After you play an action, Hannibal Traven learns it. Last Gasp: Play all learned actions form your discard pile.",
    "Keywords": "",
    "Played in": "45/14266 of  Eligible  decks (0 %)",
    "code": "xD"
  },
  {
    "Name": "Harmony",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "FrostSpark Collection",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy. Give all enemy creatures -2/-0 until the start of your turn.",
    "Keywords": "Prophecy",
    "Played in": "86/12916 of  Eligible  decks (1 %)",
    "code": "hQ"
  },
  {
    "Name": "Haskill",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Breton",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "At the end of your turn, Haskill chooses a cost. When you play a card with the chosen cost, draw a card. Then Haskill chooses a new cost.",
    "Keywords": "",
    "Played in": "132/30872 of  Eligible  decks (0 %)",
    "code": "hR"
  },
  {
    "Name": "Hatchery Meddler",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "5",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Swap a creature's power and health.",
    "Keywords": "",
    "Played in": "113/14266 of  Eligible  decks (1 %)",
    "code": "hS"
  },
  {
    "Name": "Haunted Manor",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "strength",
      "willpower",
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Ongoing. Give the second creature you summon each turn +2/+2.",
    "Keywords": "",
    "Played in": "408/861 of  Eligible  decks (47 %)",
    "code": "hT"
  },
  {
    "Name": "Haunting Spirit",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Spirit",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Last Gasp: Give a random friendly creature +3/+3.",
    "Keywords": "Last Gasp",
    "Played in": "2399/13644 of  Eligible  decks (18 %)",
    "code": "hU"
  },
  {
    "Name": "Headless Zombie",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": ["endurance", "intelligence"],
    "Race": "Skeleton",
    "Attack": "3",
    "Health": "4",
    "Magicka Cost": "4",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Consume a card. Last Gasp: Draw a copy of the consumed card.",
    "Keywords": "Last Gasp,Consume",
    "code": "yP"
  },
  {
    "Name": "Healing Hands",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Heal a creature, then give it +1/+1.",
    "Keywords": "",
    "Played in": "256/13644 of  Eligible  decks (2 %)",
    "code": "hV"
  },
  {
    "Name": "Healing Potion",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Gain 5 health.",
    "Keywords": "Prophecy",
    "Played in": "746/12907 of  Eligible  decks (6 %)",
    "Evolves from:": "Apprentice's Potion",
    "code": "hW"
  },
  {
    "Name": "Heavy Battleaxe",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+4/+1",
    "Keywords": "",
    "Played in": "310/12757 of  Eligible  decks (2 %)",
    "code": "hX"
  },
  {
    "Name": "Heirloom Greatsword",
    "Rarity": "Epic",
    "Type": "Item",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "+5/+0. Last Gasp: Return Heirloom Greatsword to your hand.",
    "Keywords": "Last Gasp",
    "Played in": "393/14266 of  Eligible  decks (3 %)",
    "code": "hY"
  },
  {
    "Name": "Helgen Squad Leader",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "2",
    "Attack": "0",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When another friendly creature attacks, Helgen Squad Leader gains +1/+0.",
    "Keywords": "",
    "Played in": "236/12907 of  Eligible  decks (2 %)",
    "code": "hZ"
  },
  {
    "Name": "Helstrom Footpad",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Argonian",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "71/13695 of  Eligible  decks (1 %)",
    "code": "ia"
  },
  {
    "Name": "Heretic Conjurer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "High Elf",
    "Magicka Cost": "5",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard. Pilfer: Creatures you summon this turn are transformed into random Daedra.",
    "Keywords": "Guard",
    "Played in": "88/12907 of  Eligible  decks (1 %)",
    "code": "ib"
  },
  {
    "Name": "Hero of Anvil",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Hero of Anvil costs 1 less for each creature summoned this turn.",
    "Keywords": "",
    "Played in": "47/12907 of  Eligible  decks (0 %)",
    "code": "ic"
  },
  {
    "Name": "Heroic Rebirth",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Uses: 3. Activate: Transform a creature in your hand into a random Legend.",
    "Keywords": "",
    "Played in": "300/30861 of  Eligible  decks (1 %)",
    "code": "id"
  },
  {
    "Name": "Hidden Trail",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: All Field Lanes become Shadow Lanes. Friendly creatures have +1/+0.",
    "Keywords": "",
    "Played in": "245/13695 of  Eligible  decks (2 %)",
    "code": "ie"
  },
  {
    "Name": "High Hrothgar",
    "Rarity": "Legendary - Unique",
    "Type": "Support",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Ongoing. When you summon a creature, its power becomes equal to its health.",
    "Keywords": "",
    "Played in": "242/13644 of  Eligible  decks (2 %)",
    "code": "if"
  },
  {
    "Name": "High King Emeric",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "endurance"
    ],
    "Race": "Breton",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Ward. Summon: Deal 2 damage for each Ward your creatures have.",
    "Keywords": "Ward",
    "Played in": "1919/4886 of  Eligible  decks (39 %)",
    "code": "ig"
  },
  {
    "Name": "High Rock Stalwart",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: +2/+2 if you have an item in play.",
    "Keywords": "",
    "Played in": "40/12757 of  Eligible  decks (0 %)",
    "code": "to"
  },
  {
    "Name": "High Rock Summoner",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Put a random Atronach into your hand.",
    "Keywords": "",
    "Played in": "1263/14266 of  Eligible  decks (9 %)",
    "code": "ih"
  },
  {
    "Name": "Highland Lurcher",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Lurcher",
    "Magicka Cost": "6",
    "Attack": "7",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "47/13695 of  Eligible  decks (0 %)",
    "code": "ii"
  },
  {
    "Name": "Hist Grove",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: +1 max magicka.\nAt the start of your turn, if you have 15 or more max magicka, sacrifice this to summon an 8/8 Swamp Leviathan in each lane.",
    "Keywords": "",
    "Played in": "1639/13644 of  Eligible  decks (12 %)",
    "code": "ij"
  },
  {
    "Name": "Hist Speaker",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "While Hist Speaker is in play, your max magicka is increased by 1.",
    "Keywords": "",
    "Played in": "616/13644 of  Eligible  decks (5 %)",
    "code": "ik"
  },
  {
    "Name": "Hit and Run",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Draw five cards. Discard your hand at the end of the turn.",
    "Keywords": "",
    "Played in": "111/12757 of  Eligible  decks (1 %)",
    "code": "il"
  },
  {
    "Name": "Hive Defender",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Kwama",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard",
    "Keywords": "Guard",
    "Played in": "6019/12907 of  Eligible  decks (47 %)",
    "Evolves from:": "Hive Worker",
    "code": "im"
  },
  {
    "Name": "Hive Warrior",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Kwama",
    "Magicka Cost": "4",
    "Attack": "6",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Breakthrough",
    "Keywords": "Breakthrough",
    "Played in": "92/12907 of  Eligible  decks (1 %)",
    "Evolves from:": "Hive Worker",
    "code": "io"
  },
  {
    "Name": "Hlaalu Oathman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: if you have a (agility) card in play, gain 3 magicka this turn. (strenght) card in play, draw a card.",
    "Keywords": "",
    "Played in": "520/12907 of  Eligible  decks (4 %)",
    "code": "iq"
  },
  {
    "Name": "Hlaalu Sharpshooter",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Plot: Silence a creature, then deal 1 damage to it.",
    "Keywords": "Plot,Silence",
    "Played in": "1429/12757 of  Eligible  decks (11 %)",
    "code": "ir"
  },
  {
    "Name": "Horned Helm",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+2/+3",
    "Keywords": "",
    "Played in": "139/30861 of  Eligible  decks (0 %)",
    "code": "is"
  },
  {
    "Name": "Horse Armor",
    "Rarity": "Legendary",
    "Type": "Item",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "+0/+1. Summon: The wielder becomes premium.",
    "Keywords": "",
    "Played in": "7/30861 of  Eligible  decks (0 %)",
    "code": "yV"
  },
  {
    "Name": "House Kinsman",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Last Gasp: Deal 3 damage to your opponent and gain 3 health.",
    "Keywords": "Last Gasp",
    "Played in": "1546/13695 of  Eligible  decks (11 %)",
    "code": "it"
  },
  {
    "Name": "Hulking Fabricant",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Fabricant",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 4 - Cogitum Centralis",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: If you have a [neutral] card in play, +3/+3.",
    "Keywords": "",
    "Played in": "214/13644 of  Eligible  decks (2 %)",
    "code": "iu"
  },
  {
    "Name": "Hulking Mummy",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Mummy",
    "Magicka Cost": "4",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Shackle Hulking Mummy",
    "Keywords": "",
    "Played in": "30/13644 of  Eligible  decks (0 %)",
    "code": "vA"
  },
  {
    "Name": "Hulking Scalon",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Grummite",
    "Magicka Cost": "10",
    "Attack": "10",
    "Health": "10",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Immune to Lethal. Immune to Shackle. Your opponent can't target Hulking Scalon with actions.",
    "Keywords": "Lethal",
    "Played in": "160/13695 of  Eligible  decks (1 %)",
    "code": "iv"
  },
  {
    "Name": "Hunter-Killers",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Fabricant",
    "Magicka Cost": "6",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 5 - Shaft of Sohleh",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Battle an enemy creature, then Battle another enemy creature.",
    "Keywords": "",
    "Played in": "85/12757 of  Eligible  decks (1 %)",
    "code": "iw"
  },
  {
    "Name": "Hush",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy. Silence a creature.",
    "Keywords": "Prophecy",
    "Played in": "121/13644 of  Eligible  decks (1 %)",
    "code": "tq"
  },
  {
    "Name": "Ice Spike",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Deal 2 damage to your opponent. Draw a card.",
    "Keywords": "",
    "Played in": "1893/14266 of  Eligible  decks (13 %)",
    "code": "ix"
  },
  {
    "Name": "Ice Storm",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Deal 3 damage to all creatures.",
    "Keywords": "",
    "Played in": "5225/14266 of  Eligible  decks (37 %)",
    "code": "iy"
  },
  {
    "Name": "Ice Wraith",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Wraith",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the start of your turn, draw an Ice Spike.",
    "Keywords": "",
    "Played in": "178/14266 of  Eligible  decks (1 %)",
    "code": "iz"
  },
  {
    "Name": "Icewing Dragon",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dragon",
    "Magicka Cost": "6",
    "Attack": "6",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Shackle an enemy creature.",
    "Keywords": "",
    "Played in": "337/14266 of  Eligible  decks (2 %)",
    "code": "iA"
  },
  {
    "Name": "Icy Shambles",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Shackle creatures damaged by Icy Shambles. Summon: Deal 2 damage to a creature.",
    "Keywords": "",
    "Played in": "294/14266 of  Eligible  decks (2 %)",
    "code": "iB"
  },
  {
    "Name": "Iliac Sorcerer",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Breton",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Ward. When Iliac Sorcerer's Ward is broken, double his power.",
    "Keywords": "Ward",
    "Played in": "447/13644 of  Eligible  decks (3 %)",
    "code": "iC"
  },
  {
    "Name": "Ill-Fated Scholar",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Redguard",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "When Ill-Fated Scholar is Consumed, summon a 3/2 Insidious Spirit.",
    "Keywords": "Consume",
    "Played in": "66/30861 of  Eligible  decks (0 %)",
    "code": "wa"
  },
  {
    "Name": "Illicit Butcher",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Consume a creature to Shackle an enemy creature.",
    "Keywords": "Consume,Shackle",
    "Played in": "75/13695 of  Eligible  decks (1 %)",
    "code": "wN"
  },
  {
    "Name": "Illusory Defenses",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Summon a 0/5 Illusory Wall with Guard in each lane. Sacrifice them at the start of your turn.",
    "Keywords": "",
    "Played in": "125/12907 of  Eligible  decks (1 %)",
    "code": "iD"
  },
  {
    "Name": "Illusory Mimic",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Spirit",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Madhouse Collection",
    "Soul Summon": "This card belongs to the Madhouse Collection and cannot be Soul Summoned.",
    "Soul Trap": "This card belongs to the Madhouse Collection and cannot be Soul Trapped.",
    "Text": "Summon: Illusory Mimic gains all Keywords on the top three cards of your deck.",
    "Keywords": "",
    "Played in": "235/30861 of  Eligible  decks (1 %)",
    "code": "iE"
  },
  {
    "Name": "Imbued Argonian",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard. When Imbued Argonian is Consumed, give the consuming creature +1/+1 and Guard.",
    "Keywords": "Guard",
    "Played in": "128/13644 of  Eligible  decks (1 %)",
    "code": "vG"
  },
  {
    "Name": "Imbued Bosmer",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "High Elf",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Lethal. When Imbued Bosmer is Consumed, give the consuming creature +1/+1 and Lethal.",
    "Keywords": "Lethal,Consume",
    "Played in": "89/13695 of  Eligible  decks (1 %)",
    "code": "vH"
  },
  {
    "Name": "Imbued Breton",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Ward. When Imbued Breton is Consumed, give the consuming creature +1/+1 and Ward.",
    "Keywords": "Ward,Consume",
    "Played in": "85/14266 of  Eligible  decks (1 %)",
    "code": "vI"
  },
  {
    "Name": "Imbued Khajiit",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Drain. When Imbued Khajiit is Consumed, give the consuming creature +1/+1 and Drain.",
    "Keywords": "Drain,Consume,Drain",
    "Played in": "45/12907 of  Eligible  decks (0 %)",
    "code": "vF"
  },
  {
    "Name": "Imbued Minotaur",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Minotaur",
    "Magicka Cost": "3",
    "Attack": "5",
    "Health": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Breakthrough. When Imbued Minotaur is Consumed, give the consuming creature +1/+1 and Breakthrough.",
    "Keywords": "Breakthrough,Consume",
    "Played in": "123/12757 of  Eligible  decks (1 %)",
    "code": "vE"
  },
  {
    "Name": "Immolating Blast",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Randomly destroy all but one creature on both sides of each lane.",
    "Keywords": "",
    "Played in": "675/12907 of  Eligible  decks (5 %)",
    "code": "iF"
  },
  {
    "Name": "Imperial Armor",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+0/+6",
    "Keywords": "",
    "Played in": "232/13644 of  Eligible  decks (2 %)",
    "code": "iG"
  },
  {
    "Name": "Imperial Camp",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Ongoing. Summon: Put a 1/2 Septim Guardsman with Guard into your hand. Friendly Guards have +1/+0.",
    "Keywords": "",
    "Played in": "277/12907 of  Eligible  decks (2 %)",
    "code": "iH"
  },
  {
    "Name": "Imperial Lackey",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Last Gasp: If you have another creature in each lane, summon a 1/1 Recruit in each lane.",
    "Keywords": "",
    "Played in": "77/13644 of  Eligible  decks (1 %)",
    "code": "sC"
  },
  {
    "Name": "Imperial Legionnaire",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "177/12907 of  Eligible  decks (1 %)",
    "code": "iI"
  },
  {
    "Name": "Imperial Might",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the end of your turn, summon a 1/1 Imperial Grunt in a random lane.",
    "Keywords": "",
    "Played in": "206/12907 of  Eligible  decks (2 %)",
    "code": "iJ"
  },
  {
    "Name": "Imperial Reinforcements",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Fill a lane with 1/1 Imperial Grunts.",
    "Keywords": "",
    "Played in": "1591/12907 of  Eligible  decks (12 %)",
    "code": "iK"
  },
  {
    "Name": "Imperial Siege Engine",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: +1/+1 for each other friendly creature.",
    "Keywords": "",
    "Played in": "287/12907 of  Eligible  decks (2 %)",
    "code": "iL"
  },
  {
    "Name": "Imposter's Mission",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon an Imposter with power and health equal to the power of your most powerful creature.",
    "Keywords": "",
    "Played in": "66/12757 of  Eligible  decks (1 %)",
    "code": "iM"
  },
  {
    "Name": "Imprison",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Shackle a creature. If you have four or more (Willpower) creatures, destroy it instead.",
    "Keywords": "",
    "Played in": "1089/12916 of  Eligible  decks (8 %)",
    "Evolves from:": "Detain",
    "code": "iN"
  },
  {
    "Name": "Imprisoned Deathlord",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "4",
    "Attack": "7",
    "Health": "7",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When an enemy creature is summoned, Shackle Imprisoned Deathlord.",
    "Keywords": "",
    "Played in": "240/13644 of  Eligible  decks (2 %)",
    "code": "iO"
  },
  {
    "Name": "Improvised Weapon",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Breakthrough, +1/+1",
    "Keywords": "Breakthrough",
    "Played in": "829/12757 of  Eligible  decks (6 %)",
    "code": "iP"
  },
  {
    "Name": "Indomitable Ordinator",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. Exlat 1: Your opponent can't target Indomitable Ordinator with actions.",
    "Keywords": "Guard,Exalt",
    "Played in": "410/13644 of  Eligible  decks (3 %)",
    "code": "iQ"
  },
  {
    "Name": "Indoril Archmage",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "8",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Guard. Last Gasp: Indoril Archmage deals 6 damage to all enemy creatures in this lane.",
    "Keywords": "Guard,Last Gasp",
    "Played in": "674/14266 of  Eligible  decks (5 %)",
    "code": "iR"
  },
  {
    "Name": "Indoril Mastermind",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Draw a card.",
    "Keywords": "",
    "Played in": "1730/13644 of  Eligible  decks (13 %)",
    "code": "iS"
  },
  {
    "Name": "Innkeeper Delphine",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Breton",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "After you play a Dragon or Shout, Innkeeper Delphine changes into Grandmaster Delphine.",
    "Keywords": "",
    "Played in": "200/13644 of  Eligible  decks (1 %)",
    "code": "iV"
  },
  {
    "Name": "Insightful Scholar",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "5",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy. Summon: Draw a card for each card your opponent drew this turn.",
    "Keywords": "Prophecy",
    "Played in": "102/14266 of  Eligible  decks (1 %)",
    "code": "iW"
  },
  {
    "Name": "Inspiring Kinsman",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "willpower",
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Rally 2. Last Gasp: Give a random creature in your hand +2/+2.",
    "Keywords": "Rally,Last Gasp",
    "Played in": "310/806 of  Eligible  decks (38 %)",
    "code": "iX"
  },
  {
    "Name": "Inspiring Soldier",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Veteran: Summon a 1/1 Recruit.",
    "Keywords": "Veteran",
    "Played in": "118/13695 of  Eligible  decks (1 %)",
    "code": "tu"
  },
  {
    "Name": "Inspiring Stormcloak",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Last Gasp: Summon a 2/2 Rallying Stormcloak in each lane.",
    "Keywords": "Last Gasp",
    "Played in": "106/12757 of  Eligible  decks (1 %)",
    "code": "iY"
  },
  {
    "Name": "Intimidate",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Enemy creatures lose Guard.",
    "Keywords": "Guard",
    "Played in": "236/12759 of  Eligible  decks (2 %)",
    "code": "iZ"
  },
  {
    "Name": "Invasion Marauder",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Daedra",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Invade.",
    "Keywords": "Invade",
    "Played in": "76/12907 of  Eligible  decks (1 %)",
    "code": "xn"
  },
  {
    "Name": "Invasion Party",
    "Rarity": "Legendary",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Choose three times: Invade or summon a 1/1 Scamp.",
    "Keywords": "Invade",
    "Played in": "63/12907 of  Eligible  decks (0 %)",
    "code": "yE"
  },
  {
    "Name": "Invasion Scout",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Daedra",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Invade.",
    "Keywords": "Invade",
    "Played in": "91/12757 of  Eligible  decks (1 %)",
    "code": "xm"
  },
  {
    "Name": "Invasion Vanguard",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Daedra",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "4",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Invade.",
    "Keywords": "Invade",
    "Played in": "95/14266 of  Eligible  decks (1 %)",
    "code": "xl"
  },
  {
    "Name": "Invoker of the Hist",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Argonian",
    "Magicka Cost": "6",
    "Attack": "3",
    "Health": "6",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Veteran: Restore your Magicka.",
    "Keywords": "Veteran",
    "Played in": "36/13695 of  Eligible  decks (0 %)",
    "code": "uy"
  },
  {
    "Name": "Iron Atronach",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Daedra",
    "Magicka Cost": "12",
    "Attack": "12",
    "Health": "12",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Breakthrough, Guard, Regenerate. Your opponent can't target Iron Atronach with actions.",
    "Keywords": "Breakthrough,Guard,Regenerate",
    "Played in": "471/13644 of  Eligible  decks (3 %)",
    "code": "ja"
  },
  {
    "Name": "Ironscale Dragon",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Dragon",
    "Magicka Cost": "7",
    "Attack": "7",
    "Health": "7",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Regenerate",
    "Keywords": "Regenerate",
    "Played in": "498/13644 of  Eligible  decks (4 %)",
    "code": "jb"
  },
  {
    "Name": "J'zargo",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Put an Experimental Scroll into your hand.",
    "Keywords": "",
    "Played in": "108/14266 of  Eligible  decks (1 %)",
    "code": "jc"
  },
  {
    "Name": "Jarl Balgruuf",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "7",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Summon a Stormcloak Skirmisher in the left lane and a Colovian Trooper in the right lane. At the start of your turn, if your lanes are full, you win the game.",
    "Keywords": "",
    "Played in": "250/12907 of  Eligible  decks (2 %)",
    "code": "jd"
  },
  {
    "Name": "Jauffre",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Breton",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "9",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Choose another friendly creature. Damage that would be dealt to the chosen creature is dealt to Jauffre instead.",
    "Keywords": "",
    "Played in": "23/12916 of  Eligible  decks (0 %)",
    "code": "xC"
  },
  {
    "Name": "Jerall Forager",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "45/12757 of  Eligible  decks (0 %)",
    "code": "je"
  },
  {
    "Name": "Jiub",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Slay: Change into Saint Jiub, Eradicator of the Winged Menace.",
    "Keywords": "Slay",
    "Played in": "138/30872 of  Eligible  decks (0 %)",
    "code": "jf"
  },
  {
    "Name": "Jorunn the Skald-King",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "endurance",
      "agility"
    ],
    "Race": "Nord",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Immune to Silence. Friendly creatures cost 1 less. Enemy non-creatures cost 1 more.",
    "Keywords": "Silence",
    "Played in": "306/338 of  Eligible  decks (91 %)",
    "code": "tw"
  },
  {
    "Name": "Jorunn's Vanguard",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Veteran: +2/+2 and give the top creature of your deck +2/+2.",
    "Keywords": "Veteran",
    "Played in": "62/12757 of  Eligible  decks (0 %)",
    "code": "tx"
  },
  {
    "Name": "Journey to Sovngarde",
    "Rarity": "Legendary - Unique",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Shuffle all creatures from your discard pile into your deck, and give them +5/+5.",
    "Keywords": "",
    "Played in": "2268/30861 of  Eligible  decks (7 %)",
    "code": "jg"
  },
  {
    "Name": "Jyggalag's Incursion",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy. Each player gains +2 max magicka",
    "Keywords": "Prophecy",
    "Played in": "90/13644 of  Eligible  decks (1 %)",
    "code": "jh"
  },
  {
    "Name": "Kaalgrontiid",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Dragon",
    "Magicka Cost": "12",
    "Attack": "8",
    "Health": "9",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Summon the Halls of Colossus.",
    "Keywords": "Guard",
    "Played in": "153/12916 of  Eligible  decks (1 %)",
    "code": "vY"
  },
  {
    "Name": "Kagouti Fabricant",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Fabricant",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 4 - The Betrayal",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: If you have a [neutral] card in play, summon a copy of Kagouti Fabricant in the other lane.",
    "Keywords": "",
    "Played in": "140/12907 of  Eligible  decks (1 %)",
    "code": "ji"
  },
  {
    "Name": "Karthspire Scourge",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Dragon",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Give all enemy creatures in this lane -1/-0.",
    "Keywords": "",
    "Played in": "507/12907 of  Eligible  decks (4 %)",
    "code": "jj"
  },
  {
    "Name": "Karthspire Scout",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Orc",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "FrostSpark Collection",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Last Gasp: Draw a card and increase its cost by 1.",
    "Keywords": "Last Gasp",
    "Played in": "232/13644 of  Eligible  decks (2 %)",
    "code": "jk"
  },
  {
    "Name": "Keeper of Whispers",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Redguard",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Other friendly creatures can't be Silenced.",
    "Keywords": "",
    "Played in": "159/14266 of  Eligible  decks (1 %)",
    "code": "jl"
  },
  {
    "Name": "Keeper of the Gates",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "6",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When you Invade, Invade again.",
    "Keywords": "Invade",
    "Played in": "58/12757 of  Eligible  decks (0 %)",
    "code": "xL"
  },
  {
    "Name": "Khajiiti Warhelm",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "+1/+3. Summon: The wielder deals 1 damage to your opponent.",
    "Keywords": "",
    "Played in": "43/14266 of  Eligible  decks (0 %)",
    "code": "wu"
  },
  {
    "Name": "Khamira",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "willpower",
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "6",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Pilfer: Give Khajiit in your deck +1/+1.",
    "Keywords": "Pilfer",
    "Played in": "81/3723 of  Eligible  decks (2 %)",
    "code": "wW"
  },
  {
    "Name": "Khuul Lawkeeper",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "6",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard, Rally.",
    "Keywords": "Guard,Rally",
    "Played in": "698/12907 of  Eligible  decks (5 %)",
    "code": "jm"
  },
  {
    "Name": "Knife to the Throat",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 1 - Cloudy Dregs Inn",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Silence a creature. Draw a card.",
    "Keywords": "",
    "Played in": "479/30861 of  Eligible  decks (2 %)",
    "code": "jn"
  },
  {
    "Name": "Knight of Gnisis",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Rally. Summon: Put a 2/2 Colovian Trooper with Guard into your hand.",
    "Keywords": "Rally",
    "Played in": "370/13644 of  Eligible  decks (3 %)",
    "code": "jo"
  },
  {
    "Name": "Knight of Order",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Daedra",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Silence all other creatures in this lane.",
    "Keywords": "",
    "Played in": "94/13644 of  Eligible  decks (1 %)",
    "code": "jp"
  },
  {
    "Name": "Knight of the Hour",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 1 - Order of the Hour Barracks",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard. Summon: You gain 3 health.",
    "Keywords": "Prophecy,Guard",
    "Played in": "1296/12907 of  Eligible  decks (10 %)",
    "code": "jq"
  },
  {
    "Name": "Kvatch Soldier",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard",
    "Keywords": "Guard",
    "Played in": "1027/12907 of  Eligible  decks (8 %)",
    "code": "jr"
  },
  {
    "Name": "Kwama Queen",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Kwama",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Plot: Summon a 1/1 Kwama Forager in each lane. Other friendly Kwama have +1/+0.",
    "Keywords": "Plot",
    "Played in": "40/12907 of  Eligible  decks (0 %)",
    "code": "js"
  },
  {
    "Name": "Kynreeve Champion",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Daedra",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "When Kynreeve Champion takes damage, it deals that much damage to your opponent.",
    "Keywords": "",
    "Played in": "30/12757 of  Eligible  decks (0 %)",
    "code": "yA"
  },
  {
    "Name": "Laaneth",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "9",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 2 - Ending",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Draw a card of your choice from your deck.",
    "Keywords": "",
    "Played in": "2952/14271 of  Eligible  decks (21 %)",
    "code": "jt"
  },
  {
    "Name": "Lady Syl's Cruelty",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Sacrifice a creature to gain magicka this turn equal to its power.",
    "Keywords": "",
    "Played in": "61/13695 of  Eligible  decks (0 %)",
    "code": "jv"
  },
  {
    "Name": "Lame Corprus",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Ash Creature",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "6",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "25/14266 of  Eligible  decks (0 %)",
    "code": "jw"
  },
  {
    "Name": "Lay Down Arms",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Set a creature's power and health to 1.",
    "Keywords": "",
    "Played in": "192/13644 of  Eligible  decks (1 %)",
    "code": "jx"
  },
  {
    "Name": "Leaflurker",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Destroy a wounded creature.",
    "Keywords": "",
    "Played in": "4276/13703 of  Eligible  decks (31 %)",
    "code": "jy"
  },
  {
    "Name": "Leafwater Blessing",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Give a creature +1/+1. When you gain health draw Leafwater Blessing from your discard pile.",
    "Keywords": "",
    "Played in": "350/13695 of  Eligible  decks (3 %)",
    "code": "jA"
  },
  {
    "Name": "Legate Rikke",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "When you summon an Imperial, summon a 1/1 Imperial Grunt in the other lane.",
    "Keywords": "",
    "Played in": "257/12907 of  Eligible  decks (2 %)",
    "code": "jB"
  },
  {
    "Name": "Legion Praefect",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "7",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Other friendly creatures get +1/+1.",
    "Keywords": "",
    "Played in": "360/12907 of  Eligible  decks (3 %)",
    "code": "jC"
  },
  {
    "Name": "Legion Shield",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard, +1/+3",
    "Keywords": "Guard",
    "Played in": "314/12907 of  Eligible  decks (2 %)",
    "code": "jD"
  },
  {
    "Name": "Legion Zero Templar",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "5",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard. Summon: If you have another creature in each lane, +0/+3.",
    "Keywords": "Guard",
    "Played in": "52/12907 of  Eligible  decks (0 %)",
    "code": "tA"
  },
  {
    "Name": "Lesser Ward",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Give a creature a Ward.",
    "Keywords": "Ward",
    "Played in": "1480/14266 of  Eligible  decks (10 %)",
    "code": "jE"
  },
  {
    "Name": "Lich's Ascension",
    "Rarity": "Legendary",
    "Type": "Support",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Ongoing. Your cards cost 0. You may play only one card per turn.",
    "Keywords": "",
    "Played in": "37/13644 of  Eligible  decks (0 %)",
    "code": "jF"
  },
  {
    "Name": "Light of the Three",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Exalt 2: Give other friendly creatures in this lane +2/+2.",
    "Keywords": "Exalt",
    "Played in": "217/12907 of  Eligible  decks (2 %)",
    "code": "jG"
  },
  {
    "Name": "Lightning Bolt",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Deal 4 damage.",
    "Keywords": "Prophecy",
    "Played in": "11505/14266 of  Eligible  decks (81 %)",
    "code": "jH"
  },
  {
    "Name": "Lillandril Hexmage",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "After you play an action, deal 1 damage to your opponent.",
    "Keywords": "",
    "Played in": "1057/14266 of  Eligible  decks (7 %)",
    "code": "jJ"
  },
  {
    "Name": "Lion Guard Armaments",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Mobilize. +3/+4.",
    "Keywords": "Mobilize",
    "Played in": "48/14266 of  Eligible  decks (0 %)",
    "code": "tF"
  },
  {
    "Name": "Lion Guard Strategist",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Breton",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When you summon another creature in this lane, give it a Ward.",
    "Keywords": "Ward",
    "Played in": "163/13644 of  Eligible  decks (1 %)",
    "code": "jK"
  },
  {
    "Name": "Little Girl",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Vampire",
    "Magicka Cost": "4",
    "Attack": "0",
    "Health": "2",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 4 - Corpselight Farm",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "At the start of your turn, Little Girl changes into a 5/5 Ageless Vampire with Drain.",
    "Keywords": "Drain",
    "Played in": "545/13644 of  Eligible  decks (4 %)",
    "code": "jL"
  },
  {
    "Name": "Lockpick",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Either put another Lockpick into your hand or draw a card an dreduct its cost by 2, chosen randomly.",
    "Keywords": "",
    "Played in": "219/13703 of  Eligible  decks (2 %)",
    "code": "jM"
  },
  {
    "Name": "Lord of the Arena",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Minotaur",
    "Magicka Cost": "11",
    "Attack": "8",
    "Health": "8",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Choose two creatures to Battle each other.",
    "Keywords": "",
    "Played in": "10/12757 of  Eligible  decks (0 %)",
    "code": "yp"
  },
  {
    "Name": "Lower Canton Smith",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Plot: Equip a friendly creature with a +2/+2 Steel Scimitar.",
    "Keywords": "Plot",
    "Played in": "391/12757 of  Eligible  decks (3 %)",
    "code": "jN"
  },
  {
    "Name": "Lowland Troll",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Troll",
    "Magicka Cost": "7",
    "Attack": "4",
    "Health": "8",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Regenerate",
    "Keywords": "Regenerate",
    "Played in": "54/13644 of  Eligible  decks (0 %)",
    "code": "jO"
  },
  {
    "Name": "Loyal Housecarl",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "5",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Prophecy. Summon: Give a creature +2/+2 and Guard.",
    "Keywords": "Guard,Prophecy",
    "Played in": "731/12907 of  Eligible  decks (6 %)",
    "code": "jP"
  },
  {
    "Name": "Lucien Lachance",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "1",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Lethal. When another friendly creature Slays, give it +2/+2.",
    "Keywords": "Lethal,Slay",
    "Played in": "1476/13644 of  Eligible  decks (11 %)",
    "code": "jQ"
  },
  {
    "Name": "Lumbering Ogrim",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Daedra",
    "Magicka Cost": "4",
    "Attack": "7",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Lumbering Ogrim can't gain Cover.",
    "Keywords": "",
    "Played in": "382/12757 of  Eligible  decks (3 %)",
    "code": "jR"
  },
  {
    "Name": "Luminous Shards",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Destroy a creature with 1 power or less. Empower: +1 power.",
    "Keywords": "Empower",
    "Played in": "66/12907 of  Eligible  decks (1 %)",
    "code": "sT"
  },
  {
    "Name": "Lunar Sway",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Wax: Put a 3/3 Cathay-raht into your hand. Wane: Put a 4/4 Dagi-raht with Guard into your hand.",
    "Keywords": "Wax/Wane,Guard",
    "Played in": "99/30861 of  Eligible  decks (0 %)",
    "code": "wp"
  },
  {
    "Name": "Lurking Crocodile",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Reptile",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy",
    "Keywords": "Prophecy",
    "Played in": "1220/30861 of  Eligible  decks (4 %)",
    "Evolves from:": "Stalking Crocodile",
    "code": "jS"
  },
  {
    "Name": "Lurking Mummy",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Mummy",
    "Magicka Cost": "5",
    "Attack": "2",
    "Health": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard",
    "Keywords": "Guard,Prophecy",
    "Played in": "516/13644 of  Eligible  decks (4 %)",
    "code": "jT"
  },
  {
    "Name": "Lute",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "+1/+2. The wielder is immune to Silence.",
    "Keywords": "",
    "Played in": "507/30872 of  Eligible  decks (2 %)",
    "code": "jU"
  },
  {
    "Name": "Luzrah gro-Shar",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Orc",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "When you summon a creature with 6 cost or more, both Luzrah and that creature gain +1/+1.",
    "Keywords": "",
    "Played in": "754/14266 of  Eligible  decks (5 %)",
    "code": "jV"
  },
  {
    "Name": "Lydia",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "8",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Guard. Lydia guards both lanes.",
    "Keywords": "Guard",
    "Played in": "697/12916 of  Eligible  decks (5 %)",
    "code": "jW"
  },
  {
    "Name": "Lyris Titanborn",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "At the start of your turn, destroy your oppnent's front rune.",
    "Keywords": "",
    "Played in": "247/12757 of  Eligible  decks (2 %)",
    "code": "tB"
  },
  {
    "Name": "Mace of Encumbrance",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "+2/+1. Summon: Shackle an enemy creature.",
    "Keywords": "",
    "Played in": "1403/14266 of  Eligible  decks (10 %)",
    "code": "jX"
  },
  {
    "Name": "Mad Dash",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Move a friendly creature, then give it +1/+1 for each enemy creature in its lane.",
    "Keywords": "",
    "Played in": "169/13695 of  Eligible  decks (1 %)",
    "code": "jY"
  },
  {
    "Name": "Madness Beckons",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Promotional Cards",
    "Unlocked in": "Limited Sheogorath offer",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Put a random Isle of Madness card into your hand.",
    "Keywords": "",
    "Played in": "72/30861 of  Eligible  decks (0 %)",
    "code": "jZ"
  },
  {
    "Name": "Mage Slayer",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Mage Slayer can't be damaged by actions.",
    "Keywords": "",
    "Played in": "466/12757 of  Eligible  decks (4 %)",
    "code": "ka"
  },
  {
    "Name": "Mage's Trick",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "intelligence",
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Deal 1 damage, gain 1 health, and draw a card.",
    "Keywords": "",
    "Played in": "892/4500 of  Eligible  decks (20 %)",
    "code": "kb"
  },
  {
    "Name": "Mages Guild Conjurer",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "6",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Expertise: Summon a Flame Atronach, then upgrade the Atronach Mages Guild Conjurer summons.",
    "Keywords": "Expertise",
    "Played in": "101/14266 of  Eligible  decks (1 %)",
    "code": "uE"
  },
  {
    "Name": "Mages Guild Recruit",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Argonian",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Reduce the cost of an action in your hand by 2.",
    "Keywords": "",
    "Played in": "464/14266 of  Eligible  decks (3 %)",
    "code": "kc"
  },
  {
    "Name": "Mages Guild Retreat",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the end of each turn, if you played two actions, summon a random Atronach.",
    "Keywords": "",
    "Played in": "331/14266 of  Eligible  decks (2 %)",
    "code": "kd"
  },
  {
    "Name": "Malefic Wreath",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Give a creature -2/-2.",
    "Keywords": "",
    "Played in": "215/13695 of  Eligible  decks (2 %)",
    "code": "ke"
  },
  {
    "Name": "Manic Grummite/Demented Grummite",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Grummite",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "24/30861 of  Eligible  decks (0 %)",
    "code": "kf"
  },
  {
    "Name": "Manic Jack/Manic Mutation",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "578/14266 of  Eligible  decks (4 %)",
    "code": "kg"
  },
  {
    "Name": "Mankar Camoran",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "After you play an action, Invade. Friendly Oblivion Gates have +4/+0.",
    "Keywords": "Invade",
    "Played in": "77/3939 of  Eligible  decks (2 %)",
    "code": "xg"
  },
  {
    "Name": "Mannimarco",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "High Elf",
    "Magicka Cost": "10",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Summon a creature from your opponent's discard pile.",
    "Keywords": "",
    "Played in": "371/13651 of  Eligible  decks (3 %)",
    "code": "tD"
  },
  {
    "Name": "Mantikora",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Mantikora",
    "Magicka Cost": "10",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. Summon: Destroy an enemy creature in this lane.",
    "Keywords": "Guard",
    "Played in": "2550/12916 of  Eligible  decks (20 %)",
    "code": "kh"
  },
  {
    "Name": "Maple Shield",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+0/+3",
    "Keywords": "",
    "Played in": "453/30861 of  Eligible  decks (1 %)",
    "code": "ki"
  },
  {
    "Name": "Marauder Chieftain",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "4",
    "Attack": "1",
    "Health": "5",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Give a creature +1/+0. When another friendly creature gains power, Marauder Chieftain also gains that much power.",
    "Keywords": "",
    "Played in": "76/12757 of  Eligible  decks (1 %)",
    "code": "xW"
  },
  {
    "Name": "Markarth Bannerman",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When Markarth Bannerman attacks, put two 1/1 Nord Firebrands with Charge into your hand.",
    "Keywords": "Charge",
    "Played in": "1120/12757 of  Eligible  decks (9 %)",
    "code": "kj"
  },
  {
    "Name": "Marked Man",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 3 - Grave Concoction",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Put a 0/2 Makeshift Defenses with Guard into your hand.",
    "Keywords": "Guard",
    "Played in": "1826/12907 of  Eligible  decks (14 %)",
    "code": "kk"
  },
  {
    "Name": "Martin Septim",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "agility",
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "7",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "At the start of your turn, gain all unspent magicka from your last turn. When you have 30 or more magicka, Martin Septim changes into a 30/30 Avatar of Akatosh.",
    "Keywords": "",
    "Played in": "120/4386 of  Eligible  decks (3 %)",
    "code": "xh"
  },
  {
    "Name": "Master Swordsmith",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Redguard",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "At the start of your turn, give each item in your deck +1/+1.",
    "Keywords": "",
    "Played in": "504/14266 of  Eligible  decks (4 %)",
    "code": "ko"
  },
  {
    "Name": "Master of Arms",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Redguard",
    "Magicka Cost": "6",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Master of Arms equips the two highest cost items in your discard pile.",
    "Keywords": "",
    "Played in": "897/14266 of  Eligible  decks (6 %)",
    "Evolves from:": "Student of Arms",
    "code": "kl"
  },
  {
    "Name": "Master of Incunabula",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "intelligence",
      "willpower"
    ],
    "Race": "High Elf",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "6",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Master of Incunabula has the Expertise abilities of all your creatures.",
    "Keywords": "Expertise",
    "Played in": "71/407 of  Eligible  decks (17 %)",
    "code": "uD"
  },
  {
    "Name": "Master of Thieves",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower",
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Friendly creatures with Pilfer can attack an additional time each turn.",
    "Keywords": "Pilfer",
    "Played in": "749/3720 of  Eligible  decks (20 %)",
    "code": "kn"
  },
  {
    "Name": "Mausoleum Delver",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Charge. pilfer: Steal a card from your opponent's discard pile to yours.",
    "Keywords": "Charge,Pilfer",
    "Played in": "19/13695 of  Eligible  decks (0 %)",
    "code": "wL"
  },
  {
    "Name": "Mechanical Ally",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Summon a Spider Worker if the top card of your deck is (Neutral).",
    "Keywords": "",
    "Played in": "526/30861 of  Eligible  decks (2 %)",
    "code": "kp"
  },
  {
    "Name": "Mecinar's Will",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 4 - The Apprentice",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Steal an enemy creature with 3 power or less until the end of turn. It gains Charge.",
    "Keywords": "Charge",
    "Played in": "211/12907 of  Eligible  decks (2 %)",
    "code": "kr"
  },
  {
    "Name": "Mecinar",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "8",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 6 - Chamber of Lorkhan",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Stitch together the top creature from both decks to create an Abomination and put it into your hand.",
    "Keywords": "",
    "Played in": "482/30872 of  Eligible  decks (2 %)",
    "code": "kq"
  },
  {
    "Name": "Mehrunes Dagon's Flayer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Daedra",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "5",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "At the start of your turn, deal 1 damage to another friendly creature and give it +2/+0.",
    "Keywords": "",
    "Played in": "70/12757 of  Eligible  decks (1 %)",
    "code": "xZ"
  },
  {
    "Name": "Mehrunes Dagon's Seducer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "6",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Breakthrough, Drain.",
    "Keywords": "Breakthrough,Drain",
    "Played in": "126/12907 of  Eligible  decks (1 %)",
    "code": "yd"
  },
  {
    "Name": "Memory Wraith",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Spirit",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 6 - The Throne Aligned",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Banish your opponent's discard pile.",
    "Keywords": "",
    "Played in": "530/14266 of  Eligible  decks (4 %)",
    "code": "ks"
  },
  {
    "Name": "Mentor of the Watch",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard. Summon: Give a creature in your hand Guard.",
    "Keywords": "Prophecy,Guard",
    "Played in": "440/13644 of  Eligible  decks (3 %)",
    "code": "kt"
  },
  {
    "Name": "Mentor's Ring",
    "Rarity": "Legendary",
    "Type": "Item",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "+3/+3. Summon: Give all your other creatures the keywords of this creature.",
    "Keywords": "",
    "Played in": "1056/14266 of  Eligible  decks (7 %)",
    "code": "ku"
  },
  {
    "Name": "Mercenary Captain",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Consume a creature to give other friendly creatures +1/+1.",
    "Keywords": "Consume",
    "Played in": "222/12907 of  Eligible  decks (2 %)",
    "code": "wG"
  },
  {
    "Name": "Merchant's Camel",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Beast",
    "Magicka Cost": "4",
    "Attack": "1",
    "Health": "4",
    "Expansion Set": "Madhouse Collection",
    "Soul Summon": "This card belongs to the Madhouse Collection and cannot be Soul Summoned.",
    "Soul Trap": "This card belongs to the Madhouse Collection and cannot be Soul Trapped.",
    "Text": "Summon: Look at the top three cards of your deck. Put one into your hand and discard the others.",
    "Keywords": "",
    "Played in": "2224/30861 of  Eligible  decks (7 %)",
    "code": "kv"
  },
  {
    "Name": "Merric-at-Aswala",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "intelligence"
    ],
    "Race": "Redguard",
    "Magicka Cost": "7",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Equip all friendly creatures in this lane with a random item.",
    "Keywords": "",
    "Played in": "1026/3939 of  Eligible  decks (26 %)",
    "code": "kw"
  },
  {
    "Name": "Midnight Burial",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Tamriel Collection",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Betray. Choose a creature in your deck. Create a copy of that creature in your discards pile and give it +1/+1.",
    "Keywords": "Betray",
    "Played in": "34/13644 of  Eligible  decks (0 %)",
    "code": "Bn"
  },
  {
    "Name": "Midnight Snack",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Nord",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard. Last Gasp: Reduce the cost of a random Dragon in your hand by 1.",
    "Keywords": "Prophecy,Guard,Last Gasp",
    "Played in": "1107/30861 of  Eligible  decks (4 %)",
    "code": "kx"
  },
  {
    "Name": "Midnight Sweep",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy. Summon a 2/2 Colovian Trooper with Guard in each lane.",
    "Keywords": "Guard,Prophecy",
    "Played in": "1419/13644 of  Eligible  decks (10 %)",
    "code": "ky"
  },
  {
    "Name": "Midnight Trespasser",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "1",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Consume a creature to gain +1/+1.",
    "Keywords": "Consume",
    "Played in": "171/14266 of  Eligible  decks (1 %)",
    "code": "wf"
  },
  {
    "Name": "Mighty Ally",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: +3/+0 and breakthrough if the top card of your deck is (Strength).",
    "Keywords": "",
    "Played in": "1149/12757 of  Eligible  decks (9 %)",
    "code": "kz"
  },
  {
    "Name": "Mighty Conjuring",
    "Rarity": "Legendary",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon a random Atronach. If you have a creature with 5 power or more, summon a Lava Atronach instead.",
    "Keywords": "",
    "Played in": "846/14266 of  Eligible  decks (6 %)",
    "code": "kA"
  },
  {
    "Name": "Militant Chieftain",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "endurance"
    ],
    "Race": "Orc",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Draw a random Orc from your discard pile. Other friendly Orcs have +1/+1.",
    "Keywords": "",
    "Played in": "451/3890 of  Eligible  decks (12 %)",
    "code": "kB"
  },
  {
    "Name": "Miraak, Dragonborn",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "11",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Steal an enemy creature.",
    "Keywords": "",
    "Played in": "3172/12907 of  Eligible  decks (25 %)",
    "code": "kC"
  },
  {
    "Name": "Miscarcand Lich",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Choose an enemy creature. At the start of your turn, if the chosen creature is alive, summon a 1/1 Risen Dead with Guard in its lane.",
    "Keywords": "",
    "Played in": "6/13644 of  Eligible  decks (0 %)",
    "code": "xO"
  },
  {
    "Name": "Mistveil Enchanter",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Ward. Summon: +2/+0 if you have another creature with Ward.",
    "Keywords": "Ward",
    "Played in": "46/14266 of  Eligible  decks (0 %)",
    "code": "kD"
  },
  {
    "Name": "Mistveil Warden",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 1 - Mistveil Dungeon",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Treasure Hunt - Guard: Give the Guard +1/+2.",
    "Keywords": "Treasure Hunt,Guard",
    "Played in": "77/13644 of  Eligible  decks (1 %)",
    "code": "kE"
  },
  {
    "Name": "Modryn Oreyn",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Breakthrough. Summon: Your opponent summons a Blackwood Hoodlum in each lane.",
    "Keywords": "Breakthrough",
    "Played in": "10/12757 of  Eligible  decks (0 %)",
    "code": "yc"
  },
  {
    "Name": "Moment of Clarity",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Reveal three random cards, then choose one to put into your hand.",
    "Keywords": "",
    "Played in": "451/14266 of  Eligible  decks (3 %)",
    "code": "kF"
  },
  {
    "Name": "Monastic Champion",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "5",
    "Attack": "6",
    "Health": "5",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Breakthrough. Pilfer: Summon a 3/3 Cathay-raht.",
    "Keywords": "Breakthrough,Pilfer",
    "Played in": "119/12907 of  Eligible  decks (1 %)",
    "code": "wC"
  },
  {
    "Name": "Monster Perfection Lab",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": ["strength", "intelligence"],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the end of your turn, you may choose a friendly creature wielding three or more items. If you do, sacrifice Monster Perfection Lab and choose an item from your deck to equip to the creature.",
    "Keywords": "",
    "code": "yQ"
  },
  {
    "Name": "Monk's Strike",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "willpower",
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Move a friendly creature and give it +3/+0 and Drain this turn.",
    "Keywords": "Drain",
    "Played in": "861/3720 of  Eligible  decks (23 %)",
    "code": "kG"
  },
  {
    "Name": "Moon Bishop",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Wax: +0/+4. Wane: You gain 4 health.",
    "Keywords": "Wax/Wane",
    "Played in": "114/12907 of  Eligible  decks (1 %)",
    "code": "wU"
  },
  {
    "Name": "Moon Gate",
    "Rarity": "Common",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Uses: 2. Activate: Get both Wax and Wane effects this turn.",
    "Keywords": "Wax/Wane",
    "Played in": "136/30861 of  Eligible  decks (0 %)",
    "code": "wo"
  },
  {
    "Name": "Moon Sugar Smuggler",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Last Gasp: Gain 2 magicka this turn.",
    "Keywords": "Last Gasp",
    "Played in": "159/13695 of  Eligible  decks (1 %)",
    "code": "kH"
  },
  {
    "Name": "Moonlight Werebat",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Beast",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Prophecy, Drain",
    "Keywords": "Drain,Prophecy",
    "Played in": "2200/13695 of  Eligible  decks (16 %)",
    "Evolves from:": "Twilight Werebat",
    "code": "kI"
  },
  {
    "Name": "Moonmoth Castellan",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard. Plot: Put a random Guard into your hand.",
    "Keywords": "Guard,Plot",
    "Played in": "470/12907 of  Eligible  decks (4 %)",
    "code": "kJ"
  },
  {
    "Name": "Moonphase Suthay",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Wax: +1/+1 and Drain. Wane: Draw a card.",
    "Keywords": "Wax/Wane,Drain",
    "Played in": "200/13695 of  Eligible  decks (1 %)",
    "code": "wH"
  },
  {
    "Name": "Moontouched Guardian",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Wax: Give a creature in your hand +2/+2. Wane: Guard and Ward.",
    "Keywords": "Wax/Wane,Guard,Ward",
    "Played in": "122/13644 of  Eligible  decks (1 %)",
    "code": "wE"
  },
  {
    "Name": "Morag Tong Aspirant",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "1",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Slay: Summon a copy of Morag Tong Aspirant.",
    "Keywords": "Slay",
    "Played in": "676/13695 of  Eligible  decks (5 %)",
    "code": "kK"
  },
  {
    "Name": "Morag Tong Assassin",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Summon a 0/1 Target with Guard for your opponent. Slay: +1/+1.",
    "Keywords": "Guard,Slay",
    "Played in": "337/13695 of  Eligible  decks (2 %)",
    "code": "kL"
  },
  {
    "Name": "Morag Tong Nightblade",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Summon a 0/1 Target with Guard for your opponent. Slay: Draw a card. If it's an action, reduce its cost to 0.",
    "Keywords": "Guard,Slay",
    "Played in": "311/12907 of  Eligible  decks (2 %)",
    "code": "kM"
  },
  {
    "Name": "Morkul Gatekeeper",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard. Summon: Give a creature +2/+0.",
    "Keywords": "Guard,Prophecy",
    "Played in": "4331/12757 of  Eligible  decks (34 %)",
    "code": "kN"
  },
  {
    "Name": "Morokei, the Deathless",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Forgotten Hero Collection",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: If you started the game with no duplicate cards in your deck, you gain 5 health and restore a rune.",
    "Keywords": "",
    "Played in": "514/30861 of  Eligible  decks (2 %)",
    "code": "kP"
  },
  {
    "Name": "Morthal Executioner",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "When an enemy rune is destroyed, Morthal Executioner gains +2/+0.",
    "Keywords": "",
    "Played in": "598/12907 of  Eligible  decks (5 %)",
    "code": "kQ"
  },
  {
    "Name": "Morthal Watchman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "1",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "84/12757 of  Eligible  decks (1 %)",
    "code": "kR"
  },
  {
    "Name": "Mountain Lion",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Beast",
    "Magicka Cost": "3",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Gain 1 magicka this turn.",
    "Keywords": "",
    "Played in": "37/13695 of  Eligible  decks (0 %)",
    "code": "ym"
  },
  {
    "Name": "Mountain Tyrant",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Giant",
    "Magicka Cost": "6",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard",
    "Keywords": "Guard",
    "Played in": "153/13644 of  Eligible  decks (1 %)",
    "code": "kS"
  },
  {
    "Name": "Mournhold Guardian",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "1",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard",
    "Keywords": "Guard",
    "Played in": "154/13695 of  Eligible  decks (1 %)",
    "code": "kT"
  },
  {
    "Name": "Mournhold Pilgrim",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Regenerate. Exalt 3: +2/+2",
    "Keywords": "Regenerate,Exalt",
    "Played in": "118/13644 of  Eligible  decks (1 %)",
    "code": "kU"
  },
  {
    "Name": "Mournhold Taskmaster",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "agility",
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Friendly creatures with Veteran have Charge.",
    "Keywords": "Veteran,Charge",
    "Played in": "72/338 of  Eligible  decks (21 %)",
    "code": "tG"
  },
  {
    "Name": "Mournhold Traitor",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "2",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Last Gasp: Your opponent summons a 2/1 Mournhold Guardian with Guard.",
    "Keywords": "Last Gasp",
    "Played in": "2167/13695 of  Eligible  decks (16 %)",
    "code": "kV"
  },
  {
    "Name": "Move in Shadows",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Move a friendly creature. It moves again at the end of the turn.",
    "Keywords": "",
    "Played in": "391/13695 of  Eligible  decks (3 %)",
    "code": "kW"
  },
  {
    "Name": "Mudcrab Anklesnapper",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Mudcrab",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Deal 1 damage to your opponent.",
    "Keywords": "",
    "Played in": "536/30861 of  Eligible  decks (2 %)",
    "code": "kX"
  },
  {
    "Name": "Mudcrab Merchant",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Mudcrab",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: The Merchant shows you two cards he has for sale. Choose one to put into your hand. He puts the other into your opponent's hand.",
    "Keywords": "",
    "Played in": "1120/30861 of  Eligible  decks (4 %)",
    "code": "kY"
  },
  {
    "Name": "Mulaamnir",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Dragon",
    "Magicka Cost": "9",
    "Attack": "9",
    "Health": "8",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon and Slay: Battle an enemy creature with less power than Mulaamnir's health.",
    "Keywords": "Slay",
    "Played in": "213/12759 of  Eligible  decks (2 %)",
    "code": "wJ"
  },
  {
    "Name": "Mummify",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy. Transform a creature into a 2/2 Shriveled Mummy.",
    "Keywords": "Prophecy",
    "Played in": "2061/13651 of  Eligible  decks (15 %)",
    "code": "kZ"
  },
  {
    "Name": "Mundus Stone",
    "Rarity": "Legendary - Unique",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "When you summon a creature, give it a random keyword.",
    "Keywords": "",
    "Played in": "2260/30861 of  Eligible  decks (7 %)",
    "code": "la"
  },
  {
    "Name": "Murkwater Butcher",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Goblin",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "If Murkwater Butcher is in your hand during your first turn, reduce his cost to 1.",
    "Keywords": "",
    "Played in": "318/13695 of  Eligible  decks (2 %)",
    "code": "lb"
  },
  {
    "Name": "Murkwater Goblin",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Goblin",
    "Magicka Cost": "0",
    "Attack": "0",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Murkwater Goblin has +2/+0 on your turn.",
    "Keywords": "",
    "Played in": "519/13695 of  Eligible  decks (4 %)",
    "code": "lc"
  },
  {
    "Name": "Murkwater Guide",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Goblin",
    "Magicka Cost": "3",
    "Attack": "4",
    "Health": "2",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 3 - Mire Mechanica",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Treasure Hunt - 0-cost card: Put a copy of the \"treasure\" into your hand.",
    "Keywords": "Treasure Hunt",
    "Played in": "335/13695 of  Eligible  decks (2 %)",
    "code": "ld"
  },
  {
    "Name": "Murkwater Savage",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Goblin",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "When you summon another (Agility) creature, Murkwater Savage gains +1/+1.",
    "Keywords": "",
    "Played in": "527/13695 of  Eligible  decks (4 %)",
    "code": "le"
  },
  {
    "Name": "Murkwater Scourge",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Goblin",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "1",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon and Last Gasp: Put a Curse into your hand.",
    "Keywords": "",
    "Played in": "380/13695 of  Eligible  decks (3 %)",
    "code": "sp"
  },
  {
    "Name": "Murkwater Shaman",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Goblin",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the start of your turn, put a Curse into your hand.",
    "Keywords": "",
    "Played in": "1384/13695 of  Eligible  decks (10 %)",
    "code": "lf"
  },
  {
    "Name": "Murkwater Skirmisher",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Goblin",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Give all other friendly Goblins +2/+2.",
    "Keywords": "",
    "Played in": "386/13695 of  Eligible  decks (3 %)",
    "code": "lg"
  },
  {
    "Name": "Murkwater Witch",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Goblin",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard. Summon: Give a creature -1/-1.",
    "Keywords": "Guard",
    "Played in": "2197/13695 of  Eligible  decks (16 %)",
    "code": "lh"
  },
  {
    "Name": "Mushroom Tower",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "9",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Ongoing. Your actions have Betray.",
    "Keywords": "Betray",
    "Played in": "310/13644 of  Eligible  decks (2 %)",
    "code": "li"
  },
  {
    "Name": "Mute",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Silence two creatures",
    "Keywords": "",
    "Played in": "49/13651 of  Eligible  decks (0 %)",
    "code": "yq"
  },
  {
    "Name": "Mystic Dragon",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dragon",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy",
    "Keywords": "Prophecy",
    "Played in": "1670/14266 of  Eligible  decks (12 %)",
    "code": "lj"
  },
  {
    "Name": "Mystic of Ancient Rites",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When Mystic of Ancient Rites Empowers an action in your hand, the Empower bonus does not expire at the end of turn.",
    "Keywords": "Empower",
    "Played in": "41/12907 of  Eligible  decks (0 %)",
    "code": "ty"
  },
  {
    "Name": "Mythic Dawn Acolyte",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "At the end of each turn, if you Invaded, deal 2 damage.",
    "Keywords": "",
    "Played in": "16/14266 of  Eligible  decks (0 %)",
    "code": "zC"
  },
  {
    "Name": "Mythic Dawn Informer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Last Gasp: Put a random Daedra into your hand.",
    "Keywords": "Last Gasp",
    "Played in": "47/14266 of  Eligible  decks (0 %)",
    "code": "xi"
  },
  {
    "Name": "Mythic Dawn Zealot",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "At the end of each turn, if you Invaded, put a 1/1 Scamp into your hand.",
    "Keywords": "",
    "Played in": "20/12907 of  Eligible  decks (0 %)",
    "code": "zA"
  },
  {
    "Name": "Nahagliiv",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Dragon",
    "Magicka Cost": "7",
    "Attack": "7",
    "Health": "7",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Guard. Your opponent can't target Nahagliiv with actions.",
    "Keywords": "Guard",
    "Played in": "3108/13651 of  Eligible  decks (23 %)",
    "code": "lk"
  },
  {
    "Name": "Nahkriin, Dragon Priest",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "9",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Draw a card and reduce its cost to 0.",
    "Keywords": "",
    "Played in": "504/14266 of  Eligible  decks (4 %)",
    "code": "ll"
  },
  {
    "Name": "Namira's Shrine",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Forgotten Hero Collection",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Ongoing. At the end of your turn, if you played three cards this turn, draw a card.",
    "Keywords": "",
    "Played in": "1016/30861 of  Eligible  decks (3 %)",
    "code": "lm"
  },
  {
    "Name": "Naryu Virian",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "6",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Summon a 0/1 Target with Guard for your opponent in each lane. Friendly creatures have \"Slay: +1/+1 and Lethal.\"",
    "Keywords": "Slay,Lethal,Guard",
    "Played in": "501/13695 of  Eligible  decks (4 %)",
    "code": "ln"
  },
  {
    "Name": "Necrom Mastermind",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Trigger the Last Gasp of each friendly creature.",
    "Keywords": "Last Gasp",
    "Played in": "394/13695 of  Eligible  decks (3 %)",
    "code": "lo"
  },
  {
    "Name": "Necromancer's Amulet",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When a friendly creature is destroyed, gain 1 health.",
    "Keywords": "",
    "Played in": "899/13644 of  Eligible  decks (7 %)",
    "code": "lp"
  },
  {
    "Name": "Nereid Sister",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Nereid",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "5",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Gain a random Keyword. When Nereid Sister gains a Keyword, give all friendly Nereid Sisters in play, hand and deck that keyword.",
    "Keywords": "",
    "Played in": "55/14266 of  Eligible  decks (0 %)",
    "code": "tC"
  },
  {
    "Name": "Nervous Giant",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Giant",
    "Magicka Cost": "4",
    "Attack": "6",
    "Health": "5",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "If Nervous Giant takes exactly 1 damage, destroy him.",
    "Keywords": "",
    "Played in": "57/12757 of  Eligible  decks (0 %)",
    "code": "lr"
  },
  {
    "Name": "Nest of Vipers",
    "Rarity": "Legendary",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "10",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Fill a lane with territorial Vipers.",
    "Keywords": "",
    "Played in": "165/13695 of  Eligible  decks (1 %)",
    "code": "ls"
  },
  {
    "Name": "Niben Bay Cutthroat",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Redguard",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+2/+0 while there are no enemy creatures in this lane.",
    "Keywords": "",
    "Played in": "42/14266 of  Eligible  decks (0 %)",
    "code": "lt"
  },
  {
    "Name": "Nibenese Mercenary",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Consume a creature to gain +0/+2.",
    "Keywords": "Consume",
    "Played in": "73/13644 of  Eligible  decks (1 %)",
    "code": "wg"
  },
  {
    "Name": "Night Predator",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Werewolf",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Breakthrough, Regenerate",
    "Keywords": "Breakthrough,Regenerate",
    "Played in": "185/13644 of  Eligible  decks (1 %)",
    "Evolves from:": "Night Patrol",
    "code": "lv"
  },
  {
    "Name": "Night Shadow",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Vampire",
    "Magicka Cost": "6",
    "Attack": "6",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Breakthrough, Drain",
    "Keywords": "Breakthrough,Drain",
    "Played in": "1677/13644 of  Eligible  decks (12 %)",
    "Evolves from:": "Night Patrol",
    "code": "lw"
  },
  {
    "Name": "Night Talon Lord",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Vampire",
    "Magicka Cost": "9",
    "Attack": "8",
    "Health": "8",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Drain. Slay: Summon the slain creature",
    "Keywords": "Drain,Slay",
    "Played in": "1412/13644 of  Eligible  decks (10 %)",
    "Evolves from:": "Volkihar Lord",
    "code": "lx"
  },
  {
    "Name": "Nightprowler",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Falmer",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "When Nightprowler gains Cover, draw a card.",
    "Keywords": "",
    "Played in": "69/13703 of  Eligible  decks (1 %)",
    "code": "ly"
  },
  {
    "Name": "Nimble Ally",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: +1/+1 and Lethal if the top card of your deck is (Agility).",
    "Keywords": "Lethal",
    "Played in": "1021/13695 of  Eligible  decks (7 %)",
    "code": "lz"
  },
  {
    "Name": "Nix-Hound Fabricant",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Fabricant",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 5 - Piston Cavum",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Drain. Summon: If you have a [neutral] card in play, Shackle an enemy creature.",
    "Keywords": "Drain,Shackle",
    "Played in": "99/13695 of  Eligible  decks (1 %)",
    "code": "lB"
  },
  {
    "Name": "Nix-Hound",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Beast",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Summon: Shackle each enemy creature with less power than Nix-Hound.",
    "Keywords": "Prophecy",
    "Played in": "115/13695 of  Eligible  decks (1 %)",
    "code": "lA"
  },
  {
    "Name": "Nix-Ox",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Beast",
    "Magicka Cost": "7",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Gain 5 magicka this turn.",
    "Keywords": "",
    "Played in": "669/13695 of  Eligible  decks (5 %)",
    "code": "lC"
  },
  {
    "Name": "Nord Firebrand",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "0",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Charge",
    "Keywords": "Charge",
    "Played in": "2330/12757 of  Eligible  decks (18 %)",
    "code": "lD"
  },
  {
    "Name": "Northpoint Captain",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Breton",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Summon a 0/4 Northpoint Herald with Guard.",
    "Keywords": "Guard",
    "Played in": "334/13644 of  Eligible  decks (2 %)",
    "Evolves from:": "Northpoint Lieutenant",
    "code": "lE"
  },
  {
    "Name": "Northwind Outpost",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Friendly (Strength) creatures have +1/+0.",
    "Keywords": "",
    "Played in": "1186/12757 of  Eligible  decks (9 %)",
    "code": "lG"
  },
  {
    "Name": "Oblivion Invasion",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Invade.",
    "Keywords": "Invade",
    "Played in": "96/30861 of  Eligible  decks (0 %)",
    "code": "xq"
  },
  {
    "Name": "Obstinate Goat",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Beast",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Tamriel Collection",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: If the top card of your deck is an Animal, draw it. Otherwise, put it on the bottom.",
    "Keywords": "",
    "Played in": "8/13695 of  Eligible  decks (0 %)",
    "code": "Bg"
  },
  {
    "Name": "Occult Ritemaster",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Orc",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Put a Steel Dagger into your hand. When Occult Ritemaster equips an item, Invade.",
    "Keywords": "Invade",
    "Played in": "13/14266 of  Eligible  decks (0 %)",
    "code": "yv"
  },
  {
    "Name": "Odahviing",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dragon",
    "Magicka Cost": "12",
    "Attack": "10",
    "Health": "10",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Deal 4 damage to each enemy creature.",
    "Keywords": "",
    "Played in": "4693/30872 of  Eligible  decks (15 %)",
    "code": "lH"
  },
  {
    "Name": "Odirniran Necromancer",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "6",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Summon a creature from your discard pile with power less than Odirniran Necromancer.",
    "Keywords": "",
    "Played in": "2279/13644 of  Eligible  decks (17 %)",
    "code": "lI"
  },
  {
    "Name": "Old Salty's Assault",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon one of each Mudcrab from your deck.",
    "Keywords": "",
    "Played in": "109/30861 of  Eligible  decks (0 %)",
    "code": "xe"
  },
  {
    "Name": "Oldgate Warden",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Breton",
    "Magicka Cost": "2",
    "Attack": "0",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard, Regenerate",
    "Keywords": "Guard,Regenerate",
    "Played in": "644/13644 of  Eligible  decks (5 %)",
    "code": "lJ"
  },
  {
    "Name": "Orb of Vaermina",
    "Rarity": "Legendary - Unique",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Uses: 3. Activate: Put a copy of a random card from your opponent's deck into your hand.",
    "Keywords": "",
    "Played in": "738/30861 of  Eligible  decks (2 %)",
    "code": "lK"
  },
  {
    "Name": "Orc Clan Captain",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Other friendly creatures in this lane have +1/+0.",
    "Keywords": "",
    "Played in": "3761/12757 of  Eligible  decks (29 %)",
    "Evolves from:": "Orc Clansman",
    "code": "lL"
  },
  {
    "Name": "Orc Clan Shaman",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Breakthrough. Other friendly Orcs in this lane have Breakthrough.",
    "Keywords": "Breakthrough",
    "Played in": "499/12757 of  Eligible  decks (4 %)",
    "Evolves from:": "Orc Clansman",
    "code": "lM"
  },
  {
    "Name": "Orcish Warhammer",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Breakthrough, +3/+3",
    "Keywords": "Breakthrough",
    "Played in": "455/12757 of  Eligible  decks (4 %)",
    "code": "lO"
  },
  {
    "Name": "Ordinator of the Almsivi",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "willpower",
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Tamriel Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. Exalt 3: +2/+2. Ordinator of the Almsivi is permanently Shackled unless you have an Exalted creature in play.",
    "Keywords": "Guard,Exalt",
    "Played in": "7/1015 of  Eligible  decks (1 %)",
    "code": "Bb"
  },
  {
    "Name": "Ornamented Sword",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Mobilize, Breakthrough, +2/+1.",
    "Keywords": "Mobilize,Breakthrough",
    "Played in": "151/12757 of  Eligible  decks (1 %)",
    "code": "tI"
  },
  {
    "Name": "Ornery Kagouti",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Beast",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Breakthrough",
    "Keywords": "Breakthrough",
    "Played in": "85/12757 of  Eligible  decks (1 %)",
    "code": "lP"
  },
  {
    "Name": "Orsinium Forge",
    "Rarity": "Legendary",
    "Type": "Support",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Uses: 3. Activate: Equip a creature with a +1/+1 Orsinium Plate. Then increase the power and health of Orsinium Plates this equips by 1.",
    "Keywords": "",
    "Played in": "19/12757 of  Eligible  decks (0 %)",
    "code": "tK"
  },
  {
    "Name": "Orvas' Bargain",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Give an enemy creature -1/-0 and a friendly creature +1/+0 this turn.",
    "Keywords": "",
    "Played in": "61/12907 of  Eligible  decks (0 %)",
    "code": "lQ"
  },
  {
    "Name": "Outflank",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Propechy. Give a friendly creature in each lane +0/+2 and Guard.",
    "Keywords": "Prophecy,Guard",
    "Played in": "71/12916 of  Eligible  decks (1 %)",
    "code": "tL"
  },
  {
    "Name": "Outland Patrol",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Last Gasp: Give a random creature in your hand +1/+1.",
    "Keywords": "Last Gasp",
    "Played in": "77/13644 of  Eligible  decks (1 %)",
    "code": "yi"
  },
  {
    "Name": "Paarthurnax",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dragon",
    "Magicka Cost": "12",
    "Attack": "9",
    "Health": "9",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Put three random Shouts into your hand and reduce their costs to 0.",
    "Keywords": "",
    "Played in": "3255/30872 of  Eligible  decks (11 %)",
    "code": "lR"
  },
  {
    "Name": "Pack Leader",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Wolf",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Pilfer: Summon a 1/1 Young Wolf. Other friendly Wolvers have +1/+1.",
    "Keywords": "Pilfer",
    "Played in": "181/12907 of  Eligible  decks (1 %)",
    "code": "lS"
  },
  {
    "Name": "Pack Wolf",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Wolf",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Summon a 1/1 Young Wolf in the other lane.",
    "Keywords": "",
    "Played in": "326/12907 of  Eligible  decks (3 %)",
    "code": "lT"
  },
  {
    "Name": "Pact Oathman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: If you have a...\n[agility] card in play, +2/+0.\n[endurance] card in play, Battle an enemy creature.",
    "Keywords": "",
    "Played in": "39/12757 of  Eligible  decks (0 %)",
    "code": "tM"
  },
  {
    "Name": "Pact Outcast",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "agility",
      "endurance"
    ],
    "Race": "Nord",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Tamriel Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. Summon and Veteran: Consume a creature. Pact Outcast uses the consumed creature's veteran ability.",
    "Keywords": "Guard",
    "Played in": "13/338 of  Eligible  decks (4 %)",
    "code": "AX"
  },
  {
    "Name": "Pact Shieldbearer",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "6",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Veteran: Your opponent's actions cost 4 more next turn.",
    "Keywords": "Veteran",
    "Played in": "66/12757 of  Eligible  decks (1 %)",
    "code": "tO"
  },
  {
    "Name": "Pahmar-raht Renegade",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Slay: draw a card.",
    "Keywords": "Slay",
    "Played in": "513/13695 of  Eligible  decks (4 %)",
    "code": "lU"
  },
  {
    "Name": "Painted World",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "12",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Costs 2 less for each attribute you have in play. Costs 2 less if you have a [neutral] card in play. Summon a Painted Troll in each lane.",
    "Keywords": "",
    "Played in": "22/30861 of  Eligible  decks (0 %)",
    "code": "xB"
  },
  {
    "Name": "Palace Conspirator",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 2 - Castle Wayrest, Grand Hall",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Draw a card, then discard a card.",
    "Keywords": "",
    "Played in": "747/14266 of  Eligible  decks (5 %)",
    "code": "lV"
  },
  {
    "Name": "Palace Prowler",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Drain. Pilfer: Gain 1 magicka this turn.",
    "Keywords": "Drain,Pilfer",
    "Played in": "748/13695 of  Eligible  decks (5 %)",
    "code": "lW"
  },
  {
    "Name": "Paralyze",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Shackle an enemy creature.",
    "Keywords": "",
    "Played in": "341/13695 of  Eligible  decks (2 %)",
    "code": "lX"
  },
  {
    "Name": "Penitus Oculatus Agent",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 5 - Bravil Treasury",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Steal a creature's Keywords.",
    "Keywords": "",
    "Played in": "1273/12907 of  Eligible  decks (10 %)",
    "code": "lZ"
  },
  {
    "Name": "Phalanx Exemplar",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "6",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 6 - Eastmarch Camp",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard. When your opponent draws a Prophecy from a rune being destroyed, put a 1/2 Septim Guardsman with Guard into your hand.",
    "Keywords": "Guard",
    "Played in": "899/12907 of  Eligible  decks (7 %)",
    "code": "ma"
  },
  {
    "Name": "Piercing Javelin",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Destroy a creature.",
    "Keywords": "Prophecy",
    "Played in": "8491/12907 of  Eligible  decks (66 %)",
    "code": "lY"
  },
  {
    "Name": "Piercing Twilight",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Daedra",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "FrostSpark Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. Summon: Choose a card in your opponent's discard pile. Banish all cards from your opponent's discard pile and deck with the same name as the chosen card.",
    "Keywords": "Guard",
    "Played in": "708/14266 of  Eligible  decks (5 %)",
    "code": "mc"
  },
  {
    "Name": "Pillaging Tribune",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Give a friendly creature Drain this turn.",
    "Keywords": "Drain",
    "Played in": "553/12907 of  Eligible  decks (4 %)",
    "code": "md"
  },
  {
    "Name": "Pit Lion",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Beast",
    "Magicka Cost": "3",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Pit Lion can't be summoned unless there's a friendly unit in each lane.",
    "Keywords": "",
    "Played in": "1530/12907 of  Eligible  decks (12 %)",
    "code": "me"
  },
  {
    "Name": "Plea to Kynareth",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Heal all friendly creatures in a lane, then give them all +1/+1.",
    "Keywords": "",
    "Played in": "314/13644 of  Eligible  decks (2 %)",
    "code": "mf"
  },
  {
    "Name": "Plunder",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Draw two random items.",
    "Keywords": "",
    "Played in": "949/12759 of  Eligible  decks (7 %)",
    "code": "mg"
  },
  {
    "Name": "Poetic Armiger",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Exalt 1: Gain a random Keyword.",
    "Keywords": "Exalt",
    "Played in": "119/14266 of  Eligible  decks (1 %)",
    "code": "mh"
  },
  {
    "Name": "Pointy Wall of Spikes",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Defense",
    "Magicka Cost": "2",
    "Attack": "0",
    "Health": "3",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard. When Pointy Wall of Spikes takes damage from a creature, it deals that much damage to that creature.",
    "Keywords": "Prophecy,Guard",
    "Played in": "343/14266 of  Eligible  decks (2 %)",
    "code": "mi"
  },
  {
    "Name": "Poisoned Dagger",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Mobilize, Lethal, +1/+0.",
    "Keywords": "Mobilize,Lethal",
    "Played in": "133/13644 of  Eligible  decks (1 %)",
    "code": "tQ"
  },
  {
    "Name": "Portcullis",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Defense",
    "Magicka Cost": "5",
    "Attack": "0",
    "Health": "9",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard",
    "Keywords": "Guard,Prophecy",
    "Played in": "379/30872 of  Eligible  decks (1 %)",
    "code": "mj"
  },
  {
    "Name": "Pouncing Senche",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "7",
    "Attack": "4",
    "Health": "7",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard. Wax: +3/+0. Wane: Charge.",
    "Keywords": "Guard,Wax/Wane,Charge",
    "Played in": "26/12757 of  Eligible  decks (0 %)",
    "code": "wn"
  },
  {
    "Name": "Power of the Almsivi",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "intelligence",
      "willpower",
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "8",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Set each creature's power and health to 1.",
    "Keywords": "",
    "Played in": "130/1015 of  Eligible  decks (13 %)",
    "code": "mk"
  },
  {
    "Name": "Praetorian Commander",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "6",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Give creatures in your deck +1/+1.",
    "Keywords": "",
    "Played in": "685/12907 of  Eligible  decks (5 %)",
    "code": "ml"
  },
  {
    "Name": "Prankster Mage",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "3",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Ward. While Prankster Mage has a Ward, he has Guard. When Prankster Mage's Ward is broken, he gains Cover.",
    "Keywords": "Ward,Guard,Cover",
    "Played in": "49/4940 of  Eligible  decks (1 %)",
    "code": "xd"
  },
  {
    "Name": "Preserver of the Root",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "While you have 7 or more magicka, Preserver of the Root has +2/+2 and Guard.",
    "Keywords": "Guard",
    "Played in": "2390/13644 of  Eligible  decks (18 %)",
    "code": "mm"
  },
  {
    "Name": "Preying Elytra",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Elytra",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Choose an enemy creature. When Preying Elytra damages the chosen creature, draw two cards.",
    "Keywords": "",
    "Played in": "48/13695 of  Eligible  decks (0 %)",
    "code": "mn"
  },
  {
    "Name": "Priest of Mara",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": ["willpower"],
    "Race": "Imperial",
    "Attack": "2",
    "Health": "5",
    "Magicka Cost": "3",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Equip an Amulet of Mara to an enemy creature and another friendly creature without Guard.",
    "Keywords": "",
    "code": "yL"
  },
  {
    "Name": "Priest of the Eight",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Draw a card if you have two other (willpower) creatures.",
    "Keywords": "",
    "Played in": "1042/12907 of  Eligible  decks (8 %)",
    "code": "mo"
  },
  {
    "Name": "Priest of the Moons",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Summon: Gain 2 health.",
    "Keywords": "Prophecy",
    "Played in": "446/12907 of  Eligible  decks (3 %)",
    "code": "mp"
  },
  {
    "Name": "Prison Ship",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Defense",
    "Magicka Cost": "3",
    "Attack": "0",
    "Health": "5",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Shackle an enemy creature while you have Prison Ship.",
    "Keywords": "",
    "Played in": "63/12907 of  Eligible  decks (0 %)",
    "code": "mq"
  },
  {
    "Name": "Prized Chicken",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Beast",
    "Magicka Cost": "5",
    "Attack": "0",
    "Health": "1",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Last Gasp: Fill this lane with 1/1 Angry Villagers.",
    "Keywords": "Last Gasp",
    "Played in": "81/30861 of  Eligible  decks (0 %)",
    "code": "mr"
  },
  {
    "Name": "Prophet of Bones",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "1",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Exalt 5: Fill this lane with 1/1 Risen Dead with Guard",
    "Keywords": "Exalt",
    "Played in": "75/13644 of  Eligible  decks (1 %)",
    "code": "ms"
  },
  {
    "Name": "Protector of the Innocent",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 2 - Wayrest Plains",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard",
    "Keywords": "Prophecy,Guard",
    "Played in": "2376/12757 of  Eligible  decks (19 %)",
    "code": "mt"
  },
  {
    "Name": "Protector of the Mane",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower",
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Drain, Guard. When you gain health, Protector of the Mane gains +1/+1.",
    "Keywords": "Drain,Guard",
    "Played in": "375/3720 of  Eligible  decks (10 %)",
    "code": "mu"
  },
  {
    "Name": "Prowl Smuggler",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Pilfer: Equip a Steel Dagger to a friendly creature.",
    "Keywords": "Pilfer",
    "Played in": "122/12757 of  Eligible  decks (1 %)",
    "code": "vB"
  },
  {
    "Name": "Pure-Blood Elder",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Vampire",
    "Magicka Cost": "7",
    "Attack": "8",
    "Health": "8",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When you gain max magicka, double the amount you gain. While you have 18 or more max magicka, Pure-Blood Elder has +8/+8 and Breakthrough.",
    "Keywords": "Breakthrough",
    "Played in": "647/13644 of  Eligible  decks (5 %)",
    "code": "mv"
  },
  {
    "Name": "Quarra Clan Bloodkin",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Vampire",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "5",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Drain",
    "Keywords": "Drain",
    "Played in": "212/13644 of  Eligible  decks (2 %)",
    "code": "mw"
  },
  {
    "Name": "Queen Barenziah",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "6",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Drain. Summon: Give all other friendly creatures in this lane Guard.",
    "Keywords": "Drain,Guard",
    "Played in": "2375/4940 of  Eligible  decks (48 %)",
    "code": "mx"
  },
  {
    "Name": "Queen's Captain",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "8",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Wax: Draw two cards. Wane: Destroy a creature.",
    "Keywords": "Wax/Wane",
    "Played in": "159/12907 of  Eligible  decks (1 %)",
    "code": "wO"
  },
  {
    "Name": "Quicksilver Crossbow",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 4 - Falkreath Jail",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+1/+1. Summon: The wielder deals 1 damage.",
    "Keywords": "",
    "Played in": "1562/12757 of  Eligible  decks (12 %)",
    "code": "my"
  },
  {
    "Name": "Quin'rawl Burglar",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "6",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Drain. Pilfer: +4/+4",
    "Keywords": "Drain,Pilfer",
    "Played in": "1907/13695 of  Eligible  decks (14 %)",
    "Evolves from:": "Quin'rawl Skulker",
    "code": "mz"
  },
  {
    "Name": "Raging Horker",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Beast",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "When Raging Horker takes damage, it gains +1/+1.",
    "Keywords": "",
    "Played in": "103/30861 of  Eligible  decks (0 %)",
    "code": "mB"
  },
  {
    "Name": "Raiding Party",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Put two 1/1 Nord Firebrands with Charge into your hand.",
    "Keywords": "Charge",
    "Played in": "2756/12757 of  Eligible  decks (22 %)",
    "code": "mC"
  },
  {
    "Name": "Rajhini Highwayman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Pilfer: Draw a card.",
    "Keywords": "Pilfer",
    "Played in": "774/12907 of  Eligible  decks (6 %)",
    "code": "mD"
  },
  {
    "Name": "Rampaging Minotaur",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Minotaur",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Breakthrough, Charge",
    "Keywords": "Breakthrough,Charge",
    "Played in": "675/12757 of  Eligible  decks (5 %)",
    "code": "mE"
  },
  {
    "Name": "Ransack",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy. Deal 3 damage and gain 3 health.",
    "Keywords": "Prophecy",
    "Played in": "401/13703 of  Eligible  decks (3 %)",
    "code": "mF"
  },
  {
    "Name": "Rapid Shot",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Deal 1 damage to a creature. If it survives, draw a card.",
    "Keywords": "",
    "Played in": "5871/12757 of  Eligible  decks (46 %)",
    "code": "mG"
  },
  {
    "Name": "Ratway Prospector",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 1 - Ragged Flagon",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Treasure Hunt - Support, item, action: +5/+5. After Ratway Prospector attacks, it gains Cover.",
    "Keywords": "Treasure Hunt",
    "Played in": "268/12757 of  Eligible  decks (2 %)",
    "code": "mH"
  },
  {
    "Name": "Ravaging Elixir",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Uses: 3. Activate: Deal 1 damage to your opponent.",
    "Keywords": "",
    "Played in": "85/14266 of  Eligible  decks (1 %)",
    "code": "tS"
  },
  {
    "Name": "Ravenous Crocodile",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Reptile",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Deal 2 damage to a friendly creature.",
    "Keywords": "",
    "Played in": "229/30861 of  Eligible  decks (1 %)",
    "Evolves from:": "Stalking Crocodile",
    "code": "mI"
  },
  {
    "Name": "Ravenous Hunger",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Daedra",
    "Magicka Cost": "2",
    "Attack": "4",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Give Ravenous Hunger Drain if there is an enemy creature in this lane.",
    "Keywords": "Drain",
    "Played in": "780/12907 of  Eligible  decks (6 %)",
    "Evolves from:": "Starved Hunger",
    "code": "mJ"
  },
  {
    "Name": "Razum-Dar",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "7",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Charge. Draw a copy of the first card your opponent draws each turn.",
    "Keywords": "Charge",
    "Played in": "285/13695 of  Eligible  decks (2 %)",
    "code": "wA"
  },
  {
    "Name": "Reachman Shaman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Reachman",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "At the start of your turn, give another random friendly creature +1/+1.",
    "Keywords": "",
    "Played in": "333/30861 of  Eligible  decks (1 %)",
    "code": "mL"
  },
  {
    "Name": "Reanimate",
    "Rarity": "Legendary",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "9",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon a creature from your discard pile.",
    "Keywords": "",
    "Played in": "118/13651 of  Eligible  decks (1 %)",
    "code": "vU"
  },
  {
    "Name": "Rebel Warden",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Pilfer: Summon a 1/1 Recruit.",
    "Keywords": "Pilfer",
    "Played in": "123/12907 of  Eligible  decks (1 %)",
    "code": "vM"
  },
  {
    "Name": "Rebellion General",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Wax: +1/+0 and trigger the Wax of each non-Rebellion General frendly creature. Wane: +0/+1 and trigger the Wane of each non-Rebellion General friendly creature.",
    "Keywords": "Wax/Wane",
    "Played in": "88/13695 of  Eligible  decks (1 %)",
    "code": "wM"
  },
  {
    "Name": "Reconstruction Engine",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 5 - The Caminus Pit",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Uses: 5. Activate: Give a friendly creature -1/-1 and summon a 1/1 Reconstructed Spider.",
    "Keywords": "",
    "Played in": "62/12907 of  Eligible  decks (0 %)",
    "code": "mN"
  },
  {
    "Name": "Red Bramman",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "agility",
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "9",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Silence and Shackle all enemy creatures in this lane.",
    "Keywords": "",
    "Played in": "1977/4386 of  Eligible  decks (45 %)",
    "code": "mO"
  },
  {
    "Name": "Red Mountain",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "strength",
      "intelligence",
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Tamriel Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Ongoing. Your creatures with 5 power or more cost 2 less.",
    "Keywords": "",
    "Played in": "11/937 of  Eligible  decks (1 %)",
    "code": "Ba"
  },
  {
    "Name": "Redoran Battlespear",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Rally. +1/+3.",
    "Keywords": "Rally",
    "Played in": "426/12757 of  Eligible  decks (3 %)",
    "code": "mP"
  },
  {
    "Name": "Redoran Enforcer",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "72/14266 of  Eligible  decks (1 %)",
    "code": "mQ"
  },
  {
    "Name": "Redoran Forerunner",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "willpower",
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Charge, Drain, Ward",
    "Keywords": "Charge,Drain,Ward",
    "Played in": "671/806 of  Eligible  decks (83 %)",
    "code": "mR"
  },
  {
    "Name": "Redoran Oathman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: If you have a ... (willpower) card in play, double Redoran Oathman's health. (strength) card in play, double Redoran Oathman's power.",
    "Keywords": "",
    "Played in": "120/13644 of  Eligible  decks (1 %)",
    "code": "mS"
  },
  {
    "Name": "Reflective Automaton",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Factotum",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 3 - The Ventral Terminus",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Reflective Automaton has all creature types.",
    "Keywords": "",
    "Played in": "1152/30861 of  Eligible  decks (4 %)",
    "code": "mT"
  },
  {
    "Name": "Reive, Blademaster",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Daedra",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "When Reive attacks, deal 2 damage to the enemy player, then increase the damage from this ability by 2.",
    "Keywords": "",
    "Played in": "1754/12757 of  Eligible  decks (14 %)",
    "code": "mU"
  },
  {
    "Name": "Relentless Raider",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "1",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "After an enemy rune is destroyed, deal 1 damage to your opponent.",
    "Keywords": "",
    "Played in": "1200/12757 of  Eligible  decks (9 %)",
    "code": "mV"
  },
  {
    "Name": "Relic Hunter",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Redguard",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 1 - Ragged Flagon",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Treasure Hunt - Item: Give the item +1/+1.",
    "Keywords": "Treasure Hunt",
    "Played in": "223/12757 of  Eligible  decks (2 %)",
    "code": "mW"
  },
  {
    "Name": "Renegade Magister",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "After a friendly action damages an enemy creature, Renegade Magister deals that much damage to that creature.",
    "Keywords": "",
    "Played in": "47/14266 of  Eligible  decks (0 %)",
    "code": "sn"
  },
  {
    "Name": "Renowned Instructor",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Expertise: Summon a 1/1 Recruit.",
    "Keywords": "Expertise",
    "Played in": "118/12907 of  Eligible  decks (1 %)",
    "code": "ud"
  },
  {
    "Name": "Renowned Legate",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "7",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Breakthrough. Summon: Summon a 1/1 Imperial Grunt, then gain 1 health for each friendly creature.",
    "Keywords": "Breakthrough",
    "Played in": "355/12907 of  Eligible  decks (3 %)",
    "Evolves from:": "Rising Legate",
    "code": "mX"
  },
  {
    "Name": "Resolute Ally",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "High Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Give other friendly creatures in this lane +1/+1 if the top card of your deck is (Willpower).",
    "Keywords": "",
    "Played in": "1393/12907 of  Eligible  decks (11 %)",
    "code": "mY"
  },
  {
    "Name": "Restless Templar",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "4",
    "Attack": "5",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Last Gasp: Gain 5 health.",
    "Keywords": "Last Gasp",
    "Played in": "640/13644 of  Eligible  decks (5 %)",
    "code": "mZ"
  },
  {
    "Name": "Restoration Tutor",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Heal a creature.",
    "Keywords": "",
    "Played in": "52/13644 of  Eligible  decks (0 %)",
    "code": "na"
  },
  {
    "Name": "Revealing the Unseen",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Put two random actions into your hand.",
    "Keywords": "",
    "Played in": "541/14266 of  Eligible  decks (4 %)",
    "code": "nb"
  },
  {
    "Name": "Reverberating Strike",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 2 - The Midden",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Deal 3 damage to a creature and all enemy creatures with the same name.",
    "Keywords": "",
    "Played in": "1390/14266 of  Eligible  decks (10 %)",
    "code": "nc"
  },
  {
    "Name": "Revered Guardian",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Dragon",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard",
    "Keywords": "Guard",
    "Played in": "788/12907 of  Eligible  decks (6 %)",
    "code": "nd"
  },
  {
    "Name": "Rift Thane",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: If you have less health than your opponent, +0/+2 and Guard. Otherwise, +2/+0 and Breakthrough.",
    "Keywords": "Breakthrough,Guard",
    "Played in": "1756/3994 of  Eligible  decks (44 %)",
    "code": "ne"
  },
  {
    "Name": "Riften Lawkeeper",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 1 - Streets of Riften",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Brekathrough. Summon: you gain 4 health.",
    "Keywords": "Breakthrough",
    "Played in": "422/12907 of  Eligible  decks (3 %)",
    "code": "nf"
  },
  {
    "Name": "Riften Pickpocket",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Reveal three random cards in your opponent’s deck. Choose one and draw a copy of it.",
    "Keywords": "",
    "Played in": "634/14266 of  Eligible  decks (4 %)",
    "code": "ng"
  },
  {
    "Name": "Riften Pillager",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: +1/+1 for each destroyed enemy rune.",
    "Keywords": "",
    "Played in": "246/12757 of  Eligible  decks (2 %)",
    "code": "nh"
  },
  {
    "Name": "Rihad Battlemage",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Redguard",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Rihad Battlemage has +0/+3 and Guard while equipped with an item.",
    "Keywords": "Guard",
    "Played in": "568/12757 of  Eligible  decks (4 %)",
    "Evolves from:": "Rihad Nomad",
    "code": "ni"
  },
  {
    "Name": "Rihad Horseman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Redguard",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Rihad Horseman has +3/+0 and Breakthrough while equipped with an item.",
    "Keywords": "Breakthrough",
    "Played in": "658/12757 of  Eligible  decks (5 %)",
    "Evolves from:": "Rihad Nomad",
    "code": "nj"
  },
  {
    "Name": "Rimmen Purveyor",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Consume a creature. Reduce the cost of each creature in your deck that shares a type with that creature by 1.",
    "Keywords": "Consume",
    "Played in": "28/13695 of  Eligible  decks (0 %)",
    "code": "yS"
  },
  {
    "Name": "Rimmen Siege Weapons",
    "Rarity": "Legendary",
    "Type": "Support",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Ongoing. At the start of your turn, each friendly creature deals 1 damage to your opponent.",
    "Keywords": "",
    "Played in": "80/12757 of  Eligible  decks (1 %)",
    "code": "wi"
  },
  {
    "Name": "Ring of Imaginary Might",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Madhouse Collection",
    "Soul Summon": "This card belongs to the Madhouse Collection and cannot be Soul Summoned.",
    "Soul Trap": "This card belongs to the Madhouse Collection and cannot be Soul Trapped.",
    "Text": "+0/+2. Summon: The wielder's power becomes equal to its health.",
    "Keywords": "",
    "Played in": "326/13644 of  Eligible  decks (2 %)",
    "code": "nl"
  },
  {
    "Name": "Ring of Lordship",
    "Rarity": "Epic",
    "Type": "Item",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "+0/+2. Your creatures with the same type as the wielder cost 1 less.",
    "Keywords": "",
    "Played in": "242/30861 of  Eligible  decks (1 %)",
    "code": "qb"
  },
  {
    "Name": "Ring of Namira",
    "Rarity": "Legendary - Unique",
    "Type": "Support",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Ongoing. When you gain health, deal that much damage to your opponent.",
    "Keywords": "",
    "Played in": "494/13695 of  Eligible  decks (4 %)",
    "code": "nm"
  },
  {
    "Name": "Rising of Bones",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Betray. Summon a 3/3 Risen Horror with Guard.",
    "Keywords": "Betray",
    "Played in": "424/13644 of  Eligible  decks (3 %)",
    "code": "no"
  },
  {
    "Name": "Riverhold Escort",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard. Pilfer: Move Riverhold Escort to the other lane.",
    "Keywords": "Guard,Pilfer",
    "Played in": "217/12907 of  Eligible  decks (2 %)",
    "code": "np"
  },
  {
    "Name": "Royal Sage",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: If you have more health than your opponent, give all friendly creatures a random keyword.",
    "Keywords": "",
    "Played in": "1496/14266 of  Eligible  decks (10 %)",
    "code": "nr"
  },
  {
    "Name": "Ruin Archaeologist",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "High Elf",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "5",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 2 - Ending",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Treasure Hunt - Support: Draw a card.",
    "Keywords": "Treasure Hunt",
    "Played in": "259/12907 of  Eligible  decks (2 %)",
    "code": "ns"
  },
  {
    "Name": "Ruin Shambler",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Mummy",
    "Magicka Cost": "4",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Discard the top three cards of your deck, then Consume all creatures that entered your discard pile this turn. Ruin Shambler gains +1/+1 for each creature consumed.",
    "Keywords": "Consume",
    "Played in": "53/13644 of  Eligible  decks (0 %)",
    "code": "wB"
  },
  {
    "Name": "Ruthless Freebooter",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 4 - Hall of Conveyance",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Treasure Hunt - Drain: +1/+1 and Drain.\nTreasure Hunt - Lethal: +1/+1 and Lethal.",
    "Keywords": "Treasure Hunt,Drain,Letha",
    "Played in": "183/13695 of  Eligible  decks (1 %)",
    "code": "nt"
  },
  {
    "Name": "Sadras Agent",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. Last Gasp: Summon a 2/1 Mournhold Guardian with Guard.",
    "Keywords": "Guard,Last Gasp",
    "Played in": "778/4940 of  Eligible  decks (16 %)",
    "code": "nu"
  },
  {
    "Name": "Sai Sahan",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Redguard",
    "Magicka Cost": "7",
    "Attack": "6",
    "Health": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Immune to Wounded enemy creatures. Summon: Give all enemy creatures -1/-1.",
    "Keywords": "",
    "Played in": "249/13695 of  Eligible  decks (2 %)",
    "code": "uf"
  },
  {
    "Name": "Sails-Through-Storms",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Argonian",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 1 - Forelhost Lost Tomb",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Pilfer: Summon the top creature of your deck.",
    "Keywords": "Pilfer",
    "Played in": "1201/13695 of  Eligible  decks (9 %)",
    "code": "nv"
  },
  {
    "Name": "Salvage",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Choose an item in your discard pile. Draw it and all items with the same name from your discard pile.",
    "Keywords": "",
    "Played in": "63/12759 of  Eligible  decks (0 %)",
    "code": "ug"
  },
  {
    "Name": "Sanctuary Pet",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Spider",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Lethal. Summon: Shackle an enemy creature in this lane.",
    "Keywords": "Lethal",
    "Played in": "4209/13695 of  Eligible  decks (31 %)",
    "code": "nw"
  },
  {
    "Name": "Sanctuary Raid",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 6 - Silverhome on the Water, Uther's Suite",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Destroy an enemy creature. Give all friendly creatures in its lane +1/+1.",
    "Keywords": "",
    "Played in": "342/12907 of  Eligible  decks (3 %)",
    "code": "nx"
  },
  {
    "Name": "Sarethi Scion",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Rally|",
    "Keywords": "Rally",
    "Played in": "419/12757 of  Eligible  decks (3 %)",
    "code": "ny"
  },
  {
    "Name": "Savage Ogre",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Ogre",
    "Magicka Cost": "7",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Give a creature +5/+0 this turn.",
    "Keywords": "",
    "Played in": "382/12757 of  Eligible  decks (3 %)",
    "code": "nz"
  },
  {
    "Name": "Scout's Report",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "agility",
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Look at the top card of your deck. You may discard it. Draw a card.",
    "Keywords": "",
    "Played in": "1727/4386 of  Eligible  decks (39 %)",
    "code": "nA"
  },
  {
    "Name": "Scouting Patrol",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon a 1/1 Imperial Grunt in each lane.",
    "Keywords": "",
    "Played in": "2231/12907 of  Eligible  decks (17 %)",
    "code": "nB"
  },
  {
    "Name": "Scroll Seeker",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 2 - J'Zargo",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Ward. Treasure Hunt - Two actions: +1/+0",
    "Keywords": "Ward,Treasure Hunt",
    "Played in": "152/14266 of  Eligible  decks (1 %)",
    "code": "nC"
  },
  {
    "Name": "Scuttler",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Reptile",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "60/12759 of  Eligible  decks (0 %)",
    "code": "nD"
  },
  {
    "Name": "Seasoned Captain",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Redguard",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Rally. When you Rally, also give a random item in your hand +1/+1.",
    "Keywords": "Rally",
    "Played in": "42/12757 of  Eligible  decks (0 %)",
    "code": "uH"
  },
  {
    "Name": "Seducer Darkfire",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Daedra",
    "Magicka Cost": "7",
    "Attack": "7",
    "Health": "7",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Choose a cost. Your opponent can't play cards with the chosen cost.",
    "Keywords": "",
    "Played in": "90/12907 of  Eligible  decks (1 %)",
    "code": "nE"
  },
  {
    "Name": "Seeker of the Black Arts",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Pilfer: Discard the top three cards of your deck.",
    "Keywords": "Pilfer",
    "Played in": "52/13644 of  Eligible  decks (0 %)",
    "code": "vO"
  },
  {
    "Name": "Seething Flesh Golem",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Daedra",
    "Magicka Cost": "8",
    "Attack": "3",
    "Health": "8",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When Seething Flesh Golem attacks, deal damage equal to its power to all enemy creatures in this lane.",
    "Keywords": "",
    "Played in": "78/14266 of  Eligible  decks (1 %)",
    "code": "pd"
  },
  {
    "Name": "Seht's Masterwork",
    "Rarity": "Legendary - Unique",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Forgotten Hero Collection",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Ongoing. If you started the game with no duplicate in your deck, your cards cost 1 less.",
    "Keywords": "",
    "Played in": "472/30861 of  Eligible  decks (2 %)",
    "code": "nF"
  },
  {
    "Name": "Senche-raht Graveprowler",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Pilfer: Consume a creature to gain power and health equal to the consumed creature's.",
    "Keywords": "Pilfer,Consume",
    "Played in": "28/12757 of  Eligible  decks (0 %)",
    "code": "wh"
  },
  {
    "Name": "Senche Noble",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "6",
    "Attack": "7",
    "Health": "4",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard",
    "Keywords": "Guard",
    "Played in": "10/12757 of  Eligible  decks (0 %)",
    "code": "wk"
  },
  {
    "Name": "Senche-Tiger",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Beast",
    "Magicka Cost": "6",
    "Attack": "4",
    "Health": "7",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard",
    "Keywords": "Guard",
    "Played in": "586/12907 of  Eligible  decks (5 %)",
    "code": "nG"
  },
  {
    "Name": "Sentinel Battlemace",
    "Rarity": "Epic",
    "Type": "Item",
    "Attributes": [
      "strength",
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Ward, +4/+0",
    "Keywords": "Ward",
    "Played in": "1910/3939 of  Eligible  decks (48 %)",
    "code": "nH"
  },
  {
    "Name": "Sentinel Reclaimer",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Redguard",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Put a Steel Dagger and Steel Sword into your hand.",
    "Keywords": "",
    "Played in": "175/14266 of  Eligible  decks (1 %)",
    "code": "xc"
  },
  {
    "Name": "Septim Guardsman",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "0",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard",
    "Keywords": "Guard",
    "Played in": "378/12907 of  Eligible  decks (3 %)",
    "code": "nI"
  },
  {
    "Name": "Serpentine Stalker",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dragon",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Slay: +2/+0. May move to attack creatures in the other lane.",
    "Keywords": "Slay",
    "Played in": "405/13695 of  Eligible  decks (3 %)",
    "code": "nJ"
  },
  {
    "Name": "Servant of Dagoth",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Ash Creature",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: if you have a creature with 5 power or more, +2/+2 and Guard.",
    "Keywords": "Guard",
    "Played in": "159/12757 of  Eligible  decks (1 %)",
    "code": "nK"
  },
  {
    "Name": "Servant of Ja-Kha'jay",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Wax: +2/+2. Wane: Silence a creature.",
    "Keywords": "Wax/Wane,Silence",
    "Played in": "84/13644 of  Eligible  decks (1 %)",
    "code": "ww"
  },
  {
    "Name": "Seyda Neen Courier",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "2",
    "Attack": "0",
    "Health": "1",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Equip a +3/+0 Steel Sword to a friendly creature.",
    "Keywords": "",
    "Played in": "560/14266 of  Eligible  decks (4 %)",
    "code": "nL"
  },
  {
    "Name": "Shadow Shift",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Move a friendly creature. Draw a card.",
    "Keywords": "",
    "Played in": "5126/13695 of  Eligible  decks (37 %)",
    "code": "nM"
  },
  {
    "Name": "Shadowfen Priest",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Silence another creature or destroy an enemy support card.",
    "Keywords": "",
    "Played in": "6523/13644 of  Eligible  decks (48 %)",
    "code": "nN"
  },
  {
    "Name": "Shadowgreen Elder",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Spriggan",
    "Magicka Cost": "7",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Give other friendly Spriggans and Animals +2/+2.",
    "Keywords": "",
    "Played in": "173/13695 of  Eligible  decks (1 %)",
    "code": "nO"
  },
  {
    "Name": "Shadowmarking",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "FrostSpark Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Look at the top three cards of your deck. Choose one to put into your opponent's hand and draw the other two.",
    "Keywords": "",
    "Played in": "314/13703 of  Eligible  decks (2 %)",
    "code": "nP"
  },
  {
    "Name": "Shadowmaster",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Falmer",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Give a friendly creature Cover. Your opponent can't target it with actions until your next turn.",
    "Keywords": "",
    "Played in": "245/13703 of  Eligible  decks (2 %)",
    "code": "nQ"
  },
  {
    "Name": "Shadowmere",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Beast",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 6 - Night Mother's Crypt Part 2",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Charge. Last Gasp: Shuffle Shadowmere into your deck, give it +3/+3 and increase its cost by 3.",
    "Keywords": "Charge,Last Gasp",
    "Played in": "1215/30872 of  Eligible  decks (4 %)",
    "code": "nR"
  },
  {
    "Name": "Shadowscale Hunter",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Argonian",
    "Magicka Cost": "3",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Veteran: Move.",
    "Keywords": "Veteran",
    "Played in": "57/13695 of  Eligible  decks (0 %)",
    "code": "tN"
  },
  {
    "Name": "Shadowscale Partisan",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Argonian",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Lethal. Summon: +0/+2 if you have another creature with Lethal.",
    "Keywords": "Lethal",
    "Played in": "248/13695 of  Eligible  decks (2 %)",
    "code": "nS"
  },
  {
    "Name": "Shalk Fabricant",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Fabricant",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 4 - Cogitum Centralis",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard. Summon: If you have a [neutral] card in play, put a random action into your hand.",
    "Keywords": "Guard",
    "Played in": "169/14266 of  Eligible  decks (1 %)",
    "code": "nT"
  },
  {
    "Name": "Sharp-Eyed Ashkhan",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "6",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Plot: Discard your hand, then draw three cards.",
    "Keywords": "Plot",
    "Played in": "276/12757 of  Eligible  decks (2 %)",
    "code": "nU"
  },
  {
    "Name": "Sharpshooter Scout",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Summon: Deal 1 damage.",
    "Keywords": "Prophecy",
    "Played in": "1814/12757 of  Eligible  decks (14 %)",
    "code": "nV"
  },
  {
    "Name": "Shearpoint Dragon",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dragon",
    "Magicka Cost": "6",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Give a creature -2/-2. When you reduce a creature's power or health with another effect, reduce it by an extra 1.",
    "Keywords": "",
    "Played in": "2636/13695 of  Eligible  decks (19 %)",
    "code": "nX"
  },
  {
    "Name": "Shield Breaker",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+2/+2. Summon: An enemy creature loses Guard.",
    "Keywords": "",
    "Played in": "1053/12757 of  Eligible  decks (8 %)",
    "code": "nY"
  },
  {
    "Name": "Shimmerene Peddler",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the end of each turn, if you played two actions, draw a card.",
    "Keywords": "",
    "Played in": "634/14266 of  Eligible  decks (4 %)",
    "code": "nZ"
  },
  {
    "Name": "Shining Saint",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Daedra",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Give a creature -2/-0 this turn. It loses Cover.",
    "Keywords": "",
    "Played in": "273/12907 of  Eligible  decks (2 %)",
    "code": "oa"
  },
  {
    "Name": "Shivering Apothecary",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Madhouse Collection",
    "Soul Summon": "This card belongs to the Madhouse Collection and cannot be Soul Summoned.",
    "Soul Trap": "This card belongs to the Madhouse Collection and cannot be Soul Trapped.",
    "Text": "Summon: Summon a random elixir.",
    "Keywords": "",
    "Played in": "178/12907 of  Eligible  decks (1 %)",
    "code": "ob"
  },
  {
    "Name": "Shocking Wamasu",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Wamasu",
    "Magicka Cost": "8",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Deal 4 damage to a creature.",
    "Keywords": "",
    "Played in": "206/14266 of  Eligible  decks (1 %)",
    "code": "oc"
  },
  {
    "Name": "Shornhelm Champion",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "endurance"
    ],
    "Race": "Breton",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Breakthrough, Ward. When Shornhelm Champion's Ward is broken, he gains +3/+3.",
    "Keywords": "Breakthrough,Ward",
    "Played in": "406/4886 of  Eligible  decks (8 %)",
    "code": "od"
  },
  {
    "Name": "Shrewd Strategist",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "5",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Consume a creature. Give all creatures in your hand and deck with the same name +2/+2.",
    "Keywords": "",
    "Played in": "33/12907 of  Eligible  decks (0 %)",
    "code": "vT"
  },
  {
    "Name": "Shrieking Harpy",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Harpy",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy. Summon: Shackle an enemy creature.",
    "Keywords": "Prophecy",
    "Played in": "8620/14266 of  Eligible  decks (60 %)",
    "code": "oe"
  },
  {
    "Name": "Shrine Guardian",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Daedra",
    "Magicka Cost": "8",
    "Attack": "8",
    "Health": "8",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. When your opponent summons a creature, reduce its power to 0 until the start of your turn.",
    "Keywords": "Guard",
    "Played in": "157/12907 of  Eligible  decks (1 %)",
    "code": "of"
  },
  {
    "Name": "Siege Catapult",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "2",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Siege Catapult can't attack unless your side of its lane is full.",
    "Keywords": "",
    "Played in": "687/13644 of  Eligible  decks (5 %)",
    "code": "og"
  },
  {
    "Name": "Siege Crawler",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Daedra",
    "Magicka Cost": "11",
    "Attack": "15",
    "Health": "15",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Breakthrough",
    "Keywords": "",
    "Played in": "30/30861 of  Eligible  decks (0 %)",
    "code": "yC"
  },
  {
    "Name": "Siege of Stros M'Kai",
    "Rarity": "Legendary - Unique",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "10",
    "Expansion Set": "Forgotten Hero Collection",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "If you started the game with no duplicate cards in your deck, play a random creature, item, support and action from your deck.",
    "Keywords": "",
    "Played in": "501/30861 of  Eligible  decks (2 %)",
    "code": "oh"
  },
  {
    "Name": "Sightless Skulk",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Falmer",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Draw a card if you have two other (agility) creatures.",
    "Keywords": "",
    "Played in": "383/13695 of  Eligible  decks (3 %)",
    "code": "oi"
  },
  {
    "Name": "Sigil Keeper",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Daedra",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Invade, then give your Oblivion Gate a Ward.",
    "Keywords": "",
    "Played in": "96/14266 of  Eligible  decks (1 %)",
    "code": "xN"
  },
  {
    "Name": "Silent Pilgrim",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Draw a random multi-attribute card from your deck.",
    "Keywords": "",
    "Played in": "315/30861 of  Eligible  decks (1 %)",
    "code": "oj"
  },
  {
    "Name": "Silt Strider",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Beast",
    "Magicka Cost": "2",
    "Attack": "0",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy, Guard. Summon: Move a friendly creature to this lane.",
    "Keywords": "Propechy,Guard",
    "Played in": "91/13695 of  Eligible  decks (1 %)",
    "code": "ok"
  },
  {
    "Name": "Silvenar Tracker",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: If there is a wounded enemy creature in this lane, give Silvenar Tracker Charge.",
    "Keywords": "Charge",
    "Played in": "267/12757 of  Eligible  decks (2 %)",
    "code": "ol"
  },
  {
    "Name": "Sixth House Amulet",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+1/+1. Summon: if the wielder has 5 power or more, it gains a Ward.",
    "Keywords": "Ward",
    "Played in": "617/14266 of  Eligible  decks (4 %)",
    "code": "om"
  },
  {
    "Name": "Skar Drillmaster",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Redguard",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Rally. When Skar Drillmaster Rallies acreature, put a copy of the rallied creature into your hand with +1/+1/",
    "Keywords": "Rally",
    "Played in": "282/12757 of  Eligible  decks (2 %)",
    "code": "on"
  },
  {
    "Name": "Skaven Pyromancer",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Redguard",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Deal 1 damage to all other creatures in this lane.",
    "Keywords": "",
    "Played in": "2542/12757 of  Eligible  decks (20 %)",
    "code": "oo"
  },
  {
    "Name": "Skeevaton",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Skeever",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 5 - The Caminus Pit",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: +1/+1 for each other Skeever you've summoned this game.",
    "Keywords": "",
    "Played in": "85/30872 of  Eligible  decks (0 %)",
    "code": "op"
  },
  {
    "Name": "Skeever Infestation",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 2 - Wayrest Sewers",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon a Skeever in each lane with power and health equal to the number of Infestations you've played. Shuffle two copies of this into your deck.",
    "Keywords": "",
    "Played in": "383/12757 of  Eligible  decks (3 %)",
    "code": "oq"
  },
  {
    "Name": "Skeletal Dragon",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Dragon",
    "Magicka Cost": "8",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Guard, Summon: Give all creatures in your discard pile +2/+2. Last Gasp: Draw a random creature from your discard pile.",
    "Keywords": "Guard,Last Gasp",
    "Played in": "1219/13644 of  Eligible  decks (9 %)",
    "code": "or"
  },
  {
    "Name": "Skeletal Mage",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "7",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Consume a creature. Deal damage equal to its power to a creature.",
    "Keywords": "Consume",
    "Played in": "98/14266 of  Eligible  decks (1 %)",
    "code": "vL"
  },
  {
    "Name": "Skeleton Champion",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. Summon: Give other friendly Skeletons +1/+1.",
    "Keywords": "Guard",
    "Played in": "163/13644 of  Eligible  decks (1 %)",
    "code": "os"
  },
  {
    "Name": "Skilled Blacksmith",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Redguard",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Your items cost 1 less",
    "Keywords": "",
    "Played in": "973/14266 of  Eligible  decks (7 %)",
    "code": "ot"
  },
  {
    "Name": "Skingrad Patroller",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "105/12907 of  Eligible  decks (1 %)",
    "code": "ou"
  },
  {
    "Name": "Skinned Hound",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Give a creature +0/+2 and Guard.",
    "Keywords": "Guard",
    "Played in": "879/13644 of  Eligible  decks (6 %)",
    "code": "ov"
  },
  {
    "Name": "Skirmisher's Elixir",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Uses: 3. Activate: Give a creature +2/+0 and Breakthrough.",
    "Keywords": "Breakthrough",
    "Played in": "283/12757 of  Eligible  decks (2 %)",
    "code": "ow"
  },
  {
    "Name": "Skooma Cat's Whimsy",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": ["neutral"],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Your cards that didn't start in your deck cost 1 less.",
    "Keywords": "",
    "code": "yN"
  },
  {
    "Name": "Skooma Racketeer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Give a creature Lethal.",
    "Keywords": "Lethal",
    "Played in": "892/13695 of  Eligible  decks (7 %)",
    "code": "ox"
  },
  {
    "Name": "Skooma Underboss",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 5 - South Bridge",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Friendly Pilfer abilities are also Slay abilities.",
    "Keywords": "Pilfer,Slay",
    "Played in": "276/13695 of  Eligible  decks (2 %)",
    "code": "oy"
  },
  {
    "Name": "Skyborn Dragon",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Dragon",
    "Magicka Cost": "6",
    "Attack": "7",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Battle an enemy creature.",
    "Keywords": "",
    "Played in": "400/12757 of  Eligible  decks (3 %)",
    "code": "oz"
  },
  {
    "Name": "Skyforge",
    "Rarity": "Legendary - Unique",
    "Type": "Support",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Activate: Equip a friendly creature with a Steel Dagger. If Skyforge has equipped 3 daggers, it changes into Underforge.",
    "Keywords": "",
    "Played in": "241/12759 of  Eligible  decks (2 %)",
    "code": "oA"
  },
  {
    "Name": "Skyshard",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": ["endurance"],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Draw a random creature from your deck. When you draw a creature on your turn, increase its cost by 2 and give it +2/+2.",
    "Keywords": "",
    "code": "yT"
  },
  {
    "Name": "Skywatch Vindicator",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "willpower"
    ],
    "Race": "High Elf",
    "Magicka Cost": "6",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Deal 2 damage to an enemy creature or give a friendly creature +2/+2.",
    "Keywords": "",
    "Played in": "186/4500 of  Eligible  decks (4 %)",
    "code": "oB"
  },
  {
    "Name": "Slaughterfish Spawning",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon a Slaughterfish in each lane.",
    "Keywords": "",
    "Played in": "506/30861 of  Eligible  decks (2 %)",
    "Evolves from:": "Slaughterfish",
    "code": "oD"
  },
  {
    "Name": "Slinking Jackal",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Beast",
    "Magicka Cost": "2",
    "Attack": "4",
    "Health": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "93/13695 of  Eligible  decks (1 %)",
    "code": "wd"
  },
  {
    "Name": "Sly Marshblade",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Argonian",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Forgotten Hero Collection",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Last Gasp: Draw a card if you have 7 or more max magicka.",
    "Keywords": "Last Gasp",
    "Played in": "927/13695 of  Eligible  decks (7 %)",
    "code": "oE"
  },
  {
    "Name": "Smash and Grab",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Give friendly creatures with Pilfer +2/+0 and Breakthrough this turn.",
    "Keywords": "Pilfer,Breakthrough",
    "Played in": "56/12907 of  Eligible  decks (0 %)",
    "code": "wv"
  },
  {
    "Name": "Smuggler Underboss",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "willpower",
      "agility"
    ],
    "Race": "Breton",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Tamriel Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Drain. At the end of your turn, if you played three cards this turn, Smuggler Underboss is immune to damage until your next turn.",
    "Keywords": "Drain",
    "Played in": "4/861 of  Eligible  decks (0 %)",
    "code": "Bo"
  },
  {
    "Name": "Smuggler's Haul",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Draw four random 0-cost cards.",
    "Keywords": "",
    "Played in": "506/13695 of  Eligible  decks (4 %)",
    "code": "oF"
  },
  {
    "Name": "Snake Tooth Necklace",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "+1/+1. Summon: Give the wielder Drain this turn.",
    "Keywords": "Drain",
    "Played in": "1073/13695 of  Eligible  decks (8 %)",
    "code": "oG"
  },
  {
    "Name": "Snow Wolf",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Wolf",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "+2/+0 while you have the most creatures in this lane.",
    "Keywords": "",
    "Played in": "208/12907 of  Eligible  decks (2 %)",
    "code": "oI"
  },
  {
    "Name": "Snowhawk detachment",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard. Summon: +1/+1 if you have another creature with Guard.",
    "Keywords": "Guard",
    "Played in": "230/12907 of  Eligible  decks (2 %)",
    "code": "oJ"
  },
  {
    "Name": "Snowy Sabre Cat",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Beast",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "7",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Can attack an additional time on each turn.",
    "Keywords": "",
    "Played in": "437/13695 of  Eligible  decks (3 %)",
    "code": "oK"
  },
  {
    "Name": "Solitude Stalwart",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "1",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "213/12907 of  Eligible  decks (2 %)",
    "code": "oL"
  },
  {
    "Name": "Sorcerer's Negation",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "intelligence",
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Silence a creature, then deal 2 damage to it.",
    "Keywords": "",
    "Played in": "3425/4886 of  Eligible  decks (70 %)",
    "code": "oM"
  },
  {
    "Name": "Sotha Sil",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "God",
    "Magicka Cost": "9",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Exlat 3: +4/+4. At the end of your turn, if you have an Exalted creature in play, summon an Awakened Imperfect.",
    "Keywords": "Exalt",
    "Played in": "711/14266 of  Eligible  decks (5 %)",
    "code": "oN"
  },
  {
    "Name": "Soul Shred",
    "Rarity": "Legendary",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "For each attribute your opponent is playing, Banish the top 2 cards of your opponent's deck. Empower: +1 card per attribute.",
    "Keywords": "Empower",
    "Played in": "76/14271 of  Eligible  decks (1 %)",
    "code": "tP"
  },
  {
    "Name": "Soul Split",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Sacrifice a creature to summon a 3/2 Sundered Shade in each lane.",
    "Keywords": "",
    "Played in": "1126/14266 of  Eligible  decks (8 %)",
    "code": "oO"
  },
  {
    "Name": "Soul Tear",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Level 1: Draw a creature from your discard pile. \nLevel 2: Draw a creature from your discard pile and give it +2/+2. \nLevel 3: Draw a creature from your discard pile and give it +5/+5.",
    "Keywords": "",
    "Played in": "3275/13644 of  Eligible  decks (24 %)",
    "code": "oP"
  },
  {
    "Name": "Soul Wraith",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Spirit",
    "Magicka Cost": "1",
    "Attack": "0",
    "Health": "5",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard.",
    "Keywords": "Prophecy,Guard",
    "Played in": "47/14266 of  Eligible  decks (0 %)",
    "code": "uh"
  },
  {
    "Name": "Soulburst",
    "Rarity": "Legendary - Unique",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "13",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Costs 1 less for each Unique creature in your discard pile. Banish a creature. Deal 3 damage to all enemies.",
    "Keywords": "",
    "Played in": "89/30872 of  Eligible  decks (0 %)",
    "code": "ui"
  },
  {
    "Name": "Soulrest Marshal",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Argonian",
    "Magicka Cost": "6",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: If you have more health than your opponent, the next card you play this turn costs 6 less.",
    "Keywords": "",
    "Played in": "668/13695 of  Eligible  decks (5 %)",
    "code": "oQ"
  },
  {
    "Name": "Sound the Alarm",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Enemy creatures lose Cover.",
    "Keywords": "",
    "Played in": "22/12907 of  Eligible  decks (0 %)",
    "code": "ue"
  },
  {
    "Name": "Sower of Revenge",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "endurance"
    ],
    "Race": "Daedra",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. Last Gasp: Deals 5 damage to the enemy player.",
    "Keywords": "Guard,Last Gasp",
    "Played in": "1764/3890 of  Eligible  decks (45 %)",
    "code": "oR"
  },
  {
    "Name": "Sparking Spider",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard",
    "Keywords": "Guard,Prophecy",
    "Played in": "326/30861 of  Eligible  decks (1 %)",
    "code": "oS"
  },
  {
    "Name": "Sparksmith",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Redguard",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "When a friendly creature equips an item, deal 1 damage to your opponent.",
    "Keywords": "",
    "Played in": "98/14271 of  Eligible  decks (1 %)",
    "code": "uj"
  },
  {
    "Name": "Spawn Mother/Baliwog",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Grummite",
    "Magicka Cost": "4",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "60/12907 of  Eligible  decks (0 %)",
    "code": "oT"
  },
  {
    "Name": "Speaker Terenus",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Imperial",
    "Magicka Cost": "10",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 2 - Castle Wayrest,  Throne Room",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "After you play an action, put a random action into your hand.",
    "Keywords": "",
    "Played in": "337/14266 of  Eligible  decks (2 %)",
    "code": "oU"
  },
  {
    "Name": "Spear of Embers",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 5 - Silverhome on the Water, Back Room",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy. +3/+3. Instead of equipping Spear of Embers, you may throw it at an enemy creature to deal 3 damage.",
    "Keywords": "Prophecy",
    "Played in": "231/14266 of  Eligible  decks (2 %)",
    "code": "oV"
  },
  {
    "Name": "Spellsword's Summoning",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "willpower",
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon a random 1-cost creature in each lane.",
    "Keywords": "",
    "Played in": "240/4355 of  Eligible  decks (6 %)",
    "code": "oW"
  },
  {
    "Name": "Spider Daedra",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Daedra",
    "Magicka Cost": "8",
    "Attack": "4",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Fill your lanes with 2/1 Spiderlings. Last Gasp: Destroy all friendly Spiderlings.",
    "Keywords": "Last Gasp",
    "Played in": "111/13695 of  Eligible  decks (1 %)",
    "code": "oX"
  },
  {
    "Name": "Spider Lair",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the start of your turn, summon a random Spider.",
    "Keywords": "",
    "Played in": "175/13695 of  Eligible  decks (1 %)",
    "code": "oY"
  },
  {
    "Name": "Spider Worker",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "2",
    "Attack": "0",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Summon: Draw a card.",
    "Keywords": "Prophecy",
    "Played in": "723/30861 of  Eligible  decks (2 %)",
    "code": "oZ"
  },
  {
    "Name": "Spine of Eldersblood",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Dragon",
    "Magicka Cost": "6",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Gaint +1 max magicka.",
    "Keywords": "",
    "Played in": "1719/13644 of  Eligible  decks (13 %)",
    "code": "pa"
  },
  {
    "Name": "Spiny Haj Mota",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Beast",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: +4/+4 for each Spiny Haj Mota in your discard pile.",
    "Keywords": "",
    "Played in": "44/13644 of  Eligible  decks (0 %)",
    "code": "uk"
  },
  {
    "Name": "Spirit Knife",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Deal 7 damage to a creature. Draw a card.",
    "Keywords": "",
    "Played in": "498/14266 of  Eligible  decks (3 %)",
    "code": "pb"
  },
  {
    "Name": "Spiteful Dremora",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Daedra",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Destroy an enemy creature with 2 power or less.",
    "Keywords": "",
    "Played in": "128/12907 of  Eligible  decks (1 %)",
    "code": "pc"
  },
  {
    "Name": "Spoils of War",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Draw two cards. Empower: Costs 1 less.",
    "Keywords": "",
    "Played in": "689/13695 of  Eligible  decks (5 %)",
    "code": "um"
  },
  {
    "Name": "Squish the Wimpy",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "A friendly creature Battles an enemy creature.",
    "Keywords": "",
    "Played in": "711/13644 of  Eligible  decks (5 %)",
    "code": "pe"
  },
  {
    "Name": "Staff of Ice",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Prophecy, Mobilize. +1/+1. Summon: The wielder deals 2 damage.",
    "Keywords": "",
    "Played in": "103/14266 of  Eligible  decks (1 %)",
    "code": "uo"
  },
  {
    "Name": "Staff of Sparks",
    "Rarity": "Legendary",
    "Type": "Item",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "+3/+0. When the wielder attacks, it deals 1 damage to all enemy creatures in this lane.",
    "Keywords": "",
    "Played in": "193/14266 of  Eligible  decks (1 %)",
    "code": "pf"
  },
  {
    "Name": "Stalking Shadowscale",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 4 - Abandoned Mine",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Slay: +1/+1",
    "Keywords": "Slay",
    "Played in": "387/13644 of  Eligible  decks (3 %)",
    "code": "ph"
  },
  {
    "Name": "Stalwart Ally",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: +0/+2 and Guard if the top card of your deck is (Endurance).",
    "Keywords": "Guard",
    "Played in": "352/13644 of  Eligible  decks (3 %)",
    "code": "pi"
  },
  {
    "Name": "Stampede Sentinel",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Giant",
    "Magicka Cost": "6",
    "Attack": "7",
    "Health": "7",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Breakthrough, You can't be damaged by actions or supports.",
    "Keywords": "Breakthrough",
    "Played in": "163/12757 of  Eligible  decks (1 %)",
    "code": "pj"
  },
  {
    "Name": "Stampeding Mammoth",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Mammoth",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Breakthrough. Stampeding Mammoth has +2/+0 for each other friendly creature with breakthrough.",
    "Keywords": "Breakthrough",
    "Played in": "67/13644 of  Eligible  decks (0 %)",
    "code": "pk"
  },
  {
    "Name": "Stand Watch",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Give a creature Guard. Draw a card.",
    "Keywords": "Prophecy,Guard",
    "Played in": "231/12907 of  Eligible  decks (2 %)",
    "code": "pl"
  },
  {
    "Name": "Star-Sung Bard",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 4 - The Red Mountain",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Immune to Silence. Your unique cards cost 1 less.",
    "Keywords": "",
    "Played in": "144/30861 of  Eligible  decks (0 %)",
    "code": "pm"
  },
  {
    "Name": "Stealer of Secrets",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "6",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 5 - Silverhome on the Water",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Ward. Summon: +1/+1 for each action in your discard pile.",
    "Keywords": "Ward",
    "Played in": "338/14266 of  Eligible  decks (2 %)",
    "code": "pp"
  },
  {
    "Name": "Steam Constructor",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: If you have a (neutral) card in your hand, summon a 1/1 Reconstructed Spider.",
    "Keywords": "",
    "Played in": "401/30861 of  Eligible  decks (1 %)",
    "code": "pq"
  },
  {
    "Name": "Steel Scimitar",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+2/+2",
    "Keywords": "",
    "Played in": "2906/12757 of  Eligible  decks (23 %)",
    "code": "pr"
  },
  {
    "Name": "Steel Sword",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+3/+0",
    "Keywords": "",
    "Played in": "212/14266 of  Eligible  decks (1 %)",
    "code": "ps"
  },
  {
    "Name": "Steel-Eyed Visionary",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Veteran: Set each friendly creature's power equal to its health.",
    "Keywords": "",
    "Played in": "36/13644 of  Eligible  decks (0 %)",
    "code": "tp"
  },
  {
    "Name": "Steelheart Vanquisher",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Orc",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Slay: Give friendly Orcs +1/+1.",
    "Keywords": "Slay",
    "Played in": "205/13644 of  Eligible  decks (2 %)",
    "code": "pt"
  },
  {
    "Name": "Stendarr's Hammer",
    "Rarity": "Legendary - Unique",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Double the wielder's power and health. The wielder can only attack creatures.",
    "Keywords": "",
    "Played in": "77/12757 of  Eligible  decks (1 %)",
    "code": "pu"
  },
  {
    "Name": "Stolen Pants",
    "Rarity": "Epic",
    "Type": "Item",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "+1/+1. Summon: Summon a 0/1 Sheepish Dunmer in the other lane. Last Gasp: Give Sheepish Dunmer his pants.",
    "Keywords": "",
    "Played in": "102/30861 of  Eligible  decks (0 %)",
    "code": "pv"
  },
  {
    "Name": "Stone Throw",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Destroy an enemy creature if you have a creature with higher power.",
    "Keywords": "",
    "Played in": "382/12757 of  Eligible  decks (3 %)",
    "code": "pw"
  },
  {
    "Name": "Stonehill Mammoth",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Mammoth",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "7",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Draw a card if you have two other (endurance) creatures.",
    "Keywords": "",
    "Played in": "115/13644 of  Eligible  decks (1 %)",
    "code": "px"
  },
  {
    "Name": "Stoneshard Orc",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Madhouse Collection",
    "Soul Summon": "This card belongs to the Madhouse Collection and cannot be Soul Summoned.",
    "Soul Trap": "This card belongs to the Madhouse Collection and cannot be Soul Trapped.",
    "Text": "Summon: Deal 1 damage to an enemy creature for each friendly Orc.",
    "Keywords": "",
    "Played in": "496/12757 of  Eligible  decks (4 %)",
    "code": "py"
  },
  {
    "Name": "Stonetooth Scrapper",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Orc",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "235/13644 of  Eligible  decks (2 %)",
    "code": "pz"
  },
  {
    "Name": "Stormcloak Avenger",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the end of your turn, if three or more friendly creatures died this turn, summon a 2/2 Rallying Stormcloak.",
    "Keywords": "",
    "Played in": "22/12757 of  Eligible  decks (0 %)",
    "code": "pB"
  },
  {
    "Name": "Stormcloak Camp",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Oigoing. At the end of your turn, if a creature died this turn, deal 2 damage to your opponent.",
    "Keywords": "",
    "Played in": "267/12757 of  Eligible  decks (2 %)",
    "code": "pC"
  },
  {
    "Name": "Stormcloak Vanguard",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Charge. Last Gasp: Put a 5/5 Stormcloak Battalion in your hand.",
    "Keywords": "Charge,Last Gasp",
    "Played in": "2285/12757 of  Eligible  decks (18 %)",
    "code": "pD"
  },
  {
    "Name": "Stormhold Henchman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "While you have 7 or more max magicka, Stormhold Henchman has +2/+2.",
    "Keywords": "",
    "Played in": "234/13644 of  Eligible  decks (2 %)",
    "code": "pE"
  },
  {
    "Name": "Stoutheart Giant",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Giant",
    "Magicka Cost": "5",
    "Attack": "6",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "55/12757 of  Eligible  decks (0 %)",
    "code": "pF"
  },
  {
    "Name": "Strange Brew",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "1",
    "Expansion Set": "Tamriel Collection",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Transform a creature in your hand into a random creature that costs 2 more. Reduce its cost by 2.",
    "Keywords": "",
    "Played in": "3/14266 of  Eligible  decks (0 %)",
    "code": "Bl"
  },
  {
    "Name": "Strategic Deployment",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon two 1/1 Recruits in each lane.",
    "Keywords": "",
    "Played in": "92/13644 of  Eligible  decks (1 %)",
    "code": "uq"
  },
  {
    "Name": "Strategist's Map",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Uses: 3. Activate: Summon a 0/1 Target with Guard for you or your opponent.",
    "Keywords": "Guard",
    "Played in": "55/12907 of  Eligible  decks (0 %)",
    "code": "sY"
  },
  {
    "Name": "Stronghold Eradicator",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "5",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Give all enemy creatures in this lane Guard.",
    "Keywords": "Guard",
    "Played in": "415/30861 of  Eligible  decks (1 %)",
    "Evolves from:": "Stronghold Prototype",
    "code": "pG"
  },
  {
    "Name": "Stronghold Incubator",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Last Gasp: Put two random Dwemer into your hand.",
    "Keywords": "Last Gasp",
    "Played in": "374/30861 of  Eligible  decks (1 %)",
    "Evolves from:": "Stronghold Prototype",
    "code": "pH"
  },
  {
    "Name": "Stronghold Patrol",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Draw a card if you have two other (strength) creatures.",
    "Keywords": "",
    "Played in": "444/12757 of  Eligible  decks (3 %)",
    "code": "pI"
  },
  {
    "Name": "Studious Greybeard",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Nord",
    "Magicka Cost": "1",
    "Attack": "0",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Studious Greybeard",
    "Keywords": "",
    "Played in": "331/14266 of  Eligible  decks (2 %)",
    "code": "pL"
  },
  {
    "Name": "Studium Headmaster",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "6",
    "Attack": "6",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Each player draws two cards.",
    "Keywords": "",
    "Played in": "74/14266 of  Eligible  decks (1 %)",
    "code": "pM"
  },
  {
    "Name": "Summerset Orrery",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Uses: 3. Activate: Shuffle all cards in your hand with Prophecy into your deck and draw that many cards.",
    "Keywords": "Prophecy",
    "Played in": "53/14266 of  Eligible  decks (0 %)",
    "code": "pN"
  },
  {
    "Name": "Summerset Shieldmage",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "High Elf",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Other friendly creatures in this lane have +0/+1.",
    "Keywords": "",
    "Played in": "126/12907 of  Eligible  decks (1 %)",
    "code": "pO"
  },
  {
    "Name": "Sun-in-Shadow",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "agility",
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "6",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Permanently Shackle another friendly creature to draw an action of your choice from your deck.",
    "Keywords": "",
    "Played in": "850/1118 of  Eligible  decks (76 %)",
    "code": "pP"
  },
  {
    "Name": "Sunhold Medic",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "High Elf",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Give a creature +0/+2.",
    "Keywords": "",
    "Played in": "185/12907 of  Eligible  decks (1 %)",
    "code": "pQ"
  },
  {
    "Name": "Sunken One",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Daedra",
    "Magicka Cost": "7",
    "Attack": "5",
    "Health": "7",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Ward.",
    "Keywords": "Ward",
    "Played in": "9/14266 of  Eligible  decks (0 %)",
    "code": "xT"
  },
  {
    "Name": "Supply Runner",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "1",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: If you have another creature in each lane, gain +1 max magicka.",
    "Keywords": "",
    "Played in": "64/13644 of  Eligible  decks (0 %)",
    "code": "ur"
  },
  {
    "Name": "Suppress",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Silence a creature.",
    "Keywords": "",
    "Played in": "1136/13644 of  Eligible  decks (8 %)",
    "code": "pR"
  },
  {
    "Name": "Supreme Atromancer",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "10",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Summon a Flame Atronach in each lane. When you summon another creature, deal 2 damage to your opponent.",
    "Keywords": "",
    "Played in": "2569/14266 of  Eligible  decks (18 %)",
    "Evolves from:": "Expert Atromancer",
    "code": "pS"
  },
  {
    "Name": "Supreme Dragon",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": ["strength", "willpower"],
    "Race": "Dragon",
    "Attack": "7",
    "Health": "7",
    "Magicka Cost": "6",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the start of each turn, for each enemy creature in this lane with power greater than 3, set its power to 3.",
    "Keywords": "",
    "code": "yO"
  },
  {
    "Name": "Suran Pawnbroker",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Plot: Put a random 0-cost card into your hand.",
    "Keywords": "Plot",
    "Played in": "1148/13695 of  Eligible  decks (8 %)",
    "code": "pT"
  },
  {
    "Name": "Suthay Bootlegger",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard. Summon: Another friendly creature ignores Guard this turn.",
    "Keywords": "Guard",
    "Played in": "85/13695 of  Eligible  decks (1 %)",
    "code": "wV"
  },
  {
    "Name": "Swamp Leviathan",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Reptile",
    "Magicka Cost": "7",
    "Attack": "8",
    "Health": "8",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "165/13644 of  Eligible  decks (1 %)",
    "code": "pU"
  },
  {
    "Name": "Swift Strike",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Give a creature an extra attack this turn.",
    "Keywords": "",
    "Played in": "1189/13695 of  Eligible  decks (9 %)",
    "code": "pV"
  },
  {
    "Name": "Swiftwing Dragon",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Dragon",
    "Magicka Cost": "8",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Charge|",
    "Keywords": "Charge",
    "Played in": "355/12757 of  Eligible  decks (3 %)",
    "code": "pW"
  },
  {
    "Name": "Swims-at-Night",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Argonian",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Put a random 0-cost card into your hand. After you play a 0-cost card, Swims-at-Night gains +1/+1.",
    "Keywords": "",
    "Played in": "396/13695 of  Eligible  decks (3 %)",
    "code": "pX"
  },
  {
    "Name": "Swindler's Market",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Madhouse Collection",
    "Soul Summon": "This card belongs to the Madhouse Collection and cannot be Soul Summoned.",
    "Soul Trap": "This card belongs to the Madhouse Collection and cannot be Soul Trapped.",
    "Text": "Ongoing. When you play a 0-cost card, deal 1 damage to your opponent and gain 1 health.",
    "Keywords": "",
    "Played in": "706/13695 of  Eligible  decks (5 %)",
    "code": "pZ"
  },
  {
    "Name": "Sword of the Inferno",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "FrostSpark Collection",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "+2/+0. Summon: The wielder deals 2 damage to itself and another creature.",
    "Keywords": "",
    "Played in": "505/12757 of  Eligible  decks (4 %)",
    "code": "qa"
  },
  {
    "Name": "Syl, Duchess of Dementia",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "6",
    "Attack": "7",
    "Health": "6",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: This lane becomes Dementia.",
    "Keywords": "",
    "Played in": "459/12757 of  Eligible  decks (4 %)",
    "code": "fc"
  },
  {
    "Name": "Tavyar the Knight/Rayvat the Mage",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "endurance",
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "",
    "Keywords": "",
    "Played in": "251/4886 of  Eligible  decks (5 %)",
    "code": "mK"
  },
  {
    "Name": "Tazkad the Packmaster",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Goblin",
    "Magicka Cost": "9",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Breakthrough, Charge. Last Gasp: Summon a 4/4 Durzog.",
    "Keywords": "Breakthrough,Charge,Last Gasp",
    "Played in": "5162/13695 of  Eligible  decks (38 %)",
    "code": "qc"
  },
  {
    "Name": "Tel Vos Magister",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Ward. At the end of your turn, if Tel Vos Magister has a Ward, you gain a Ward.",
    "Keywords": "Ward",
    "Played in": "1459/14266 of  Eligible  decks (10 %)",
    "code": "qd"
  },
  {
    "Name": "Telekinesis",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Equip all your items in play to a friendly creature.",
    "Keywords": "",
    "Played in": "111/14271 of  Eligible  decks (1 %)",
    "code": "us"
  },
  {
    "Name": "Telvanni Arcanist",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Last Gasp: Put a random action into your hand.",
    "Keywords": "Last Gasp",
    "Played in": "889/14266 of  Eligible  decks (6 %)",
    "code": "qe"
  },
  {
    "Name": "Telvanni Catspaw",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "agility",
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Last Gasp: Draw a card. If Telvanni Catspaw was sacrificed, draw two cards instead.",
    "Keywords": "Last Gasp",
    "Played in": "625/1118 of  Eligible  decks (56 %)",
    "code": "qf"
  },
  {
    "Name": "Telvanni Oathman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: If you have a ... (intelligence) card in play, draw a random action from your deck. (endurance) card in play, summon a Risen Dead in each lane.",
    "Keywords": "",
    "Played in": "261/13695 of  Eligible  decks (2 %)",
    "code": "qg"
  },
  {
    "Name": "Temple Conjurer",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Exalt 3: Summon a 5/3 Flame Atronach with Breakthrough.",
    "Keywords": "Exalt",
    "Played in": "489/14266 of  Eligible  decks (3 %)",
    "code": "qh"
  },
  {
    "Name": "Temple Patriarch",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "willpower",
      "endurance"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Trigger the Exalt of each friendly creature.",
    "Keywords": "Exalt",
    "Played in": "161/1015 of  Eligible  decks (16 %)",
    "code": "qi"
  },
  {
    "Name": "Tenarr Zalviit Lurker",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "6",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Consume a creature. You gain health equal to its health.",
    "Keywords": "Consume",
    "Played in": "40/12907 of  Eligible  decks (0 %)",
    "code": "vN"
  },
  {
    "Name": "Tenarr Zalviit Nightstalker",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "At the start of your turn, Consume a random creature. If you can't sacrifice Tenarr Zalvitt Nightstalker.",
    "Keywords": "Consume",
    "Played in": "15/13695 of  Eligible  decks (0 %)",
    "code": "vX"
  },
  {
    "Name": "Tenmar Swiftclaw",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Pilfer: +1/+1. Can attack an additional time each turn.",
    "Keywords": "Pilfer",
    "Played in": "333/13695 of  Eligible  decks (2 %)",
    "code": "qj"
  },
  {
    "Name": "Territorial Viper",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Reptile",
    "Magicka Cost": "4",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Charge, Lethal",
    "Keywords": "Charge,Lethal",
    "Played in": "2626/13695 of  Eligible  decks (19 %)",
    "code": "qk"
  },
  {
    "Name": "Thadon, Duke of Mania",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "6",
    "Attack": "6",
    "Health": "7",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: This lane becomes Mania.",
    "Keywords": "",
    "Played in": "455/12907 of  Eligible  decks (4 %)",
    "code": "fe"
  },
  {
    "Name": "Thalmor Embassy",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Ongoing. Your High Elves cost 1 less. You can't be damaged by actions.",
    "Keywords": "",
    "Played in": "139/14266 of  Eligible  decks (1 %)",
    "code": "ql"
  },
  {
    "Name": "Thalmor Justiciar",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "High Elf",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "After you play an action, summon a 1/1 Thalmor Soldier.",
    "Keywords": "",
    "Played in": "149/12907 of  Eligible  decks (1 %)",
    "code": "qm"
  },
  {
    "Name": "The Black Dragon",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 1 - Docks",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Immune to Lethal. Slay: Discard all copies of the slain creature from the opponent's deck.",
    "Keywords": "Lethal,Slay",
    "Played in": "2952/12907 of  Eligible  decks (23 %)",
    "code": "qn"
  },
  {
    "Name": "The Crisis Begins",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Destroy a creature. Invade.",
    "Keywords": "Invade",
    "Played in": "57/12907 of  Eligible  decks (0 %)",
    "code": "xo"
  },
  {
    "Name": "The Gatekeeper",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Daedra",
    "Magicka Cost": "5",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Guard. Only one creature in this lane can attack each turn.",
    "Keywords": "Guard",
    "Played in": "868/13644 of  Eligible  decks (6 %)",
    "code": "qo"
  },
  {
    "Name": "The Gray Fox",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Draw a card from your opponent's discard pile. Pilfer: Reveal a random unrevealed card from your opponent's hand.",
    "Keywords": "Pilfer",
    "Played in": "85/13695 of  Eligible  decks (1 %)",
    "code": "yB"
  },
  {
    "Name": "The Mechanical Heart",
    "Rarity": "Legendary - Unique",
    "Type": "Support",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 6 - Chamber of Lorkhan",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Ongoing: When you have 0 or less health, sacrifice The Mechanical Heart, set your health to 10, and restore a rune.",
    "Keywords": "",
    "Played in": "350/12907 of  Eligible  decks (3 %)",
    "code": "qp"
  },
  {
    "Name": "The Night Mother",
    "Rarity": "Legendary - Unique",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 6 - Night Mother's Crypt Part 2",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Uses: Unlimited. Activate: Summon 0/1 Target with Guard for your opponent. Once 20 enemy creatures have died, deal 20 damage to your opponent, gain 20 health, and draw up to 10 cards.",
    "Keywords": "Guard",
    "Played in": "1233/30861 of  Eligible  decks (4 %)",
    "code": "qq"
  },
  {
    "Name": "The Red Year",
    "Rarity": "Legendary - Unique",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "10",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Deal 10 damage to each creature.",
    "Keywords": "",
    "Played in": "836/12757 of  Eligible  decks (7 %)",
    "code": "qr"
  },
  {
    "Name": "The Ruby Throne",
    "Rarity": "Legendary - Unique",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Ongoing. Summon: Crown a creature. At the end of each player's turn, give crowned creatures +1/+1. If there is no crowned creature in play, when either player summons a Unique creature, crown it.",
    "Keywords": "",
    "Played in": "78/30861 of  Eligible  decks (0 %)",
    "code": "ut"
  },
  {
    "Name": "The Ultimate Heist",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "12",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Costs 3 less for each time you've Pilfered or Drained this turn. Deal damage to your opponent destroying their front rune. Steal the card drawn from the rune. If it's a Prophecy, you may play it for free.",
    "Keywords": "",
    "Played in": "50/13695 of  Eligible  decks (0 %)",
    "code": "yn"
  },
  {
    "Name": "Therana's Lawman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "8",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard, Ward.",
    "Keywords": "Guard,Ward",
    "Played in": "128/14266 of  Eligible  decks (1 %)",
    "code": "qu"
  },
  {
    "Name": "Therana",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "8",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "After you play an action, shuffle three 0-cost copies of that action into your deck.",
    "Keywords": "",
    "Played in": "983/14271 of  Eligible  decks (7 %)",
    "code": "qt"
  },
  {
    "Name": "Thief of Dreams",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: See a vision of two of your opponent's cards. Guess which one is in their hand. If you're right, draw a copy of it.",
    "Keywords": "",
    "Played in": "470/14266 of  Eligible  decks (3 %)",
    "code": "qv"
  },
  {
    "Name": "Thievery",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Deal 3 damage to your opponent and gain 3 health.",
    "Keywords": "",
    "Played in": "327/13703 of  Eligible  decks (2 %)",
    "code": "qw"
  },
  {
    "Name": "Thieves Guild Fence",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "When you draw a card on your turn, reduce its cost by 1.",
    "Keywords": "",
    "Played in": "624/13695 of  Eligible  decks (5 %)",
    "code": "qx"
  },
  {
    "Name": "Thieves Guild Recruit",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Argonian",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Draw a card. If it costs 7 or more, reduce its cost by 1.",
    "Keywords": "",
    "Played in": "7171/13695 of  Eligible  decks (52 %)",
    "Evolves from:": "Guild Recruit",
    "code": "qy"
  },
  {
    "Name": "Thieves Guild Shadowfoot",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Steal the top card of the opponent's deck and replace it with a Counterfeit Trinket.",
    "Keywords": "",
    "Played in": "1091/12907 of  Eligible  decks (8 %)",
    "code": "qz"
  },
  {
    "Name": "Thieves' Den",
    "Rarity": "Legendary",
    "Type": "Support",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Friendly creatures have Pilfer: +1/+1.",
    "Keywords": "Pilfer",
    "Played in": "1033/13695 of  Eligible  decks (8 %)",
    "code": "qA"
  },
  {
    "Name": "Thorn Histmage",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility",
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "5",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. Summon: Gain +1 max magicka. When your magicka increases Thorn Histmage gains +1/+0.",
    "Keywords": "Guard",
    "Played in": "2436/4386 of  Eligible  decks (56 %)",
    "code": "qB"
  },
  {
    "Name": "Thornwell Terror",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Nord",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 1 - Darkened Forest",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Beast Form: +1/+1",
    "Keywords": "",
    "Played in": "146/13644 of  Eligible  decks (1 %)",
    "code": "qC"
  },
  {
    "Name": "Three Feather Warchief",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Goblin",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Set a creature's health to 1.",
    "Keywords": "",
    "Played in": "60/13644 of  Eligible  decks (0 %)",
    "code": "yy"
  },
  {
    "Name": "Throne Aligned",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 6 - The Throne Aligned",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard. +3/+3. Summon: Shackle the wielder.",
    "Keywords": "Guard",
    "Played in": "226/14266 of  Eligible  decks (2 %)",
    "code": "qD"
  },
  {
    "Name": "Tiny Dragon",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Dragon",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Deal 1 damage to all enemy creatures in this lane.",
    "Keywords": "",
    "Played in": "403/12759 of  Eligible  decks (3 %)",
    "code": "qE"
  },
  {
    "Name": "Tome of Alteration",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+2/+2. Summon: Draw a card.",
    "Keywords": "",
    "Played in": "1130/14266 of  Eligible  decks (8 %)",
    "code": "qF"
  },
  {
    "Name": "Torval Crook",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "4",
    "Attack": "1",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Charge. Pilfer: Gain 2 magicka.",
    "Keywords": "Charge,Pilfer",
    "Played in": "510/13695 of  Eligible  decks (4 %)",
    "code": "qG"
  },
  {
    "Name": "Torval Extortionist",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "5",
    "Attack": "7",
    "Health": "5",
    "Expansion Set": "FrostSpark Collection",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Slay: Gain magicka this turn equal to the slain creature's cost.",
    "Keywords": "Slay",
    "Played in": "303/13695 of  Eligible  decks (2 %)",
    "code": "qH"
  },
  {
    "Name": "Tower Alchemist",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Your support cards with Activate abilities have unlimited uses.",
    "Keywords": "",
    "Played in": "497/12907 of  Eligible  decks (4 %)",
    "code": "qI"
  },
  {
    "Name": "Training Grounds",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Ongoing: When you summon a creature, give it +1/+1 if it shares a type with the top creature in your deck.",
    "Keywords": "",
    "Played in": "152/30861 of  Eligible  decks (0 %)",
    "code": "so"
  },
  {
    "Name": "Traitor's Flames",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Betray. Deal 2 damage to all enemy creatures in a lane.",
    "Keywords": "Betray",
    "Played in": "72/14266 of  Eligible  decks (1 %)",
    "code": "qJ"
  },
  {
    "Name": "Transitus Shrine",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "willpower",
      "agility",
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Ongoing. While you have a creature in each lane, your creatures and actions cost 1 less.",
    "Keywords": "",
    "Played in": "120/356 of  Eligible  decks (34 %)",
    "code": "uu"
  },
  {
    "Name": "Transmogrify",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Attack": "0",
    "Health": "0",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Sacrifice a creature to summon the top creature from your deck.",
    "Keywords": "",
    "Played in": "71/14271 of  Eligible  decks (0 %)",
    "code": "qK"
  },
  {
    "Name": "Treasure Map",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 2 - Alfe Fyr",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "+1/+1. Summon: Draw a card. If the wielder has Treasure Hunt, draw something they are hunting for instead.",
    "Keywords": "Treasure Hunt",
    "Played in": "512/30861 of  Eligible  decks (2 %)",
    "code": "qL"
  },
  {
    "Name": "Trebuchet",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "0",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "At the start of your turn, deal 4 damage to a random enemy.",
    "Keywords": "",
    "Played in": "155/12759 of  Eligible  decks (1 %)",
    "code": "qM"
  },
  {
    "Name": "Tree Minder",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Argonian",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard, Summon: Gain +1 max magicka.",
    "Keywords": "Guard",
    "Played in": "3979/13644 of  Eligible  decks (29 %)",
    "code": "qN"
  },
  {
    "Name": "Trespasser's Bane",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Set a creature's power to 1.",
    "Keywords": "",
    "Played in": "142/13644 of  Eligible  decks (1 %)",
    "code": "qO"
  },
  {
    "Name": "Trial of Flame",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 2 - Winterhold Wilderness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Choose a lane. Destroy all creatures except for the most powerful creature on both sides of that lane.",
    "Keywords": "",
    "Played in": "99/12757 of  Eligible  decks (1 %)",
    "code": "qP"
  },
  {
    "Name": "Tribunal Oathman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: If you have a... (willpower) card in play, you gain 4 health. (endurance) card in play, gain +1 max magicka.",
    "Keywords": "",
    "Played in": "233/14266 of  Eligible  decks (2 %)",
    "code": "qQ"
  },
  {
    "Name": "Triumphant Jarl",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "6",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: If you have more health than your opponent, draw two cards.",
    "Keywords": "",
    "Played in": "2100/12757 of  Eligible  decks (16 %)",
    "code": "qR"
  },
  {
    "Name": "Trouble Seeker",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Battle an enemy creature. When Trouble Seeker takes damage, he deals that much damage to you.",
    "Keywords": "",
    "Played in": "40/12757 of  Eligible  decks (0 %)",
    "code": "qS"
  },
  {
    "Name": "Trusty Sword",
    "Rarity": "Common",
    "Type": "Item",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "+2/+0",
    "Keywords": "",
    "Played in": "19/14266 of  Eligible  decks (0 %)",
    "code": "xM"
  },
  {
    "Name": "Tullius' Conscription",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "12",
    "Expansion Set": "Forgotten Hero Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon one of each creature from your deck that costs 2 or less.",
    "Keywords": "",
    "Played in": "1132/30861 of  Eligible  decks (4 %)",
    "code": "qT"
  },
  {
    "Name": "Tusked Bristleback",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Beast",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "71/12907 of  Eligible  decks (1 %)",
    "code": "qU"
  },
  {
    "Name": "Twin Lamps Consul",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Argonian",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Plot: Lethal and Guard.",
    "Keywords": "Plot,Lethal,Guard",
    "Played in": "237/13695 of  Eligible  decks (2 %)",
    "code": "qW"
  },
  {
    "Name": "Two-Moons Contemplation",
    "Rarity": "Rare",
    "Type": "Support",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "If your opponent doesn't damage you on their turn, sacrifice this and summon a Priest of the Moons in each lane.",
    "Keywords": "",
    "Played in": "212/12907 of  Eligible  decks (2 %)",
    "code": "qX"
  },
  {
    "Name": "Tyr",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Prophecy, Breakthrough, Guard",
    "Keywords": "Breakthrough,Guard,Prophecy",
    "Played in": "1173/3996 of  Eligible  decks (29 %)",
    "code": "qY"
  },
  {
    "Name": "Ulfric Stormcloak",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "5",
    "Attack": "6",
    "Health": "5",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Breakthrough, When you play a Shout, draw a random Nord from your deck.",
    "Keywords": "Breakthrough",
    "Played in": "149/12757 of  Eligible  decks (1 %)",
    "code": "qZ"
  },
  {
    "Name": "Ulfric's Housecarl",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When an enemy rune is destroyed, draw a card.",
    "Keywords": "",
    "Played in": "958/3994 of  Eligible  decks (24 %)",
    "code": "ra"
  },
  {
    "Name": "Ulfric's Uprising",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Expansion Set": "Forgotten Hero Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Trigger the Summon of each friendly creature.",
    "Keywords": "",
    "Played in": "723/30861 of  Eligible  decks (2 %)",
    "code": "rb"
  },
  {
    "Name": "Ulfric's Zealot",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "5",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Last Gasp: Put a Heavy Battleaxe into your hand.",
    "Keywords": "Last Gasp",
    "Played in": "263/12757 of  Eligible  decks (2 %)",
    "code": "rc"
  },
  {
    "Name": "Umaril the Unfeathered",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Ayleid",
    "Magicka Cost": "6",
    "Attack": "6",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Guard. When Umaril the Unfeathered leaves play, summon him in the other Silenced.",
    "Keywords": "Guard",
    "Played in": "25/13644 of  Eligible  decks (0 %)",
    "code": "yH"
  },
  {
    "Name": "Umbra",
    "Rarity": "Legendary - Unique",
    "Type": "Item",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "+3/+5. At the start of your turn, the wielder Battles an enemy creature of Umbra's choosing.",
    "Keywords": "",
    "Played in": "100/12916 of  Eligible  decks (1 %)",
    "code": "rd"
  },
  {
    "Name": "Underworld Vigilante",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "1",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 6 - Night Mother's Crypt",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Enemy creatures in this lane lose Cover.",
    "Keywords": "Charge",
    "Played in": "1641/12757 of  Eligible  decks (13 %)",
    "code": "re"
  },
  {
    "Name": "Undying Dragon",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Dragon",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Drain. +5/+5 while you have 30 or more health.",
    "Keywords": "Drain",
    "Played in": "1517/12907 of  Eligible  decks (12 %)",
    "code": "rf"
  },
  {
    "Name": "Unexpected Arrival",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Invade, then summon a random Daedra with cost equal to your Oblivion Gate's level.",
    "Keywords": "Invade",
    "Played in": "68/12907 of  Eligible  decks (1 %)",
    "code": "xs"
  },
  {
    "Name": "Unfinished Business",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Costs 3 less for each friendly Wounded creature. Unsummon a creature. Then you may unsummon a friendly creature.",
    "Keywords": "",
    "Played in": "14/12757 of  Eligible  decks (0 %)",
    "code": "xA"
  },
  {
    "Name": "Ungolim the Listener",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Shuffle three Brotherhood Assassins into your deck.",
    "Keywords": "",
    "Played in": "5614/13695 of  Eligible  decks (41 %)",
    "code": "rg"
  },
  {
    "Name": "Unicorn",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Beast",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Friendly creatures in this lane with less power than Unicorn have Charge.",
    "Keywords": "Charge",
    "Played in": "50/13703 of  Eligible  decks (0 %)",
    "code": "xX"
  },
  {
    "Name": "Unite the Houses",
    "Rarity": "Legendary",
    "Type": "Action",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "If you have at least one card of each attribute in play, you win the game.",
    "Keywords": "",
    "Played in": "164/30861 of  Eligible  decks (1 %)",
    "code": "rh"
  },
  {
    "Name": "Unrelenting Force",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Level 1:\nUnsummon an enemy creature with power 3 or less.\n\nLevel 2:\nUnsummon an enemy creature.\n\nLevel 3:\nUnsummon all enemy creatures in a lane.",
    "Keywords": "",
    "Played in": "252/12757 of  Eligible  decks (2 %)",
    "code": "ri"
  },
  {
    "Name": "Unrelenting Siege",
    "Rarity": "Legendary",
    "Type": "Support",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Ongoing. Friendly creatures with 1 power may attack an extra time each turn.",
    "Keywords": "",
    "Played in": "63/13695 of  Eligible  decks (0 %)",
    "code": "td"
  },
  {
    "Name": "Unstable Madman",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "At the end of your turn, Unstable Madman gains +1/+1. The , if he has 5 or more power, change him into Unstoppable Berskerker.",
    "Keywords": "",
    "Played in": "232/12757 of  Eligible  decks (2 %)",
    "code": "rj"
  },
  {
    "Name": "Unstoppable Rage",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "8",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 3 - Hilltop Shrine",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "A friendly creature deals damage equal to its power to all other creatures in its lane.",
    "Keywords": "",
    "Played in": "2466/12757 of  Eligible  decks (19 %)",
    "code": "rk"
  },
  {
    "Name": "Valenwood Huntsman",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Deal 1 damage.",
    "Keywords": "",
    "Played in": "235/12757 of  Eligible  decks (2 %)",
    "Evolves from:": "Valenwood Trapper",
    "code": "rl"
  },
  {
    "Name": "Valenwood Sentry",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy, Guard.",
    "Keywords": "Prophecy,Guard",
    "Played in": "85/13695 of  Eligible  decks (1 %)",
    "code": "uv"
  },
  {
    "Name": "Valkynaz Mage",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Daedra",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Ward. When Valkynaz Mage's Ward is broken, Invade.",
    "Keywords": "Ward,Invade",
    "Played in": "76/14266 of  Eligible  decks (1 %)",
    "code": "yb"
  },
  {
    "Name": "Vanus Galerion",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "intelligence",
      "willpower"
    ],
    "Race": "High Elf",
    "Magicka Cost": "11",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Expertise: Deal 3 damage, you gain 3 health and draw 3 cards.",
    "Keywords": "Expertise",
    "Played in": "112/407 of  Eligible  decks (28 %)",
    "code": "uw"
  },
  {
    "Name": "Vanus's Scribe",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "3",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Expertise: Reduce the cost of a random action in your hand by 1.",
    "Keywords": "Expertise",
    "Played in": "95/14266 of  Eligible  decks (1 %)",
    "code": "uF"
  },
  {
    "Name": "Varanis Courier",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard. Last Gasp: Draw a card.",
    "Keywords": "Guard,Last Gasp",
    "Played in": "1477/13695 of  Eligible  decks (11 %)",
    "code": "rn"
  },
  {
    "Name": "Varen Aquilarios",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Imperial",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "6",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "When one of your runes breaks, you gain 5 health instead of drawing a card.",
    "Keywords": "",
    "Played in": "467/12907 of  Eligible  decks (4 %)",
    "code": "ux"
  },
  {
    "Name": "Vastarie",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "High Elf",
    "Magicka Cost": "5",
    "Attack": "1",
    "Health": "4",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Fill this lane with 1/1 Skeletons. Vastarie has +1/+0 for each friendly Spirit and Skeleton.",
    "Keywords": "",
    "Played in": "53/14271 of  Eligible  decks (0 %)",
    "code": "wQ"
  },
  {
    "Name": "Verminous Fabricant",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Fabricant",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 5 - Collapsing Tunnel",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: If you have a [neutral] card in play, Silence another creature.",
    "Keywords": "",
    "Played in": "86/12757 of  Eligible  decks (1 %)",
    "code": "ro"
  },
  {
    "Name": "Vicious Dreugh",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dreugh",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Destroy an enemy support card.",
    "Keywords": "",
    "Played in": "1064/30861 of  Eligible  decks (3 %)",
    "Evolves from:": "Snapping Dreugh",
    "code": "rp"
  },
  {
    "Name": "Vigilant Ancestor",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Spirit",
    "Magicka Cost": "3",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Guard. Vigilant Ancestor is permanently Shackled.",
    "Keywords": "Guard",
    "Played in": "861/14266 of  Eligible  decks (6 %)",
    "code": "rq"
  },
  {
    "Name": "Vigilant Giant",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Giant",
    "Magicka Cost": "8",
    "Attack": "8",
    "Health": "8",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Breakthrough, Guard. Summon: Draw a card.",
    "Keywords": "Breakthrough,Guard",
    "Played in": "2277/12757 of  Eligible  decks (18 %)",
    "Evolves from:": "Reclusive Giant",
    "code": "rr"
  },
  {
    "Name": "Vigilant of Stendarr",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Attack": "5",
    "Health": "2",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "84/14266 of  Eligible  decks (1 %)",
    "code": "rs"
  },
  {
    "Name": "Vivec City Pilgrim",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Drain. Exalt 3: +2/+2.",
    "Keywords": "Drain,Exalt",
    "Played in": "385/12907 of  Eligible  decks (3 %)",
    "code": "ru"
  },
  {
    "Name": "Vivec",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "God",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Exalt 3: +5/+5. While you have an Exalted creature in play, you can't lose the game.",
    "Keywords": "Exalt",
    "Played in": "611/12916 of  Eligible  decks (5 %)",
    "code": "rt"
  },
  {
    "Name": "Voice of Balance",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Forgotten Hero Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: +4/+4 and Guard if you have an action, item, and support in your discard pile or in play.",
    "Keywords": "Guard",
    "Played in": "334/30861 of  Eligible  decks (1 %)",
    "code": "rv"
  },
  {
    "Name": "Volendrung",
    "Rarity": "Legendary - Unique",
    "Type": "Support",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "8",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Uses: 2. Activate: Give a creature +4/+4 and Breakthrough.",
    "Keywords": "Breakthrough",
    "Played in": "222/12759 of  Eligible  decks (2 %)",
    "code": "rw"
  },
  {
    "Name": "Voracious Spriggan",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Spriggan",
    "Magicka Cost": "1",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Drain",
    "Keywords": "Drain",
    "Played in": "450/13695 of  Eligible  decks (3 %)",
    "code": "ry"
  },
  {
    "Name": "Vvardvark Experiment",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "0",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon a 0/1 Vvardvark in each lane.",
    "Keywords": "",
    "Played in": "84/13644 of  Eligible  decks (1 %)",
    "code": "qs"
  },
  {
    "Name": "Wabbajack",
    "Rarity": "Legendary - Unique",
    "Type": "Support",
    "Attributes": [
      "neutral"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Uses: 3. Activate: Transform a creature into a random creature.",
    "Keywords": "",
    "Played in": "465/30872 of  Eligible  decks (2 %)",
    "code": "rz"
  },
  {
    "Name": "Wake the Dead",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Draw a Spirit or Skeleton creature of your choice from your deck and give it +0/+1.",
    "Keywords": "",
    "Played in": "157/13644 of  Eligible  decks (1 %)",
    "code": "lq"
  },
  {
    "Name": "Wandering Skeleton",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Skeleton",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Last Gasp: Summon a 1/1 Skeleton.",
    "Keywords": "",
    "Played in": "77/14266 of  Eligible  decks (1 %)",
    "code": "vJ"
  },
  {
    "Name": "War Cry",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Give friendly creatures in one lane +2/+0 this turn.",
    "Keywords": "",
    "Played in": "390/12907 of  Eligible  decks (3 %)",
    "code": "rA"
  },
  {
    "Name": "War-Hardened Senche",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "4",
    "Attack": "4",
    "Health": "3",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Wax: +1/+1. Wane: Battle an enemy creature.",
    "Keywords": "Wax/Wane",
    "Played in": "13/12757 of  Eligible  decks (0 %)",
    "code": "wl"
  },
  {
    "Name": "Warclaw Mercenary",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Khajiit",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Rally",
    "Keywords": "Rally",
    "Played in": "451/12907 of  Eligible  decks (3 %)",
    "code": "rB"
  },
  {
    "Name": "Wardcrafter",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Breton",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Give a creature a Ward.",
    "Keywords": "Ward",
    "Played in": "6921/14271 of  Eligible  decks (48 %)",
    "code": "rC"
  },
  {
    "Name": "Warrior's Fury",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "strength",
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Give a random creature and item in your hand +2/+2.",
    "Keywords": "",
    "Played in": "130/3890 of  Eligible  decks (3 %)",
    "code": "rD"
  },
  {
    "Name": "Watch Commander",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Imperial",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Give all friendly Guards +1/+2.",
    "Keywords": "Guard",
    "Played in": "200/13644 of  Eligible  decks (1 %)",
    "code": "rE"
  },
  {
    "Name": "Waves of the Fallen",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "8",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Transform all enemy creatures in a lane into 2/2 Stricken Draugrs, or transform all friendly creatures in a lane into 5/5 Hulking Draugrs.",
    "Keywords": "",
    "Played in": "146/13644 of  Eligible  decks (1 %)",
    "code": "rF"
  },
  {
    "Name": "Weakness",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Return to Clockwork City",
    "Unlocked in": "Episode 1 - Forelhost Lost Tomb",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Set a creature's health to 1.",
    "Keywords": "",
    "Played in": "158/13651 of  Eligible  decks (1 %)",
    "code": "rG"
  },
  {
    "Name": "Whirling Duelist",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Redguard",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When Whirling Duelist equips an item, deal 1 damage to each enemy creature in this lane.",
    "Keywords": "",
    "Played in": "274/12757 of  Eligible  decks (2 %)",
    "code": "rH"
  },
  {
    "Name": "Whispering Claw Strike",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "agility"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Prophecy. Give an enemy creature -2/-2 and a friendly creature +2/+2.",
    "Keywords": "Prophecy",
    "Played in": "19/13695 of  Eligible  decks (0 %)",
    "code": "wm"
  },
  {
    "Name": "Whiterun Protector",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Nord",
    "Magicka Cost": "5",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Beast Form: +2/+2, Guard, and Regenerate.",
    "Keywords": "",
    "Played in": "569/13644 of  Eligible  decks (4 %)",
    "code": "rI"
  },
  {
    "Name": "Whiterun Trooper",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "6",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "95/12757 of  Eligible  decks (1 %)",
    "Evolves from:": "Whiterun Recruit",
    "code": "rK"
  },
  {
    "Name": "Whodunit?",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "8",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Costs 1 less for each creature in your discard pile. Gain +2 max magicka.",
    "Keywords": "",
    "Played in": "58/13644 of  Eligible  decks (0 %)",
    "code": "xR"
  },
  {
    "Name": "Widow Daedra",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Daedra",
    "Magicka Cost": "4",
    "Attack": "5",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "When an enemy rune is destroyed, Invade.",
    "Keywords": "Invade",
    "Played in": "70/12757 of  Eligible  decks (1 %)",
    "code": "xt"
  },
  {
    "Name": "Wild Beastcaller",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Spriggan",
    "Magicka Cost": "6",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Summon a random Animal.",
    "Keywords": "",
    "Played in": "354/13695 of  Eligible  decks (3 %)",
    "Evolves from:": "Wild Spriggan",
    "code": "rL"
  },
  {
    "Name": "Wild Boar",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Beast",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Wild Boar can't gain Cover. At the start of your turn, Wild Boar moves and gains +1/+0.",
    "Keywords": "",
    "Played in": "7/13695 of  Eligible  decks (0 %)",
    "code": "yo"
  },
  {
    "Name": "Wild Clumsiness",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Betray. Shackle a random enemy creature in each lane.",
    "Keywords": "Betray",
    "Played in": "115/14266 of  Eligible  decks (1 %)",
    "code": "rM"
  },
  {
    "Name": "Wild Echatere",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength",
      "willpower",
      "endurance"
    ],
    "Race": "Beast",
    "Magicka Cost": "3",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Tamriel Collection",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Charge. Summon: Friendly creatures gain Rally this turn.",
    "Keywords": "Charge",
    "Played in": "7/806 of  Eligible  decks (1 %)",
    "code": "Bh"
  },
  {
    "Name": "Wildfire Dragon",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Dragon",
    "Magicka Cost": "7",
    "Attack": "6",
    "Health": "6",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Breakthrough. Summon: Deal 1 damage to all other creatures. Slay: +1/+1.",
    "Keywords": "Breakthrough,Slay",
    "Played in": "477/12757 of  Eligible  decks (4 %)",
    "code": "rO"
  },
  {
    "Name": "Wilds Incarnate",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Beast",
    "Magicka Cost": "7",
    "Attack": "5",
    "Health": "6",
    "Expansion Set": "FrostSpark Collection",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Guard. Summon: Draw a card if you have 4 runes. Draw an additional card if you have 5 runes.",
    "Keywords": "Guard",
    "Played in": "843/30861 of  Eligible  decks (3 %)",
    "code": "rP"
  },
  {
    "Name": "Will-o-the-Wisp",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Spirit",
    "Magicka Cost": "2",
    "Attack": "3",
    "Health": "2",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Drain.",
    "Keywords": "Drain",
    "Played in": "43/13695 of  Eligible  decks (0 %)",
    "code": "xj"
  },
  {
    "Name": "Wily Kee'va",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Beast",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "",
    "Keywords": "",
    "Played in": "193/12907 of  Eligible  decks (1 %)",
    "code": "wc"
  },
  {
    "Name": "Wind Keep Spellsword",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Breton",
    "Magicka Cost": "2",
    "Attack": "2",
    "Health": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Ward",
    "Keywords": "Ward",
    "Played in": "3865/13644 of  Eligible  decks (28 %)",
    "code": "rQ"
  },
  {
    "Name": "Windhelm Gatekeeper",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Nord",
    "Magicka Cost": "4",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard. Veteran: +3/+0.",
    "Keywords": "Guard,Veteran",
    "Played in": "53/12757 of  Eligible  decks (0 %)",
    "code": "uB"
  },
  {
    "Name": "Winter's Grasp",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Shackle all enemy creatures.",
    "Keywords": "",
    "Played in": "662/14266 of  Eligible  decks (5 %)",
    "Evolves from:": "Winter's Touch",
    "code": "rR"
  },
  {
    "Name": "Winterhold Illusionist",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Dark Elf",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Another creature disappears, then returns at the end of the turn.",
    "Keywords": "",
    "Played in": "500/12907 of  Eligible  decks (4 %)",
    "code": "rT"
  },
  {
    "Name": "Wisdom of Ancients",
    "Rarity": "Epic",
    "Type": "Action",
    "Attributes": [
      "intelligence"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Prophecy. Give all friendly creatures a random keyword.",
    "Keywords": "Prophecy",
    "Played in": "287/14266 of  Eligible  decks (2 %)",
    "code": "rU"
  },
  {
    "Name": "Wish",
    "Rarity": "Rare",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Alliance War",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon a random 2 cost creature. Empower: +1 cost creature.",
    "Keywords": "Empower",
    "Played in": "59/12916 of  Eligible  decks (0 %)",
    "code": "sP"
  },
  {
    "Name": "Wispmother",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence"
    ],
    "Race": "Spirit",
    "Magicka Cost": "7",
    "Attack": "5",
    "Health": "5",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When you summon a creature that costs 2 or less, summon a copy of that creature in the other lane.",
    "Keywords": "",
    "Played in": "484/14271 of  Eligible  decks (3 %)",
    "code": "rV"
  },
  {
    "Name": "Withered Hand Cultist",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Redguard",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "All actions cost 2 more.",
    "Keywords": "",
    "Played in": "1911/12757 of  Eligible  decks (15 %)",
    "code": "rW"
  },
  {
    "Name": "Wolf Cage",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Uses: 3. Activate: Summon an Uncaged Wolf.",
    "Keywords": "",
    "Played in": "152/12907 of  Eligible  decks (1 %)",
    "code": "rX"
  },
  {
    "Name": "Wood Orc Headhunter",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Orc",
    "Magicka Cost": "5",
    "Attack": "5",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Breakthrough. Summon: Give Wood Orc Headhunter Charge if you have another friendly Orc.",
    "Keywords": "Breakthrough,Charge",
    "Played in": "801/12757 of  Eligible  decks (6 %)",
    "code": "rY"
  },
  {
    "Name": "Woodland Lookout",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "agility"
    ],
    "Race": "Wood Elf",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "When you summon a Dragon, gain 4 health.",
    "Keywords": "",
    "Played in": "788/13695 of  Eligible  decks (6 %)",
    "code": "rZ"
  },
  {
    "Name": "Word Wall",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Defense",
    "Magicka Cost": "1",
    "Attack": "0",
    "Health": "4",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Guard. Summon: Upgrade a Shout in your hand.",
    "Keywords": "Guard",
    "Played in": "1656/30861 of  Eligible  decks (5 %)",
    "code": "sa"
  },
  {
    "Name": "World-Eater's Eyrie",
    "Rarity": "Legendary",
    "Type": "Support",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "6",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Ongoing. When you summon a creature that costs 7 or more, double its power and health.",
    "Keywords": "",
    "Played in": "209/12757 of  Eligible  decks (2 %)",
    "code": "sb"
  },
  {
    "Name": "Worldly Wanderer",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "willpower"
    ],
    "Race": "Nord",
    "Magicka Cost": "5",
    "Attack": "3",
    "Health": "5",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Summon a support of your choice from your deck with cost less than Worldly Wanderer's power.",
    "Keywords": "",
    "Played in": "74/12907 of  Eligible  decks (1 %)",
    "code": "yX"
  },
  {
    "Name": "Worm King's Agent",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "intelligence",
      "endurance"
    ],
    "Race": "Breton",
    "Magicka Cost": "7",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Summon: Deal 2 damage to an enemy creature. Slay: Summon a 2/2 Worm Thrall with Guard.",
    "Keywords": "Slay,Guard",
    "Played in": "281/4886 of  Eligible  decks (6 %)",
    "code": "sc"
  },
  {
    "Name": "Wrath of Sithis",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Spirit",
    "Magicka Cost": "6",
    "Attack": "5",
    "Health": "6",
    "Expansion Set": "The Fall of the Dark Brotherhood",
    "Unlocked in": "Wayrest - Episode 4 - Varlyn",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Summon: Your opponent's cards cost 1 more next turn.",
    "Keywords": "",
    "Played in": "426/13644 of  Eligible  decks (3 %)",
    "code": "sd"
  },
  {
    "Name": "Writ of Execution",
    "Rarity": "Common",
    "Type": "Action",
    "Attributes": [
      "willpower"
    ],
    "Race": "",
    "Magicka Cost": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Choose an enemy creature. At the start of your turn, destroy it and put a Completed Contract into your hand.",
    "Keywords": "",
    "Played in": "89/12907 of  Eligible  decks (1 %)",
    "code": "se"
  },
  {
    "Name": "Wrothgar Artisan",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Orc",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "3",
    "Expansion Set": "Core Set",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: Give a creature +1/+1.",
    "Keywords": "",
    "Played in": "334/13644 of  Eligible  decks (2 %)",
    "code": "sf"
  },
  {
    "Name": "Wrothgar Forge",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": [
      "strength"
    ],
    "Race": "",
    "Magicka Cost": "7",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "The first time you summon a creature each turn, equip it with a random item.",
    "Keywords": "",
    "Played in": "621/12757 of  Eligible  decks (5 %)",
    "code": "sg"
  },
  {
    "Name": "Wrothgar Kingpin",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Orc",
    "Magicka Cost": "2",
    "Attack": "1",
    "Health": "1",
    "Expansion Set": "Core Set",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "When you summon another Orc, Wrothgar Kingpin gains +1/+1.",
    "Keywords": "",
    "Played in": "209/13644 of  Eligible  decks (2 %)",
    "code": "sh"
  },
  {
    "Name": "Xavara Atronach",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Daedra",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Isle of Madness",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Summon: You may sacrifice another creature to give Xavara Atronach its power and health.",
    "Keywords": "",
    "Played in": "76/13644 of  Eligible  decks (1 %)",
    "code": "si"
  },
  {
    "Name": "Xivilai Warlord",
    "Rarity": "Common",
    "Type": "Creature",
    "Attributes": [
      "strength"
    ],
    "Race": "Daedra",
    "Magicka Cost": "4",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Jaws of Oblivion",
    "Soul Summon": "50",
    "Soul Trap": "5",
    "Text": "Charge, Guard",
    "Keywords": "Charge,Guard",
    "Played in": "52/12757 of  Eligible  decks (0 %)",
    "code": "xv"
  },
  {
    "Name": "Xivkyn Banelord",
    "Rarity": "Legendary",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Daedra",
    "Magicka Cost": "7",
    "Attack": "1",
    "Health": "7",
    "Expansion Set": "Alliance War",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Guard. Summon: Set the health of each enemy creature in this lane to 1.",
    "Keywords": "Guard",
    "Played in": "128/13644 of  Eligible  decks (1 %)",
    "code": "uC"
  },
  {
    "Name": "Yagrum Bagarn",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Dwemer",
    "Magicka Cost": "3",
    "Attack": "2",
    "Health": "4",
    "Expansion Set": "Houses of Morrowind",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Draw a Dwemer from your discard pile and give it +2/+2.",
    "Keywords": "",
    "Played in": "334/30861 of  Eligible  decks (1 %)",
    "code": "sj"
  },
  {
    "Name": "Yagrum's Workshop",
    "Rarity": "Epic",
    "Type": "Support",
    "Attributes": ["neutral"],
    "Race": "",
    "Magicka Cost": "3",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Uses: 3. Activate: Your Neutral Summon and Assemble abilities trigger an additional time this turn.",
    "Keywords": "Assemble",
    "code": "yM"
  },
  {
    "Name": "Yew Shield",
    "Rarity": "Rare",
    "Type": "Item",
    "Attributes": [
      "endurance"
    ],
    "Race": "",
    "Magicka Cost": "2",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Guard. Summon: +1/+1 for each enemy creature in this lane.",
    "Keywords": "Guard",
    "Played in": "248/13644 of  Eligible  decks (2 %)",
    "code": "sk"
  },
  {
    "Name": "Yokudan Nightblade",
    "Rarity": "Epic",
    "Type": "Creature",
    "Attributes": ["intelligence"],
    "Race": "Redguard",
    "Magicka Cost": "1",
    "Attack": "1",
    "Health": "4",
    "Expansion Set": "Monthly Reward",
    "Soul Summon": "400",
    "Soul Trap": "100",
    "Text": "Friendly equipped creatures are Immune to Silence.",
    "Keywords": "",
    "code": "zD"
  },
  {
    "Name": "Young Dragonborn",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "neutral"
    ],
    "Race": "Nord",
    "Magicka Cost": "3",
    "Attack": "3",
    "Health": "3",
    "Expansion Set": "Heroes of Skyrim",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "When Young Dragonborn Slays a Dragon, put a random Shout into your hand. After you play a Shout, Young Dragonborn gains +1/+1.",
    "Keywords": "",
    "Played in": "246/30861 of  Eligible  decks (1 %)",
    "code": "sl"
  },
  {
    "Name": "Young Mammoth",
    "Rarity": "Rare",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Mammoth",
    "Magicka Cost": "3",
    "Attack": "4",
    "Health": "4",
    "Expansion Set": "Core Set",
    "Soul Summon": "100",
    "Soul Trap": "20",
    "Text": "Breakthrough",
    "Keywords": "Breakthrough",
    "Played in": "3048/13644 of  Eligible  decks (22 %)",
    "code": "sm"
  },
  {
    "Name": "Zumog Phoom",
    "Rarity": "Legendary - Unique",
    "Type": "Creature",
    "Attributes": [
      "endurance"
    ],
    "Race": "Orc",
    "Magicka Cost": "6",
    "Attack": "4",
    "Health": "6",
    "Expansion Set": "Moons of Elsweyr",
    "Soul Summon": "1200",
    "Soul Trap": "400",
    "Text": "Summon: Choose another creature. When the chosen creature dies, summon it as a 1/1.",
    "Keywords": "",
    "Played in": "196/13644 of  Eligible  decks (1 %)",
    "code": "vZ"
  }
]
}